/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type BulkDeleteFacilityServiceAreas200Response,
    BulkDeleteFacilityServiceAreas200ResponseFromJSON,
    BulkDeleteFacilityServiceAreas200ResponseToJSON,
} from '../models/BulkDeleteFacilityServiceAreas200Response';
import {
    type BulkDeleteFacilityServiceAreasRequest,
    BulkDeleteFacilityServiceAreasRequestFromJSON,
    BulkDeleteFacilityServiceAreasRequestToJSON,
} from '../models/BulkDeleteFacilityServiceAreasRequest';
import {
    type BulkImportFacilityServiceAreas200Response,
    BulkImportFacilityServiceAreas200ResponseFromJSON,
    BulkImportFacilityServiceAreas200ResponseToJSON,
} from '../models/BulkImportFacilityServiceAreas200Response';
import {
    type BulkImportFacilityServiceAreasRequest,
    BulkImportFacilityServiceAreasRequestFromJSON,
    BulkImportFacilityServiceAreasRequestToJSON,
} from '../models/BulkImportFacilityServiceAreasRequest';
import {
    type BulkUpdateBedRoomsRequest,
    BulkUpdateBedRoomsRequestFromJSON,
    BulkUpdateBedRoomsRequestToJSON,
} from '../models/BulkUpdateBedRoomsRequest';
import {
    type BulkUpdateBedTypes200Response,
    BulkUpdateBedTypes200ResponseFromJSON,
    BulkUpdateBedTypes200ResponseToJSON,
} from '../models/BulkUpdateBedTypes200Response';
import {
    type BulkUpdateBedTypesRequest,
    BulkUpdateBedTypesRequestFromJSON,
    BulkUpdateBedTypesRequestToJSON,
} from '../models/BulkUpdateBedTypesRequest';
import {
    type BulkUpdateBeds200Response,
    BulkUpdateBeds200ResponseFromJSON,
    BulkUpdateBeds200ResponseToJSON,
} from '../models/BulkUpdateBeds200Response';
import {
    type BulkUpdateBedsRequest,
    BulkUpdateBedsRequestFromJSON,
    BulkUpdateBedsRequestToJSON,
} from '../models/BulkUpdateBedsRequest';
import {
    type BulkUpdateCriteriaCategoriesRequest,
    BulkUpdateCriteriaCategoriesRequestFromJSON,
    BulkUpdateCriteriaCategoriesRequestToJSON,
} from '../models/BulkUpdateCriteriaCategoriesRequest';
import {
    type BulkUpdateCriteriaRequest,
    BulkUpdateCriteriaRequestFromJSON,
    BulkUpdateCriteriaRequestToJSON,
} from '../models/BulkUpdateCriteriaRequest';
import {
    type BulkUpdateFacilityServiceAreas200Response,
    BulkUpdateFacilityServiceAreas200ResponseFromJSON,
    BulkUpdateFacilityServiceAreas200ResponseToJSON,
} from '../models/BulkUpdateFacilityServiceAreas200Response';
import {
    type BulkUpdateFacilityServiceAreasRequest,
    BulkUpdateFacilityServiceAreasRequestFromJSON,
    BulkUpdateFacilityServiceAreasRequestToJSON,
} from '../models/BulkUpdateFacilityServiceAreasRequest';
import {
    type BulkUpdateScreenerBedUnitsRequest,
    BulkUpdateScreenerBedUnitsRequestFromJSON,
    BulkUpdateScreenerBedUnitsRequestToJSON,
} from '../models/BulkUpdateScreenerBedUnitsRequest';
import {
    type BulkUpdateScreenerTagsRequest,
    BulkUpdateScreenerTagsRequestFromJSON,
    BulkUpdateScreenerTagsRequestToJSON,
} from '../models/BulkUpdateScreenerTagsRequest';
import {
    type CheckEligibility200Response,
    CheckEligibility200ResponseFromJSON,
    CheckEligibility200ResponseToJSON,
} from '../models/CheckEligibility200Response';
import {
    type CombineDocuments200Response,
    CombineDocuments200ResponseFromJSON,
    CombineDocuments200ResponseToJSON,
} from '../models/CombineDocuments200Response';
import {
    type CombineDocumentsRequest,
    CombineDocumentsRequestFromJSON,
    CombineDocumentsRequestToJSON,
} from '../models/CombineDocumentsRequest';
import {
    type CombineLeads200Response,
    CombineLeads200ResponseFromJSON,
    CombineLeads200ResponseToJSON,
} from '../models/CombineLeads200Response';
import {
    type CombineLeadsRequest,
    CombineLeadsRequestFromJSON,
    CombineLeadsRequestToJSON,
} from '../models/CombineLeadsRequest';
import {
    type CopyLead201Response,
    CopyLead201ResponseFromJSON,
    CopyLead201ResponseToJSON,
} from '../models/CopyLead201Response';
import {
    type CopyLeadRequest,
    CopyLeadRequestFromJSON,
    CopyLeadRequestToJSON,
} from '../models/CopyLeadRequest';
import {
    type CountActiveIntegrationEvents200Response,
    CountActiveIntegrationEvents200ResponseFromJSON,
    CountActiveIntegrationEvents200ResponseToJSON,
} from '../models/CountActiveIntegrationEvents200Response';
import {
    type CreateCriteria201Response,
    CreateCriteria201ResponseFromJSON,
    CreateCriteria201ResponseToJSON,
} from '../models/CreateCriteria201Response';
import {
    type CreateCriteriaCategory201Response,
    CreateCriteriaCategory201ResponseFromJSON,
    CreateCriteriaCategory201ResponseToJSON,
} from '../models/CreateCriteriaCategory201Response';
import {
    type CreateCriteriaRequest,
    CreateCriteriaRequestFromJSON,
    CreateCriteriaRequestToJSON,
} from '../models/CreateCriteriaRequest';
import {
    type CreateCriteriaTargets201Response,
    CreateCriteriaTargets201ResponseFromJSON,
    CreateCriteriaTargets201ResponseToJSON,
} from '../models/CreateCriteriaTargets201Response';
import {
    type CreateCriteriaTargetsRequest,
    CreateCriteriaTargetsRequestFromJSON,
    CreateCriteriaTargetsRequestToJSON,
} from '../models/CreateCriteriaTargetsRequest';
import {
    type CreateDocumentExclusionTerm201Response,
    CreateDocumentExclusionTerm201ResponseFromJSON,
    CreateDocumentExclusionTerm201ResponseToJSON,
} from '../models/CreateDocumentExclusionTerm201Response';
import {
    type CreateDocumentExclusionTermRequest,
    CreateDocumentExclusionTermRequestFromJSON,
    CreateDocumentExclusionTermRequestToJSON,
} from '../models/CreateDocumentExclusionTermRequest';
import {
    type CreateFacilityCustomTag201Response,
    CreateFacilityCustomTag201ResponseFromJSON,
    CreateFacilityCustomTag201ResponseToJSON,
} from '../models/CreateFacilityCustomTag201Response';
import {
    type CreateFacilityCustomTagRequest,
    CreateFacilityCustomTagRequestFromJSON,
    CreateFacilityCustomTagRequestToJSON,
} from '../models/CreateFacilityCustomTagRequest';
import {
    type CreateFacilityRegion201Response,
    CreateFacilityRegion201ResponseFromJSON,
    CreateFacilityRegion201ResponseToJSON,
} from '../models/CreateFacilityRegion201Response';
import {
    type CreateFacilityRegionRequest,
    CreateFacilityRegionRequestFromJSON,
    CreateFacilityRegionRequestToJSON,
} from '../models/CreateFacilityRegionRequest';
import {
    type CreateFacilityServiceArea201Response,
    CreateFacilityServiceArea201ResponseFromJSON,
    CreateFacilityServiceArea201ResponseToJSON,
} from '../models/CreateFacilityServiceArea201Response';
import {
    type CreateFacilityServiceAreaRequest,
    CreateFacilityServiceAreaRequestFromJSON,
    CreateFacilityServiceAreaRequestToJSON,
} from '../models/CreateFacilityServiceAreaRequest';
import {
    type CreateFacilityServiceAreaUploadUrl200Response,
    CreateFacilityServiceAreaUploadUrl200ResponseFromJSON,
    CreateFacilityServiceAreaUploadUrl200ResponseToJSON,
} from '../models/CreateFacilityServiceAreaUploadUrl200Response';
import {
    type CreateFilterView201Response,
    CreateFilterView201ResponseFromJSON,
    CreateFilterView201ResponseToJSON,
} from '../models/CreateFilterView201Response';
import {
    type CreateFilterViewRequest,
    CreateFilterViewRequestFromJSON,
    CreateFilterViewRequestToJSON,
} from '../models/CreateFilterViewRequest';
import {
    type CreateLeadAdditionalDocumentsRequest,
    CreateLeadAdditionalDocumentsRequestFromJSON,
    CreateLeadAdditionalDocumentsRequestToJSON,
} from '../models/CreateLeadAdditionalDocumentsRequest';
import {
    type CreateLeadInfo201Response,
    CreateLeadInfo201ResponseFromJSON,
    CreateLeadInfo201ResponseToJSON,
} from '../models/CreateLeadInfo201Response';
import {
    type CreateLeadInfoRequest,
    CreateLeadInfoRequestFromJSON,
    CreateLeadInfoRequestToJSON,
} from '../models/CreateLeadInfoRequest';
import {
    type CreateLeadWaitlistUpdate201Response,
    CreateLeadWaitlistUpdate201ResponseFromJSON,
    CreateLeadWaitlistUpdate201ResponseToJSON,
} from '../models/CreateLeadWaitlistUpdate201Response';
import {
    type CreateLeadsBulkRequest,
    CreateLeadsBulkRequestFromJSON,
    CreateLeadsBulkRequestToJSON,
} from '../models/CreateLeadsBulkRequest';
import {
    type CreateMatrixCarePatient201Response,
    CreateMatrixCarePatient201ResponseFromJSON,
    CreateMatrixCarePatient201ResponseToJSON,
} from '../models/CreateMatrixCarePatient201Response';
import {
    type CreateMatrixCarePatientRequest,
    CreateMatrixCarePatientRequestFromJSON,
    CreateMatrixCarePatientRequestToJSON,
} from '../models/CreateMatrixCarePatientRequest';
import {
    type CreateOrganizationIPWhitelistRequest,
    CreateOrganizationIPWhitelistRequestFromJSON,
    CreateOrganizationIPWhitelistRequestToJSON,
} from '../models/CreateOrganizationIPWhitelistRequest';
import {
    type CreateOrganizationIPWhitelistResponse,
    CreateOrganizationIPWhitelistResponseFromJSON,
    CreateOrganizationIPWhitelistResponseToJSON,
} from '../models/CreateOrganizationIPWhitelistResponse';
import {
    type CreateOrganizationState201Response,
    CreateOrganizationState201ResponseFromJSON,
    CreateOrganizationState201ResponseToJSON,
} from '../models/CreateOrganizationState201Response';
import {
    type CreateOrganizationStateTownsBulk201Response,
    CreateOrganizationStateTownsBulk201ResponseFromJSON,
    CreateOrganizationStateTownsBulk201ResponseToJSON,
} from '../models/CreateOrganizationStateTownsBulk201Response';
import {
    type CreateOrganizationStateTownsBulkRequest,
    CreateOrganizationStateTownsBulkRequestFromJSON,
    CreateOrganizationStateTownsBulkRequestToJSON,
} from '../models/CreateOrganizationStateTownsBulkRequest';
import {
    type CreateReferralRecipientConfig201Response,
    CreateReferralRecipientConfig201ResponseFromJSON,
    CreateReferralRecipientConfig201ResponseToJSON,
} from '../models/CreateReferralRecipientConfig201Response';
import {
    type CreateReferralRecipientConfigRequest,
    CreateReferralRecipientConfigRequestFromJSON,
    CreateReferralRecipientConfigRequestToJSON,
} from '../models/CreateReferralRecipientConfigRequest';
import {
    type CreateScreenerAdmissionFlag201Response,
    CreateScreenerAdmissionFlag201ResponseFromJSON,
    CreateScreenerAdmissionFlag201ResponseToJSON,
} from '../models/CreateScreenerAdmissionFlag201Response';
import {
    type CreateScreenerLeadTag201Response,
    CreateScreenerLeadTag201ResponseFromJSON,
    CreateScreenerLeadTag201ResponseToJSON,
} from '../models/CreateScreenerLeadTag201Response';
import {
    type CreateSourceTag201Response,
    CreateSourceTag201ResponseFromJSON,
    CreateSourceTag201ResponseToJSON,
} from '../models/CreateSourceTag201Response';
import {
    type CreateSourceTagRequest,
    CreateSourceTagRequestFromJSON,
    CreateSourceTagRequestToJSON,
} from '../models/CreateSourceTagRequest';
import {
    type Criteria,
    CriteriaFromJSON,
    CriteriaToJSON,
} from '../models/Criteria';
import {
    type CriteriaCategory,
    CriteriaCategoryFromJSON,
    CriteriaCategoryToJSON,
} from '../models/CriteriaCategory';
import {
    type DeleteFacilityRegion200Response,
    DeleteFacilityRegion200ResponseFromJSON,
    DeleteFacilityRegion200ResponseToJSON,
} from '../models/DeleteFacilityRegion200Response';
import {
    type DeleteOrganizationIPWhitelistResponse,
    DeleteOrganizationIPWhitelistResponseFromJSON,
    DeleteOrganizationIPWhitelistResponseToJSON,
} from '../models/DeleteOrganizationIPWhitelistResponse';
import {
    type DeleteReferralRecipientConfig200Response,
    DeleteReferralRecipientConfig200ResponseFromJSON,
    DeleteReferralRecipientConfig200ResponseToJSON,
} from '../models/DeleteReferralRecipientConfig200Response';
import {
    type EditMissingInfoFollowUpDraft200Response,
    EditMissingInfoFollowUpDraft200ResponseFromJSON,
    EditMissingInfoFollowUpDraft200ResponseToJSON,
} from '../models/EditMissingInfoFollowUpDraft200Response';
import {
    type EditMissingInfoFollowUpDraftRequest,
    EditMissingInfoFollowUpDraftRequestFromJSON,
    EditMissingInfoFollowUpDraftRequestToJSON,
} from '../models/EditMissingInfoFollowUpDraftRequest';
import {
    type ExchangeLeadRequest,
    ExchangeLeadRequestFromJSON,
    ExchangeLeadRequestToJSON,
} from '../models/ExchangeLeadRequest';
import {
    type ExchangeLeadResponse,
    ExchangeLeadResponseFromJSON,
    ExchangeLeadResponseToJSON,
} from '../models/ExchangeLeadResponse';
import {
    type ExecuteBulkUploadDocumentsRequest,
    ExecuteBulkUploadDocumentsRequestFromJSON,
    ExecuteBulkUploadDocumentsRequestToJSON,
} from '../models/ExecuteBulkUploadDocumentsRequest';
import {
    type ExecuteInstanceBulkDecision200Response,
    ExecuteInstanceBulkDecision200ResponseFromJSON,
    ExecuteInstanceBulkDecision200ResponseToJSON,
} from '../models/ExecuteInstanceBulkDecision200Response';
import {
    type FacilityServiceAreaStatus,
    FacilityServiceAreaStatusFromJSON,
    FacilityServiceAreaStatusToJSON,
} from '../models/FacilityServiceAreaStatus';
import {
    type FilterViewScope,
    FilterViewScopeFromJSON,
    FilterViewScopeToJSON,
} from '../models/FilterViewScope';
import {
    type FindAllBedRooms200Response,
    FindAllBedRooms200ResponseFromJSON,
    FindAllBedRooms200ResponseToJSON,
} from '../models/FindAllBedRooms200Response';
import {
    type FindAllBedTypes200Response,
    FindAllBedTypes200ResponseFromJSON,
    FindAllBedTypes200ResponseToJSON,
} from '../models/FindAllBedTypes200Response';
import {
    type FindAllBeds200Response,
    FindAllBeds200ResponseFromJSON,
    FindAllBeds200ResponseToJSON,
} from '../models/FindAllBeds200Response';
import {
    type FindAllCriteria200Response,
    FindAllCriteria200ResponseFromJSON,
    FindAllCriteria200ResponseToJSON,
} from '../models/FindAllCriteria200Response';
import {
    type FindAllCriteriaCategories200Response,
    FindAllCriteriaCategories200ResponseFromJSON,
    FindAllCriteriaCategories200ResponseToJSON,
} from '../models/FindAllCriteriaCategories200Response';
import {
    type FindAllCriteriaTargets200Response,
    FindAllCriteriaTargets200ResponseFromJSON,
    FindAllCriteriaTargets200ResponseToJSON,
} from '../models/FindAllCriteriaTargets200Response';
import {
    type FindAllExecutionsAvailableByFacilityId200Response,
    FindAllExecutionsAvailableByFacilityId200ResponseFromJSON,
    FindAllExecutionsAvailableByFacilityId200ResponseToJSON,
} from '../models/FindAllExecutionsAvailableByFacilityId200Response';
import {
    type FindAllFacilityCustomTags200Response,
    FindAllFacilityCustomTags200ResponseFromJSON,
    FindAllFacilityCustomTags200ResponseToJSON,
} from '../models/FindAllFacilityCustomTags200Response';
import {
    type FindAllFacilityRegions200Response,
    FindAllFacilityRegions200ResponseFromJSON,
    FindAllFacilityRegions200ResponseToJSON,
} from '../models/FindAllFacilityRegions200Response';
import {
    type FindAllFacilityServiceAreas200Response,
    FindAllFacilityServiceAreas200ResponseFromJSON,
    FindAllFacilityServiceAreas200ResponseToJSON,
} from '../models/FindAllFacilityServiceAreas200Response';
import {
    type FindAllFaxes200Response,
    FindAllFaxes200ResponseFromJSON,
    FindAllFaxes200ResponseToJSON,
} from '../models/FindAllFaxes200Response';
import {
    type FindAllFilterViews200Response,
    FindAllFilterViews200ResponseFromJSON,
    FindAllFilterViews200ResponseToJSON,
} from '../models/FindAllFilterViews200Response';
import {
    type FindAllIcd10Codes200Response,
    FindAllIcd10Codes200ResponseFromJSON,
    FindAllIcd10Codes200ResponseToJSON,
} from '../models/FindAllIcd10Codes200Response';
import {
    type FindAllIntegrationEventsByFacilityId200Response,
    FindAllIntegrationEventsByFacilityId200ResponseFromJSON,
    FindAllIntegrationEventsByFacilityId200ResponseToJSON,
} from '../models/FindAllIntegrationEventsByFacilityId200Response';
import {
    type FindAllOrganizationIPWhitelistResponse,
    FindAllOrganizationIPWhitelistResponseFromJSON,
    FindAllOrganizationIPWhitelistResponseToJSON,
} from '../models/FindAllOrganizationIPWhitelistResponse';
import {
    type FindAllOrganizationStates200Response,
    FindAllOrganizationStates200ResponseFromJSON,
    FindAllOrganizationStates200ResponseToJSON,
} from '../models/FindAllOrganizationStates200Response';
import {
    type FindAllReferralCareAttributes200Response,
    FindAllReferralCareAttributes200ResponseFromJSON,
    FindAllReferralCareAttributes200ResponseToJSON,
} from '../models/FindAllReferralCareAttributes200Response';
import {
    type FindAllReferralRecipientConfigs200Response,
    FindAllReferralRecipientConfigs200ResponseFromJSON,
    FindAllReferralRecipientConfigs200ResponseToJSON,
} from '../models/FindAllReferralRecipientConfigs200Response';
import {
    type FindAllScreenerAdmissionFlags200Response,
    FindAllScreenerAdmissionFlags200ResponseFromJSON,
    FindAllScreenerAdmissionFlags200ResponseToJSON,
} from '../models/FindAllScreenerAdmissionFlags200Response';
import {
    type FindAllScreenerAdmissionFlags200ResponseDataInner,
    FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSON,
    FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON,
} from '../models/FindAllScreenerAdmissionFlags200ResponseDataInner';
import {
    type FindAllScreenerBedUnits200Response,
    FindAllScreenerBedUnits200ResponseFromJSON,
    FindAllScreenerBedUnits200ResponseToJSON,
} from '../models/FindAllScreenerBedUnits200Response';
import {
    type FindAllScreenerLeadWaitlist200Response,
    FindAllScreenerLeadWaitlist200ResponseFromJSON,
    FindAllScreenerLeadWaitlist200ResponseToJSON,
} from '../models/FindAllScreenerLeadWaitlist200Response';
import {
    type FindAllScreenerResidents200Response,
    FindAllScreenerResidents200ResponseFromJSON,
    FindAllScreenerResidents200ResponseToJSON,
} from '../models/FindAllScreenerResidents200Response';
import {
    type FindAllScreenerTags200Response,
    FindAllScreenerTags200ResponseFromJSON,
    FindAllScreenerTags200ResponseToJSON,
} from '../models/FindAllScreenerTags200Response';
import {
    type FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSON,
} from '../models/FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner';
import {
    type FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistToJSON,
} from '../models/FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist';
import {
    type FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerToJSON,
} from '../models/FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner';
import {
    type FindAllSourceAllowNames200Response,
    FindAllSourceAllowNames200ResponseFromJSON,
    FindAllSourceAllowNames200ResponseToJSON,
} from '../models/FindAllSourceAllowNames200Response';
import {
    type FindAllSourceOptions200Response,
    FindAllSourceOptions200ResponseFromJSON,
    FindAllSourceOptions200ResponseToJSON,
} from '../models/FindAllSourceOptions200Response';
import {
    type FindAllSourceTags200Response,
    FindAllSourceTags200ResponseFromJSON,
    FindAllSourceTags200ResponseToJSON,
} from '../models/FindAllSourceTags200Response';
import {
    type FindHomeHealthPractitionerAssignments200Response,
    FindHomeHealthPractitionerAssignments200ResponseFromJSON,
    FindHomeHealthPractitionerAssignments200ResponseToJSON,
} from '../models/FindHomeHealthPractitionerAssignments200Response';
import {
    type FindInstanceBulkDecisionCandidates200Response,
    FindInstanceBulkDecisionCandidates200ResponseFromJSON,
    FindInstanceBulkDecisionCandidates200ResponseToJSON,
} from '../models/FindInstanceBulkDecisionCandidates200Response';
import {
    type FindOneBed200Response,
    FindOneBed200ResponseFromJSON,
    FindOneBed200ResponseToJSON,
} from '../models/FindOneBed200Response';
import {
    type FindOneMatrixCarePatientDetails200Response,
    FindOneMatrixCarePatientDetails200ResponseFromJSON,
    FindOneMatrixCarePatientDetails200ResponseToJSON,
} from '../models/FindOneMatrixCarePatientDetails200Response';
import {
    type GetAllowedRecipients200Response,
    GetAllowedRecipients200ResponseFromJSON,
    GetAllowedRecipients200ResponseToJSON,
} from '../models/GetAllowedRecipients200Response';
import {
    type GetAnalysisResultHistory200Response,
    GetAnalysisResultHistory200ResponseFromJSON,
    GetAnalysisResultHistory200ResponseToJSON,
} from '../models/GetAnalysisResultHistory200Response';
import {
    type GetDocumentExclusionTerms200Response,
    GetDocumentExclusionTerms200ResponseFromJSON,
    GetDocumentExclusionTerms200ResponseToJSON,
} from '../models/GetDocumentExclusionTerms200Response';
import {
    type GetFacilityBedOccupancyStats200Response,
    GetFacilityBedOccupancyStats200ResponseFromJSON,
    GetFacilityBedOccupancyStats200ResponseToJSON,
} from '../models/GetFacilityBedOccupancyStats200Response';
import {
    type GetFacilityInvoiceStatuses200Response,
    GetFacilityInvoiceStatuses200ResponseFromJSON,
    GetFacilityInvoiceStatuses200ResponseToJSON,
} from '../models/GetFacilityInvoiceStatuses200Response';
import {
    type GetFacilityScreenerSettings200Response,
    GetFacilityScreenerSettings200ResponseFromJSON,
    GetFacilityScreenerSettings200ResponseToJSON,
} from '../models/GetFacilityScreenerSettings200Response';
import {
    type GetLeadDiagnoses200Response,
    GetLeadDiagnoses200ResponseFromJSON,
    GetLeadDiagnoses200ResponseToJSON,
} from '../models/GetLeadDiagnoses200Response';
import {
    type GetLeadExchangeDestinationsResponse,
    GetLeadExchangeDestinationsResponseFromJSON,
    GetLeadExchangeDestinationsResponseToJSON,
} from '../models/GetLeadExchangeDestinationsResponse';
import {
    type GetLeadShadowDecision200Response,
    GetLeadShadowDecision200ResponseFromJSON,
    GetLeadShadowDecision200ResponseToJSON,
} from '../models/GetLeadShadowDecision200Response';
import {
    type GetLeadStageCounts200Response,
    GetLeadStageCounts200ResponseFromJSON,
    GetLeadStageCounts200ResponseToJSON,
} from '../models/GetLeadStageCounts200Response';
import {
    type GetOneFacilitySetting200Response,
    GetOneFacilitySetting200ResponseFromJSON,
    GetOneFacilitySetting200ResponseToJSON,
} from '../models/GetOneFacilitySetting200Response';
import {
    type GetScreenerSetting200Response,
    GetScreenerSetting200ResponseFromJSON,
    GetScreenerSetting200ResponseToJSON,
} from '../models/GetScreenerSetting200Response';
import {
    type GetSourceMergePreview200Response,
    GetSourceMergePreview200ResponseFromJSON,
    GetSourceMergePreview200ResponseToJSON,
} from '../models/GetSourceMergePreview200Response';
import {
    type GetUnreadFaxCount200Response,
    GetUnreadFaxCount200ResponseFromJSON,
    GetUnreadFaxCount200ResponseToJSON,
} from '../models/GetUnreadFaxCount200Response';
import {
    type InstanceBulkDecisionRequest,
    InstanceBulkDecisionRequestFromJSON,
    InstanceBulkDecisionRequestToJSON,
} from '../models/InstanceBulkDecisionRequest';
import {
    type InstanceBulkLostRequest,
    InstanceBulkLostRequestFromJSON,
    InstanceBulkLostRequestToJSON,
} from '../models/InstanceBulkLostRequest';
import {
    type LinkFaxToReferralRequest,
    LinkFaxToReferralRequestFromJSON,
    LinkFaxToReferralRequestToJSON,
} from '../models/LinkFaxToReferralRequest';
import {
    type ListMissingInfoFollowUps200Response,
    ListMissingInfoFollowUps200ResponseFromJSON,
    ListMissingInfoFollowUps200ResponseToJSON,
} from '../models/ListMissingInfoFollowUps200Response';
import {
    type MatrixCarePatientDetails,
    MatrixCarePatientDetailsFromJSON,
    MatrixCarePatientDetailsToJSON,
} from '../models/MatrixCarePatientDetails';
import {
    type MergeSources200Response,
    MergeSources200ResponseFromJSON,
    MergeSources200ResponseToJSON,
} from '../models/MergeSources200Response';
import {
    type MergeSources409Response,
    MergeSources409ResponseFromJSON,
    MergeSources409ResponseToJSON,
} from '../models/MergeSources409Response';
import {
    type MergeSourcesRequest,
    MergeSourcesRequestFromJSON,
    MergeSourcesRequestToJSON,
} from '../models/MergeSourcesRequest';
import {
    type OrganizationState,
    OrganizationStateFromJSON,
    OrganizationStateToJSON,
} from '../models/OrganizationState';
import {
    type OrganizationStateTownSwitchTypeRequest,
    OrganizationStateTownSwitchTypeRequestFromJSON,
    OrganizationStateTownSwitchTypeRequestToJSON,
} from '../models/OrganizationStateTownSwitchTypeRequest';
import {
    type OrganizationStateType,
    OrganizationStateTypeFromJSON,
    OrganizationStateTypeToJSON,
} from '../models/OrganizationStateType';
import {
    type OverrideAnalysisResult200Response,
    OverrideAnalysisResult200ResponseFromJSON,
    OverrideAnalysisResult200ResponseToJSON,
} from '../models/OverrideAnalysisResult200Response';
import {
    type OverrideAnalysisResultRequest,
    OverrideAnalysisResultRequestFromJSON,
    OverrideAnalysisResultRequestToJSON,
} from '../models/OverrideAnalysisResultRequest';
import {
    type PccE2eFixtureResetRequest,
    PccE2eFixtureResetRequestFromJSON,
    PccE2eFixtureResetRequestToJSON,
} from '../models/PccE2eFixtureResetRequest';
import {
    type PdfDownloader200Response,
    PdfDownloader200ResponseFromJSON,
    PdfDownloader200ResponseToJSON,
} from '../models/PdfDownloader200Response';
import {
    type ProcessIntegrationEvent500Response,
    ProcessIntegrationEvent500ResponseFromJSON,
    ProcessIntegrationEvent500ResponseToJSON,
} from '../models/ProcessIntegrationEvent500Response';
import {
    type RelocateScreenerResident200Response,
    RelocateScreenerResident200ResponseFromJSON,
    RelocateScreenerResident200ResponseToJSON,
} from '../models/RelocateScreenerResident200Response';
import {
    type RelocateScreenerResidentRequest,
    RelocateScreenerResidentRequestFromJSON,
    RelocateScreenerResidentRequestToJSON,
} from '../models/RelocateScreenerResidentRequest';
import {
    type ReplaceHomeHealthPractitionerAssignmentsRequest,
    ReplaceHomeHealthPractitionerAssignmentsRequestFromJSON,
    ReplaceHomeHealthPractitionerAssignmentsRequestToJSON,
} from '../models/ReplaceHomeHealthPractitionerAssignmentsRequest';
import {
    type ResetPccE2eFixture200Response,
    ResetPccE2eFixture200ResponseFromJSON,
    ResetPccE2eFixture200ResponseToJSON,
} from '../models/ResetPccE2eFixture200Response';
import {
    type ResetPccPushStatus200Response,
    ResetPccPushStatus200ResponseFromJSON,
    ResetPccPushStatus200ResponseToJSON,
} from '../models/ResetPccPushStatus200Response';
import {
    type ResolveIntegrationEventRequest,
    ResolveIntegrationEventRequestFromJSON,
    ResolveIntegrationEventRequestToJSON,
} from '../models/ResolveIntegrationEventRequest';
import {
    type ResolveIntegrationEventResponse,
    ResolveIntegrationEventResponseFromJSON,
    ResolveIntegrationEventResponseToJSON,
} from '../models/ResolveIntegrationEventResponse';
import {
    type ScheduledOccupancyType,
    ScheduledOccupancyTypeFromJSON,
    ScheduledOccupancyTypeToJSON,
} from '../models/ScheduledOccupancyType';
import {
    type SearchProviderDirectory200Response,
    SearchProviderDirectory200ResponseFromJSON,
    SearchProviderDirectory200ResponseToJSON,
} from '../models/SearchProviderDirectory200Response';
import {
    type SendLeadReferral201Response,
    SendLeadReferral201ResponseFromJSON,
    SendLeadReferral201ResponseToJSON,
} from '../models/SendLeadReferral201Response';
import {
    type SendLeadReferralRequest,
    SendLeadReferralRequestFromJSON,
    SendLeadReferralRequestToJSON,
} from '../models/SendLeadReferralRequest';
import {
    type SwapScreenerLeadResidents200Response,
    SwapScreenerLeadResidents200ResponseFromJSON,
    SwapScreenerLeadResidents200ResponseToJSON,
} from '../models/SwapScreenerLeadResidents200Response';
import {
    type SwapScreenerLeadResidentsRequest,
    SwapScreenerLeadResidentsRequestFromJSON,
    SwapScreenerLeadResidentsRequestToJSON,
} from '../models/SwapScreenerLeadResidentsRequest';
import {
    type UpdateBedNoteRequest,
    UpdateBedNoteRequestFromJSON,
    UpdateBedNoteRequestToJSON,
} from '../models/UpdateBedNoteRequest';
import {
    type UpdateDocumentExclusionTermRequest,
    UpdateDocumentExclusionTermRequestFromJSON,
    UpdateDocumentExclusionTermRequestToJSON,
} from '../models/UpdateDocumentExclusionTermRequest';
import {
    type UpdateFacilityCustomTagRequest,
    UpdateFacilityCustomTagRequestFromJSON,
    UpdateFacilityCustomTagRequestToJSON,
} from '../models/UpdateFacilityCustomTagRequest';
import {
    type UpdateFacilityRegionRequest,
    UpdateFacilityRegionRequestFromJSON,
    UpdateFacilityRegionRequestToJSON,
} from '../models/UpdateFacilityRegionRequest';
import {
    type UpdateFacilityServiceAreaRequest,
    UpdateFacilityServiceAreaRequestFromJSON,
    UpdateFacilityServiceAreaRequestToJSON,
} from '../models/UpdateFacilityServiceAreaRequest';
import {
    type UpdateFaxReadStatusRequest,
    UpdateFaxReadStatusRequestFromJSON,
    UpdateFaxReadStatusRequestToJSON,
} from '../models/UpdateFaxReadStatusRequest';
import {
    type UpdateFilterViewRequest,
    UpdateFilterViewRequestFromJSON,
    UpdateFilterViewRequestToJSON,
} from '../models/UpdateFilterViewRequest';
import {
    type UpdateLeadCareAttributes200Response,
    UpdateLeadCareAttributes200ResponseFromJSON,
    UpdateLeadCareAttributes200ResponseToJSON,
} from '../models/UpdateLeadCareAttributes200Response';
import {
    type UpdateLeadCareAttributesRequest,
    UpdateLeadCareAttributesRequestFromJSON,
    UpdateLeadCareAttributesRequestToJSON,
} from '../models/UpdateLeadCareAttributesRequest';
import {
    type UpdateLeadWaitlistRankRequest,
    UpdateLeadWaitlistRankRequestFromJSON,
    UpdateLeadWaitlistRankRequestToJSON,
} from '../models/UpdateLeadWaitlistRankRequest';
import {
    type UpdateLeadWaitlistStatus200Response,
    UpdateLeadWaitlistStatus200ResponseFromJSON,
    UpdateLeadWaitlistStatus200ResponseToJSON,
} from '../models/UpdateLeadWaitlistStatus200Response';
import {
    type UpdateLeadWaitlistStatusRequest,
    UpdateLeadWaitlistStatusRequestFromJSON,
    UpdateLeadWaitlistStatusRequestToJSON,
} from '../models/UpdateLeadWaitlistStatusRequest';
import {
    type UpdateReferralRecipientConfigRequest,
    UpdateReferralRecipientConfigRequestFromJSON,
    UpdateReferralRecipientConfigRequestToJSON,
} from '../models/UpdateReferralRecipientConfigRequest';
import {
    type UpdateReferralStatusRequest,
    UpdateReferralStatusRequestFromJSON,
    UpdateReferralStatusRequestToJSON,
} from '../models/UpdateReferralStatusRequest';
import {
    type UpdateScreenerBedUnitRankRequest,
    UpdateScreenerBedUnitRankRequestFromJSON,
    UpdateScreenerBedUnitRankRequestToJSON,
} from '../models/UpdateScreenerBedUnitRankRequest';
import {
    type UpdateScreenerLeadAdmissionFlag200Response,
    UpdateScreenerLeadAdmissionFlag200ResponseFromJSON,
    UpdateScreenerLeadAdmissionFlag200ResponseToJSON,
} from '../models/UpdateScreenerLeadAdmissionFlag200Response';
import {
    type UpdateScreenerLeadAdmissionFlagRequest,
    UpdateScreenerLeadAdmissionFlagRequestFromJSON,
    UpdateScreenerLeadAdmissionFlagRequestToJSON,
} from '../models/UpdateScreenerLeadAdmissionFlagRequest';
import {
    type UpdateScreenerSettingRequest,
    UpdateScreenerSettingRequestFromJSON,
    UpdateScreenerSettingRequestToJSON,
} from '../models/UpdateScreenerSettingRequest';

export interface BulkDeleteFacilityServiceAreasOperationRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    bulkDeleteFacilityServiceAreasRequest: BulkDeleteFacilityServiceAreasRequest;
}

export interface BulkImportFacilityServiceAreasOperationRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    bulkImportFacilityServiceAreasRequest: BulkImportFacilityServiceAreasRequest;
}

export interface BulkUpdateBedRoomsOperationRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    unitId: string;
    /**
     * 
     */
    bulkUpdateBedRoomsRequest: BulkUpdateBedRoomsRequest;
}

export interface BulkUpdateBedTypesOperationRequest {
    /**
     * The ID of the facility
     */
    facilityId: string;
    /**
     * 
     */
    bulkUpdateBedTypesRequest: BulkUpdateBedTypesRequest;
}

export interface BulkUpdateBedsOperationRequest {
    /**
     * The ID of the room
     */
    roomId: string;
    /**
     * The ID of the facility
     */
    facilityId: string;
    /**
     * 
     */
    bulkUpdateBedsRequest: BulkUpdateBedsRequest;
}

export interface BulkUpdateCriteriaOperationRequest {
    /**
     * 
     */
    criteriaId: string;
    /**
     * 
     */
    bulkUpdateCriteriaRequest: BulkUpdateCriteriaRequest;
}

export interface BulkUpdateFacilityServiceAreasOperationRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    bulkUpdateFacilityServiceAreasRequest: BulkUpdateFacilityServiceAreasRequest;
}

export interface BulkUpdateScreenerBedUnitsOperationRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    bulkUpdateScreenerBedUnitsRequest: BulkUpdateScreenerBedUnitsRequest;
}

export interface BulkUpdateScreenerTagsOperationRequest {
    /**
     * 
     */
    bulkUpdateScreenerTagsRequest: BulkUpdateScreenerTagsRequest;
}

export interface CheckEligibilityRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * The eligibility action to check
     */
    action: CheckEligibilityActionEnum;
    /**
     * The proposed new date (required for update-move-in-date, update-hospitalized-date, and update-loa-date actions)
     */
    date?: Date;
}

export interface CombineDocumentsOperationRequest {
    /**
     * 
     */
    combineDocumentsRequest: CombineDocumentsRequest;
}

export interface CombineLeadsOperationRequest {
    /**
     * 
     */
    combineLeadsRequest: CombineLeadsRequest;
}

export interface CopyLeadOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    copyLeadRequest: CopyLeadRequest;
}

export interface CountActiveIntegrationEventsRequest {
    /**
     * 
     */
    facilityId: string;
}

export interface CreateCriteriaOperationRequest {
    /**
     * 
     */
    createCriteriaRequest: CreateCriteriaRequest;
}

export interface CreateCriteriaCategoryRequest {
    /**
     * 
     */
    criteriaCategory: CriteriaCategory;
}

export interface CreateCriteriaTargetsOperationRequest {
    /**
     * 
     */
    createCriteriaTargetsRequest: CreateCriteriaTargetsRequest;
}

export interface CreateDocumentExclusionTermOperationRequest {
    /**
     * 
     */
    createDocumentExclusionTermRequest: CreateDocumentExclusionTermRequest;
}

export interface CreateFacilityCustomTagOperationRequest {
    /**
     * 
     */
    createFacilityCustomTagRequest: CreateFacilityCustomTagRequest;
}

export interface CreateFacilityRegionOperationRequest {
    /**
     * 
     */
    createFacilityRegionRequest: CreateFacilityRegionRequest;
}

export interface CreateFacilityServiceAreaOperationRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    createFacilityServiceAreaRequest: CreateFacilityServiceAreaRequest;
}

export interface CreateFacilityServiceAreaUploadUrlRequest {
    /**
     * 
     */
    facilityId: string;
}

export interface CreateFaxReferralRequest {
    /**
     * 
     */
    id: string;
}

export interface CreateFilterViewOperationRequest {
    /**
     * 
     */
    createFilterViewRequest: CreateFilterViewRequest;
}

export interface CreateLeadAdditionalDocumentsOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    createLeadAdditionalDocumentsRequest: CreateLeadAdditionalDocumentsRequest;
}

export interface CreateLeadInfoOperationRequest {
    /**
     * 
     */
    createLeadInfoRequest: CreateLeadInfoRequest;
}

export interface CreateLeadWaitlistRequest {
    /**
     * 
     */
    leadId: string;
}

export interface CreateLeadWaitlistUpdateRequest {
    /**
     * 
     */
    waitlistId: string;
    /**
     * 
     */
    findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner;
}

export interface CreateLeadsBulkOperationRequest {
    /**
     * 
     */
    createLeadsBulkRequest: CreateLeadsBulkRequest;
}

export interface CreateMatrixCarePatientOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    createMatrixCarePatientRequest: CreateMatrixCarePatientRequest;
}

export interface CreateMatrixCarePatientDetailsRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    matrixCarePatientDetails: MatrixCarePatientDetails;
}

export interface CreateOrganizationIPWhitelistOperationRequest {
    /**
     * 
     */
    createOrganizationIPWhitelistRequest: CreateOrganizationIPWhitelistRequest;
}

export interface CreateOrganizationStateRequest {
    /**
     * 
     */
    organizationState: OrganizationState;
}

export interface CreateOrganizationStateTownsBulkOperationRequest {
    /**
     * 
     */
    createOrganizationStateTownsBulkRequest: CreateOrganizationStateTownsBulkRequest;
}

export interface CreateReferralRecipientConfigOperationRequest {
    /**
     * 
     */
    createReferralRecipientConfigRequest: CreateReferralRecipientConfigRequest;
}

export interface CreateScreenerAdmissionFlagRequest {
    /**
     * 
     */
    findAllScreenerAdmissionFlags200ResponseDataInner: FindAllScreenerAdmissionFlags200ResponseDataInner;
}

export interface CreateScreenerLeadTagRequest {
    /**
     * 
     */
    findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner;
}

export interface CreateSourceTagOperationRequest {
    /**
     * 
     */
    createSourceTagRequest: CreateSourceTagRequest;
}

export interface DeleteAdditionalDocumentForLeadRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    documentId: string;
}

export interface DeleteCriteriaRequest {
    /**
     * 
     */
    criteriaId: string;
}

export interface DeleteCriteriaCategoryRequest {
    /**
     * 
     */
    categoryId: string;
}

export interface DeleteCriteriaTargetsRequest {
    /**
     * 
     */
    criteriaId: string;
}

export interface DeleteDocumentExclusionTermRequest {
    /**
     * 
     */
    termId: string;
}

export interface DeleteFacilityCustomTagRequest {
    /**
     * 
     */
    id: string;
}

export interface DeleteFacilityRegionRequest {
    /**
     * 
     */
    id: string;
}

export interface DeleteFacilityServiceAreaRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    id: string;
}

export interface DeleteFilterViewByIdRequest {
    /**
     * 
     */
    id: string;
}

export interface DeleteOrganizationIPWhitelistRequest {
    /**
     * The IP address to remove from whitelist
     */
    ipAddress: string;
}

export interface DeleteOrganizationStateByIdRequest {
    /**
     * 
     */
    id: string;
}

export interface DeleteOrganizationStateTownByIdRequest {
    /**
     * 
     */
    id: string;
}

export interface DeleteReferralRecipientConfigRequest {
    /**
     * 
     */
    id: number;
}

export interface DeleteScreenerAdmissionFlagByIdRequest {
    /**
     * 
     */
    id: string;
}

export interface DeleteScreenerLeadTagRequest {
    /**
     * 
     */
    id: string;
}

export interface DeleteScreenerTagByIdRequest {
    /**
     * 
     */
    id: string;
}

export interface EditMissingInfoFollowUpDraftOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    editMissingInfoFollowUpDraftRequest: EditMissingInfoFollowUpDraftRequest;
}

export interface ExchangeLeadOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    exchangeLeadRequest: ExchangeLeadRequest;
}

export interface ExecuteBulkUploadDocumentsOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    executeBulkUploadDocumentsRequest: ExecuteBulkUploadDocumentsRequest;
}

export interface ExecuteInstanceBulkDecisionRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    instanceBulkDecisionRequest: InstanceBulkDecisionRequest;
}

export interface ExecuteInstanceBulkLostRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    instanceBulkLostRequest: InstanceBulkLostRequest;
}

export interface FindAllBedRoomsRequest {
    /**
     * 
     */
    unitId: string;
}

export interface FindAllBedTypesRequest {
    /**
     * The ID of the facility
     */
    facilityId: string;
}

export interface FindAllBedsRequest {
    /**
     * The ID of the facility
     */
    facilityId: string;
    /**
     * List of bed type IDs to filter by
     */
    bedTypeIds?: string;
    /**
     * Include occupied beds in the response
     */
    includeOccupied?: boolean;
    /**
     * Filter beds by availability from date
     */
    availabilityFrom?: string;
    /**
     * Filter beds by availability to date
     */
    availabilityTo?: string;
    /**
     * Filter beds by room ID
     */
    roomId?: string;
}

export interface FindAllCriteriaRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    isInformational: boolean;
}

export interface FindAllCriteriaCategoriesRequest {
    /**
     * 
     */
    facilityId?: string;
}

export interface FindAllCriteriaTargetsRequest {
    /**
     * Case-insensitive whitespace-split search over the criteria name
     */
    search?: string;
    /**
     * Filters criteria to the Rule / Med Rule / Data Pull grouping shown in the UI toggle
     */
    criteriaType?: FindAllCriteriaTargetsCriteriaTypeEnum;
    /**
     * Comma-separated list of criteria category ids to filter by (matches any)
     */
    categoryId?: string;
    /**
     * Comma-separated list of criteria qualifiers (e.g. "Deal Breaker,Warning") to filter by (matches any)
     */
    qualifier?: string;
    /**
     * Restrict to criteria that would be evaluated for a lead from this facility
     */
    appliesToFacilityId?: string;
}

export interface FindAllExecutionsAvailableByFacilityIdRequest {
    /**
     * 
     */
    facilityIds: string;
}

export interface FindAllFacilityServiceAreasRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    limit?: number;
    /**
     * Case-insensitive substring match on zip or city.
     */
    search?: string;
    /**
     * 
     */
    status?: FacilityServiceAreaStatus;
}

export interface FindAllFaxesRequest {
    /**
     * Specific facility to fetch faxes for. Takes precedence over facility_type when both are provided so an explicit facility request is not hidden by stale care-setting intent.
     */
    facilityId?: string;
    /**
     * Facility type to filter accessible facilities by when facility_id is omitted. Must be a valid FacilityType enum value when provided. Ignored when facility_id is provided because facility_id is the more explicit scope.
     */
    facilityType?: FindAllFaxesFacilityTypeEnum;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    page?: number;
}

export interface FindAllFilterViewsRequest {
    /**
     * 
     */
    scope: FilterViewScope;
    /**
     * 
     */
    viewKey: string;
}

export interface FindAllIcd10CodesRequest {
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    page?: number;
}

export interface FindAllIntegrationEventsByFacilityIdRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    filter?: FindAllIntegrationEventsByFacilityIdFilterEnum;
    /**
     * 
     */
    search?: string;
}

export interface FindAllOrganizationStatesRequest {
    /**
     * Type of organization state
     */
    type: OrganizationStateType;
}

export interface FindAllReferralCareAttributesRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * When omitted, returns values for every category applicable to the facility's type.
     */
    category?: FindAllReferralCareAttributesCategoryEnum;
}

export interface FindAllReferralRecipientConfigsRequest {
    /**
     * Restrict to one sender facility. Omit to return configs for all facilities the caller can access.
     */
    senderFacilityId?: number;
}

export interface FindAllScheduledScreenerResidentsRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * The type of scheduled occupancy to retrieve
     */
    scheduledOccupancyType: ScheduledOccupancyType;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    page?: number;
    /**
     * Optional start date for the date range filter
     */
    startDate?: Date;
    /**
     * Optional end date for the date range filter
     */
    endDate?: Date;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    sourceId?: string;
    /**
     * 
     */
    connector?: string;
    /**
     * 
     */
    bedTypeId?: string;
    /**
     * 
     */
    includeCancelled?: boolean;
}

export interface FindAllScreenerBedUnitsRequest {
    /**
     * 
     */
    facilityId: string;
}

export interface FindAllScreenerLeadWaitlistRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    status?: string;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    sourceId?: string;
    /**
     * 
     */
    admissionStatus?: string;
    /**
     * 
     */
    statusId?: string;
    /**
     * 
     */
    includeEmptyAdmission?: boolean;
}

export interface FindAllScreenerResidentsRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    sourceId?: string;
    /**
     * 
     */
    bedTypeId?: string;
    /**
     * 
     */
    onlyTodayActivity?: boolean;
    /**
     * 
     */
    stayType?: string;
    /**
     * 
     */
    payerType?: string;
    /**
     * 
     * @deprecated
     */
    payer?: string;
    /**
     * 
     */
    payerSource?: string;
    /**
     * 
     */
    includeNullPayerType?: boolean;
    /**
     * 
     */
    includeNullPayerSource?: boolean;
    /**
     * 
     */
    admissionStatus?: string;
    /**
     * Comma-separated referral care attribute IDs in the clinical_care_need category. Filter to leads with at least one of them applied. Include the value `none` to also match leads with no clinical_care_need applied.
     */
    clinicalCareNeeds?: string;
    /**
     * Comma-separated referral care attribute IDs in the program category. Filter to leads with at least one of them applied. Include the value `none` to also match leads with no program applied.
     */
    programs?: string;
    /**
     * Comma-separated referral care attribute IDs in the type_of_care category. Filter to leads with at least one of them applied. Include the value `none` to also match leads with no type_of_care applied.
     */
    typesOfCare?: string;
    /**
     * Comma-separated screener tag IDs. Filter to residents with at least one of them applied. Include the value `none` to also match residents with no tag applied.
     */
    tags?: string;
}

export interface FindAllScreenerTagsRequest {
    /**
     * 
     */
    facilityId: string;
}

export interface FindAllSourceAllowNamesRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    search?: string;
}

export interface FindBulkUploadDocumentCandidatesRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindHomeHealthPractitionerAssignmentsRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindInstanceBulkDecisionCandidatesRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindInstanceBulkLostCandidatesRequest {
    /**
     * 
     */
    leadId: string;
}

export interface FindOneBedRequest {
    /**
     * The ID of the bed to retrieve
     */
    bedId: string;
}

export interface FindOneMatrixCarePatientDetailsRequest {
    /**
     * 
     */
    leadId: string;
}

export interface GetAllowedRecipientsRequest {
    /**
     * The sender SNF facility ID
     */
    senderFacilityId: number;
    /**
     * Filter recipients to those valid for this referral type. Omit to return all.
     */
    referralType?: GetAllowedRecipientsReferralTypeEnum;
}

export interface GetAnalysisResultHistoryRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    resultId: string;
}

export interface GetDocumentExclusionTermsRequest {
    /**
     * The ID of the facility
     */
    facilityId: string;
}

export interface GetFacilityBedOccupancyStatsRequest {
    /**
     * 
     */
    facilityId: string;
}

export interface GetFacilityInvoiceStatusesRequest {
    /**
     * 
     */
    facilityId: string;
}

export interface GetFacilityScreenerSettingsRequest {
    /**
     * Comma-separated list of facility IDs.
     */
    facilityIds: string;
}

export interface GetLeadDiagnosesRequest {
    /**
     * Lead ID
     */
    leadId: string;
}

export interface GetLeadExchangeDestinationsRequest {
    /**
     * 
     */
    facilityId: string;
}

export interface GetLeadShadowDecisionRequest {
    /**
     * ID of the lead
     */
    leadId: string;
}

export interface GetLeadStageCountsRequest {
    /**
     * 
     */
    facilityId?: string;
    /**
     * 
     */
    sourceId?: string;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    suggestion?: string;
    /**
     * 
     */
    connector?: string;
    /**
     * 
     */
    payerType?: string;
    /**
     * 
     * @deprecated
     */
    payer?: string;
    /**
     * 
     */
    payerSource?: string;
    /**
     * 
     */
    includeNullPayerType?: boolean;
    /**
     * 
     */
    includeNullPayerSource?: boolean;
    /**
     * 
     */
    pccStatus?: string;
    /**
     * 
     */
    matrixCareStatus?: string;
    /**
     * 
     */
    hasNewHospitalMessages?: boolean;
    /**
     * 
     */
    hasNewDocuments?: boolean;
    /**
     * Comma-separated user IDs. Filter to leads with at least one active assignment for any of these users.
     */
    assigneeUserIds?: string;
    /**
     * When true, filter to leads with no active assignments.
     */
    unassigned?: boolean;
    /**
     * Comma-separated referral care attribute IDs in the clinical_care_need category. Filter to leads with at least one of them applied. Include the value `none` to also match leads with no clinical_care_need applied.
     */
    clinicalCareNeeds?: string;
    /**
     * Comma-separated referral care attribute IDs in the program category. Filter to leads with at least one of them applied. Include the value `none` to also match leads with no program applied.
     */
    programs?: string;
    /**
     * Comma-separated referral care attribute IDs in the type_of_care category. Filter to leads with at least one of them applied. Include the value `none` to also match leads with no type_of_care applied.
     */
    typesOfCare?: string;
}

export interface GetOneFacilitySettingRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    settingName: string;
}

export interface GetScreenerSettingRequest {
    /**
     * 
     */
    settingName: string;
}

export interface GetSourceMergePreviewRequest {
    /**
     * The ID of the source that would be merged away
     */
    sourceId: string;
    /**
     * The ID of the source that would survive the merge. When omitted only source_to_merge is returned.
     */
    sourceToKeepId?: string;
}

export interface GetUnreadFaxCountRequest {
    /**
     * Specific facility to count unread faxes for. Takes precedence over facility_type when both are provided so an explicit facility request is not hidden by stale care-setting intent.
     */
    facilityId?: string;
    /**
     * Facility type to filter accessible facilities by when facility_id is omitted. Must be a valid FacilityType enum value when provided. Ignored when facility_id is provided because facility_id is the more explicit scope.
     */
    facilityType?: GetUnreadFaxCountFacilityTypeEnum;
}

export interface LinkFaxToReferralOperationRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    linkFaxToReferralRequest: LinkFaxToReferralRequest;
}

export interface ListMissingInfoFollowUpsRequest {
    /**
     * 
     */
    leadId: string;
}

export interface MergeSourcesOperationRequest {
    /**
     * The ID of the source being merged away
     */
    sourceId: string;
    /**
     * 
     */
    mergeSourcesRequest: MergeSourcesRequest;
}

export interface OverrideAnalysisResultOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    resultId: string;
    /**
     * 
     */
    overrideAnalysisResultRequest: OverrideAnalysisResultRequest;
}

export interface PdfDownloaderRequest {
    /**
     * 
     */
    documentIds: string;
    /**
     * 
     */
    leadId: string;
}

export interface ProcessIntegrationEventRequest {
    /**
     * 
     */
    integrationEventId: string;
    /**
     * 
     */
    action: ProcessIntegrationEventActionEnum;
    /**
     * 
     */
    confirmation?: ProcessIntegrationEventConfirmationEnum;
}

export interface RelocateScreenerResidentOperationRequest {
    /**
     * 
     */
    residentId: string;
    /**
     * 
     */
    relocateScreenerResidentRequest: RelocateScreenerResidentRequest;
}

export interface ReplaceHomeHealthPractitionerAssignmentsOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    practitionerId: string;
    /**
     * 
     */
    replaceHomeHealthPractitionerAssignmentsRequest: ReplaceHomeHealthPractitionerAssignmentsRequest;
}

export interface ResetPccE2eFixtureRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    pccE2eFixtureResetRequest: PccE2eFixtureResetRequest;
}

export interface ResetPccPushStatusRequest {
    /**
     * 
     */
    leadId: string;
}

export interface ResolveIntegrationEventOperationRequest {
    /**
     * 
     */
    integrationEventId: string;
    /**
     * 
     */
    resolveIntegrationEventRequest: ResolveIntegrationEventRequest;
}

export interface RevertAnalysisResultRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    resultId: string;
}

export interface SearchProviderDirectoryRequest {
    /**
     * 
     */
    q: string;
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    providerType?: string;
    /**
     * 
     */
    state?: string;
    /**
     * 
     */
    zip?: string;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    page?: number;
}

export interface SendLeadReferralOperationRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    sendLeadReferralRequest: SendLeadReferralRequest;
}

export interface SwapScreenerLeadResidentsOperationRequest {
    /**
     * 
     */
    swapScreenerLeadResidentsRequest: SwapScreenerLeadResidentsRequest;
}

export interface SwitchOrganizationStateTownTypeRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    organizationStateTownSwitchTypeRequest: OrganizationStateTownSwitchTypeRequest;
}

export interface TriggerPdpmEstimatorRequest {
    /**
     * 
     */
    leadId: string;
}

export interface UpdateBedNoteOperationRequest {
    /**
     * The ID of the bed to update
     */
    bedId: string;
    /**
     * 
     */
    updateBedNoteRequest: UpdateBedNoteRequest;
}

export interface UpdateCriteriaRequest {
    /**
     * 
     */
    criteriaId: string;
    /**
     * 
     */
    criteria: Criteria;
}

export interface UpdateCriteriaCategoriesRequest {
    /**
     * 
     */
    bulkUpdateCriteriaCategoriesRequest: BulkUpdateCriteriaCategoriesRequest;
}

export interface UpdateCriteriaTargetsRequest {
    /**
     * 
     */
    criteriaId: string;
    /**
     * 
     */
    createCriteriaTargetsRequest: CreateCriteriaTargetsRequest;
}

export interface UpdateDocumentExclusionTermOperationRequest {
    /**
     * 
     */
    termId: string;
    /**
     * 
     */
    updateDocumentExclusionTermRequest: UpdateDocumentExclusionTermRequest;
}

export interface UpdateFacilityCustomTagOperationRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    updateFacilityCustomTagRequest: UpdateFacilityCustomTagRequest;
}

export interface UpdateFacilityRegionOperationRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    updateFacilityRegionRequest: UpdateFacilityRegionRequest;
}

export interface UpdateFacilityServiceAreaOperationRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    updateFacilityServiceAreaRequest: UpdateFacilityServiceAreaRequest;
}

export interface UpdateFacilitySettingRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    settingName: string;
    /**
     * 
     */
    updateScreenerSettingRequest: UpdateScreenerSettingRequest;
}

export interface UpdateFaxReadStatusOperationRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    updateFaxReadStatusRequest: UpdateFaxReadStatusRequest;
}

export interface UpdateFilterViewByIdRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    updateFilterViewRequest: UpdateFilterViewRequest;
}

export interface UpdateLeadCareAttributesOperationRequest {
    /**
     * 
     */
    updateLeadCareAttributesRequest: UpdateLeadCareAttributesRequest;
}

export interface UpdateLeadInfoRequest {
    /**
     * 
     */
    leadId: string;
    /**
     * 
     */
    createLeadInfoRequest: CreateLeadInfoRequest;
}

export interface UpdateLeadWaitlistRequest {
    /**
     * 
     */
    waitlistId: string;
    /**
     * 
     */
    findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist;
}

export interface UpdateLeadWaitlistRankOperationRequest {
    /**
     * 
     */
    waitlistId: string;
    /**
     * 
     */
    updateLeadWaitlistRankRequest: UpdateLeadWaitlistRankRequest;
}

export interface UpdateLeadWaitlistStatusOperationRequest {
    /**
     * 
     */
    waitlistId: string;
    /**
     * 
     */
    updateLeadWaitlistStatusRequest: UpdateLeadWaitlistStatusRequest;
}

export interface UpdateReferralRecipientConfigOperationRequest {
    /**
     * 
     */
    id: number;
    /**
     * 
     */
    updateReferralRecipientConfigRequest: UpdateReferralRecipientConfigRequest;
}

export interface UpdateReferralStatusOperationRequest {
    /**
     * 
     */
    referralId: string;
    /**
     * 
     */
    updateReferralStatusRequest: UpdateReferralStatusRequest;
}

export interface UpdateScreenerAdmissionFlagRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    findAllScreenerAdmissionFlags200ResponseDataInner: FindAllScreenerAdmissionFlags200ResponseDataInner;
}

export interface UpdateScreenerBedUnitRankOperationRequest {
    /**
     * 
     */
    bedUnitId: string;
    /**
     * 
     */
    updateScreenerBedUnitRankRequest: UpdateScreenerBedUnitRankRequest;
}

export interface UpdateScreenerLeadAdmissionFlagOperationRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    updateScreenerLeadAdmissionFlagRequest: UpdateScreenerLeadAdmissionFlagRequest;
}

export interface UpdateScreenerSettingOperationRequest {
    /**
     * 
     */
    settingName: string;
    /**
     * 
     */
    updateScreenerSettingRequest: UpdateScreenerSettingRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for bulkDeleteFacilityServiceAreas without sending the request
     */
    async bulkDeleteFacilityServiceAreasRequestOpts(requestParameters: BulkDeleteFacilityServiceAreasOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling bulkDeleteFacilityServiceAreas().'
            );
        }

        if (requestParameters['bulkDeleteFacilityServiceAreasRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkDeleteFacilityServiceAreasRequest',
                'Required parameter "bulkDeleteFacilityServiceAreasRequest" was null or undefined when calling bulkDeleteFacilityServiceAreas().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facilities/{facility_id}/service-areas/bulk`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: BulkDeleteFacilityServiceAreasRequestToJSON(requestParameters['bulkDeleteFacilityServiceAreasRequest']),
        };
    }

    /**
     * Delete multiple facility service-area rows by id
     */
    async bulkDeleteFacilityServiceAreasRaw(requestParameters: BulkDeleteFacilityServiceAreasOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkDeleteFacilityServiceAreas200Response>> {
        const requestOptions = await this.bulkDeleteFacilityServiceAreasRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkDeleteFacilityServiceAreas200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete multiple facility service-area rows by id
     */
    async bulkDeleteFacilityServiceAreas(requestParameters: BulkDeleteFacilityServiceAreasOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkDeleteFacilityServiceAreas200Response> {
        const response = await this.bulkDeleteFacilityServiceAreasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for bulkImportFacilityServiceAreas without sending the request
     */
    async bulkImportFacilityServiceAreasRequestOpts(requestParameters: BulkImportFacilityServiceAreasOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling bulkImportFacilityServiceAreas().'
            );
        }

        if (requestParameters['bulkImportFacilityServiceAreasRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkImportFacilityServiceAreasRequest',
                'Required parameter "bulkImportFacilityServiceAreasRequest" was null or undefined when calling bulkImportFacilityServiceAreas().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facilities/{facility_id}/service-areas/bulk`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkImportFacilityServiceAreasRequestToJSON(requestParameters['bulkImportFacilityServiceAreasRequest']),
        };
    }

    /**
     * Reads the CSV identified by `s3_key`, validates each row, and upserts valid rows by `(facility_id, zip)`. Returns per-row errors for any rows that failed validation. 
     * Bulk-import facility service areas from a previously-uploaded CSV
     */
    async bulkImportFacilityServiceAreasRaw(requestParameters: BulkImportFacilityServiceAreasOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkImportFacilityServiceAreas200Response>> {
        const requestOptions = await this.bulkImportFacilityServiceAreasRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkImportFacilityServiceAreas200ResponseFromJSON(jsonValue));
    }

    /**
     * Reads the CSV identified by `s3_key`, validates each row, and upserts valid rows by `(facility_id, zip)`. Returns per-row errors for any rows that failed validation. 
     * Bulk-import facility service areas from a previously-uploaded CSV
     */
    async bulkImportFacilityServiceAreas(requestParameters: BulkImportFacilityServiceAreasOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkImportFacilityServiceAreas200Response> {
        const response = await this.bulkImportFacilityServiceAreasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for bulkUpdateBedRooms without sending the request
     */
    async bulkUpdateBedRoomsRequestOpts(requestParameters: BulkUpdateBedRoomsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling bulkUpdateBedRooms().'
            );
        }

        if (requestParameters['unitId'] == null) {
            throw new runtime.RequiredError(
                'unitId',
                'Required parameter "unitId" was null or undefined when calling bulkUpdateBedRooms().'
            );
        }

        if (requestParameters['bulkUpdateBedRoomsRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkUpdateBedRoomsRequest',
                'Required parameter "bulkUpdateBedRoomsRequest" was null or undefined when calling bulkUpdateBedRooms().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['unitId'] != null) {
            queryParameters['unit_id'] = requestParameters['unitId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/bed-rooms`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateBedRoomsRequestToJSON(requestParameters['bulkUpdateBedRoomsRequest']),
        };
    }

    /**
     * Update bed rooms
     * Update bed rooms
     */
    async bulkUpdateBedRoomsRaw(requestParameters: BulkUpdateBedRoomsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllBedRooms200Response>> {
        const requestOptions = await this.bulkUpdateBedRoomsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllBedRooms200ResponseFromJSON(jsonValue));
    }

    /**
     * Update bed rooms
     * Update bed rooms
     */
    async bulkUpdateBedRooms(requestParameters: BulkUpdateBedRoomsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllBedRooms200Response> {
        const response = await this.bulkUpdateBedRoomsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for bulkUpdateBedTypes without sending the request
     */
    async bulkUpdateBedTypesRequestOpts(requestParameters: BulkUpdateBedTypesOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling bulkUpdateBedTypes().'
            );
        }

        if (requestParameters['bulkUpdateBedTypesRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkUpdateBedTypesRequest',
                'Required parameter "bulkUpdateBedTypesRequest" was null or undefined when calling bulkUpdateBedTypes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/bed-types`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateBedTypesRequestToJSON(requestParameters['bulkUpdateBedTypesRequest']),
        };
    }

    /**
     * Update bed types
     * Update bed types
     */
    async bulkUpdateBedTypesRaw(requestParameters: BulkUpdateBedTypesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkUpdateBedTypes200Response>> {
        const requestOptions = await this.bulkUpdateBedTypesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkUpdateBedTypes200ResponseFromJSON(jsonValue));
    }

    /**
     * Update bed types
     * Update bed types
     */
    async bulkUpdateBedTypes(requestParameters: BulkUpdateBedTypesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkUpdateBedTypes200Response> {
        const response = await this.bulkUpdateBedTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for bulkUpdateBeds without sending the request
     */
    async bulkUpdateBedsRequestOpts(requestParameters: BulkUpdateBedsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roomId'] == null) {
            throw new runtime.RequiredError(
                'roomId',
                'Required parameter "roomId" was null or undefined when calling bulkUpdateBeds().'
            );
        }

        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling bulkUpdateBeds().'
            );
        }

        if (requestParameters['bulkUpdateBedsRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkUpdateBedsRequest',
                'Required parameter "bulkUpdateBedsRequest" was null or undefined when calling bulkUpdateBeds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['roomId'] != null) {
            queryParameters['room_id'] = requestParameters['roomId'];
        }

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/beds`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateBedsRequestToJSON(requestParameters['bulkUpdateBedsRequest']),
        };
    }

    /**
     * Update beds in a room
     * Bulk update beds in a room
     */
    async bulkUpdateBedsRaw(requestParameters: BulkUpdateBedsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkUpdateBeds200Response>> {
        const requestOptions = await this.bulkUpdateBedsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkUpdateBeds200ResponseFromJSON(jsonValue));
    }

    /**
     * Update beds in a room
     * Bulk update beds in a room
     */
    async bulkUpdateBeds(requestParameters: BulkUpdateBedsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkUpdateBeds200Response> {
        const response = await this.bulkUpdateBedsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for bulkUpdateCriteria without sending the request
     */
    async bulkUpdateCriteriaRequestOpts(requestParameters: BulkUpdateCriteriaOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['criteriaId'] == null) {
            throw new runtime.RequiredError(
                'criteriaId',
                'Required parameter "criteriaId" was null or undefined when calling bulkUpdateCriteria().'
            );
        }

        if (requestParameters['bulkUpdateCriteriaRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkUpdateCriteriaRequest',
                'Required parameter "bulkUpdateCriteriaRequest" was null or undefined when calling bulkUpdateCriteria().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/criteria/{criteria_id}/rank`;
        urlPath = urlPath.replace('{criteria_id}', encodeURIComponent(String(requestParameters['criteriaId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateCriteriaRequestToJSON(requestParameters['bulkUpdateCriteriaRequest']),
        };
    }

    /**
     * Bulk update screener criteria
     */
    async bulkUpdateCriteriaRaw(requestParameters: BulkUpdateCriteriaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.bulkUpdateCriteriaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Bulk update screener criteria
     */
    async bulkUpdateCriteria(requestParameters: BulkUpdateCriteriaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.bulkUpdateCriteriaRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for bulkUpdateFacilityServiceAreas without sending the request
     */
    async bulkUpdateFacilityServiceAreasRequestOpts(requestParameters: BulkUpdateFacilityServiceAreasOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling bulkUpdateFacilityServiceAreas().'
            );
        }

        if (requestParameters['bulkUpdateFacilityServiceAreasRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkUpdateFacilityServiceAreasRequest',
                'Required parameter "bulkUpdateFacilityServiceAreasRequest" was null or undefined when calling bulkUpdateFacilityServiceAreas().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facilities/{facility_id}/service-areas/bulk`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateFacilityServiceAreasRequestToJSON(requestParameters['bulkUpdateFacilityServiceAreasRequest']),
        };
    }

    /**
     * Apply the same status and/or notes change to multiple rows
     */
    async bulkUpdateFacilityServiceAreasRaw(requestParameters: BulkUpdateFacilityServiceAreasOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkUpdateFacilityServiceAreas200Response>> {
        const requestOptions = await this.bulkUpdateFacilityServiceAreasRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkUpdateFacilityServiceAreas200ResponseFromJSON(jsonValue));
    }

    /**
     * Apply the same status and/or notes change to multiple rows
     */
    async bulkUpdateFacilityServiceAreas(requestParameters: BulkUpdateFacilityServiceAreasOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkUpdateFacilityServiceAreas200Response> {
        const response = await this.bulkUpdateFacilityServiceAreasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for bulkUpdateScreenerBedUnits without sending the request
     */
    async bulkUpdateScreenerBedUnitsRequestOpts(requestParameters: BulkUpdateScreenerBedUnitsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling bulkUpdateScreenerBedUnits().'
            );
        }

        if (requestParameters['bulkUpdateScreenerBedUnitsRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkUpdateScreenerBedUnitsRequest',
                'Required parameter "bulkUpdateScreenerBedUnitsRequest" was null or undefined when calling bulkUpdateScreenerBedUnits().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/screener-bed-units`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateScreenerBedUnitsRequestToJSON(requestParameters['bulkUpdateScreenerBedUnitsRequest']),
        };
    }

    /**
     * Update screener bed units
     * Update screener bed units
     */
    async bulkUpdateScreenerBedUnitsRaw(requestParameters: BulkUpdateScreenerBedUnitsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerBedUnits200Response>> {
        const requestOptions = await this.bulkUpdateScreenerBedUnitsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerBedUnits200ResponseFromJSON(jsonValue));
    }

    /**
     * Update screener bed units
     * Update screener bed units
     */
    async bulkUpdateScreenerBedUnits(requestParameters: BulkUpdateScreenerBedUnitsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerBedUnits200Response> {
        const response = await this.bulkUpdateScreenerBedUnitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for bulkUpdateScreenerTags without sending the request
     */
    async bulkUpdateScreenerTagsRequestOpts(requestParameters: BulkUpdateScreenerTagsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['bulkUpdateScreenerTagsRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkUpdateScreenerTagsRequest',
                'Required parameter "bulkUpdateScreenerTagsRequest" was null or undefined when calling bulkUpdateScreenerTags().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/screener-tags/bulk`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateScreenerTagsRequestToJSON(requestParameters['bulkUpdateScreenerTagsRequest']),
        };
    }

    /**
     * Bulk update screener tags
     */
    async bulkUpdateScreenerTagsRaw(requestParameters: BulkUpdateScreenerTagsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerTags200Response>> {
        const requestOptions = await this.bulkUpdateScreenerTagsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerTags200ResponseFromJSON(jsonValue));
    }

    /**
     * Bulk update screener tags
     */
    async bulkUpdateScreenerTags(requestParameters: BulkUpdateScreenerTagsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerTags200Response> {
        const response = await this.bulkUpdateScreenerTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for checkEligibility without sending the request
     */
    async checkEligibilityRequestOpts(requestParameters: CheckEligibilityRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling checkEligibility().'
            );
        }

        if (requestParameters['action'] == null) {
            throw new runtime.RequiredError(
                'action',
                'Required parameter "action" was null or undefined when calling checkEligibility().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['action'] != null) {
            queryParameters['action'] = requestParameters['action'];
        }

        if (requestParameters['date'] != null) {
            queryParameters['date'] = runtime.serializeDate(requestParameters['date'] as any);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/check-eligibility`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Unified endpoint for checking eligibility of various lead actions (date updates, reverts, etc.)
     * Check eligibility for a lead action
     */
    async checkEligibilityRaw(requestParameters: CheckEligibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckEligibility200Response>> {
        const requestOptions = await this.checkEligibilityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckEligibility200ResponseFromJSON(jsonValue));
    }

    /**
     * Unified endpoint for checking eligibility of various lead actions (date updates, reverts, etc.)
     * Check eligibility for a lead action
     */
    async checkEligibility(requestParameters: CheckEligibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckEligibility200Response> {
        const response = await this.checkEligibilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for combineDocuments without sending the request
     */
    async combineDocumentsRequestOpts(requestParameters: CombineDocumentsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['combineDocumentsRequest'] == null) {
            throw new runtime.RequiredError(
                'combineDocumentsRequest',
                'Required parameter "combineDocumentsRequest" was null or undefined when calling combineDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/combine-documents`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CombineDocumentsRequestToJSON(requestParameters['combineDocumentsRequest']),
        };
    }

    /**
     * Copy documents from combine leads to the retained lead, then cancel the combine leads
     * Combine documents from multiple leads into a retained lead
     */
    async combineDocumentsRaw(requestParameters: CombineDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CombineDocuments200Response>> {
        const requestOptions = await this.combineDocumentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CombineDocuments200ResponseFromJSON(jsonValue));
    }

    /**
     * Copy documents from combine leads to the retained lead, then cancel the combine leads
     * Combine documents from multiple leads into a retained lead
     */
    async combineDocuments(requestParameters: CombineDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CombineDocuments200Response> {
        const response = await this.combineDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for combineLeads without sending the request
     * @deprecated
     */
    async combineLeadsRequestOpts(requestParameters: CombineLeadsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['combineLeadsRequest'] == null) {
            throw new runtime.RequiredError(
                'combineLeadsRequest',
                'Required parameter "combineLeadsRequest" was null or undefined when calling combineLeads().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/combine`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CombineLeadsRequestToJSON(requestParameters['combineLeadsRequest']),
        };
    }

    /**
     * Combine leads
     * Combine leads
     * @deprecated
     */
    async combineLeadsRaw(requestParameters: CombineLeadsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CombineLeads200Response>> {
        const requestOptions = await this.combineLeadsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CombineLeads200ResponseFromJSON(jsonValue));
    }

    /**
     * Combine leads
     * Combine leads
     * @deprecated
     */
    async combineLeads(requestParameters: CombineLeadsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CombineLeads200Response> {
        const response = await this.combineLeadsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for copyLead without sending the request
     */
    async copyLeadRequestOpts(requestParameters: CopyLeadOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling copyLead().'
            );
        }

        if (requestParameters['copyLeadRequest'] == null) {
            throw new runtime.RequiredError(
                'copyLeadRequest',
                'Required parameter "copyLeadRequest" was null or undefined when calling copyLead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/copy`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CopyLeadRequestToJSON(requestParameters['copyLeadRequest']),
        };
    }

    /**
     * Copy lead to other facilities
     */
    async copyLeadRaw(requestParameters: CopyLeadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CopyLead201Response>> {
        const requestOptions = await this.copyLeadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CopyLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Copy lead to other facilities
     */
    async copyLead(requestParameters: CopyLeadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CopyLead201Response> {
        const response = await this.copyLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for countActiveIntegrationEvents without sending the request
     */
    async countActiveIntegrationEventsRequestOpts(requestParameters: CountActiveIntegrationEventsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling countActiveIntegrationEvents().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{facility_id}/integration-events/active-count`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Count un-actioned integration events
     */
    async countActiveIntegrationEventsRaw(requestParameters: CountActiveIntegrationEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CountActiveIntegrationEvents200Response>> {
        const requestOptions = await this.countActiveIntegrationEventsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CountActiveIntegrationEvents200ResponseFromJSON(jsonValue));
    }

    /**
     * Count un-actioned integration events
     */
    async countActiveIntegrationEvents(requestParameters: CountActiveIntegrationEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CountActiveIntegrationEvents200Response> {
        const response = await this.countActiveIntegrationEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createCriteria without sending the request
     */
    async createCriteriaRequestOpts(requestParameters: CreateCriteriaOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createCriteriaRequest'] == null) {
            throw new runtime.RequiredError(
                'createCriteriaRequest',
                'Required parameter "createCriteriaRequest" was null or undefined when calling createCriteria().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/criteria`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCriteriaRequestToJSON(requestParameters['createCriteriaRequest']),
        };
    }

    /**
     * Create a screener criteria
     */
    async createCriteriaRaw(requestParameters: CreateCriteriaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCriteria201Response>> {
        const requestOptions = await this.createCriteriaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCriteria201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener criteria
     */
    async createCriteria(requestParameters: CreateCriteriaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCriteria201Response> {
        const response = await this.createCriteriaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createCriteriaCategory without sending the request
     */
    async createCriteriaCategoryRequestOpts(requestParameters: CreateCriteriaCategoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['criteriaCategory'] == null) {
            throw new runtime.RequiredError(
                'criteriaCategory',
                'Required parameter "criteriaCategory" was null or undefined when calling createCriteriaCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/criteria/categories`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CriteriaCategoryToJSON(requestParameters['criteriaCategory']),
        };
    }

    /**
     * Create a criteria category
     * Create a criteria category
     */
    async createCriteriaCategoryRaw(requestParameters: CreateCriteriaCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCriteriaCategory201Response>> {
        const requestOptions = await this.createCriteriaCategoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCriteriaCategory201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a criteria category
     * Create a criteria category
     */
    async createCriteriaCategory(requestParameters: CreateCriteriaCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCriteriaCategory201Response> {
        const response = await this.createCriteriaCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createCriteriaTargets without sending the request
     */
    async createCriteriaTargetsRequestOpts(requestParameters: CreateCriteriaTargetsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createCriteriaTargetsRequest'] == null) {
            throw new runtime.RequiredError(
                'createCriteriaTargetsRequest',
                'Required parameter "createCriteriaTargetsRequest" was null or undefined when calling createCriteriaTargets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/criteria/targets`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCriteriaTargetsRequestToJSON(requestParameters['createCriteriaTargetsRequest']),
        };
    }

    /**
     * Create a screener criteria and its facility/system-tag targets in a single transaction
     * Create a criteria with targets
     */
    async createCriteriaTargetsRaw(requestParameters: CreateCriteriaTargetsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCriteriaTargets201Response>> {
        const requestOptions = await this.createCriteriaTargetsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCriteriaTargets201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener criteria and its facility/system-tag targets in a single transaction
     * Create a criteria with targets
     */
    async createCriteriaTargets(requestParameters: CreateCriteriaTargetsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCriteriaTargets201Response> {
        const response = await this.createCriteriaTargetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createDocumentExclusionTerm without sending the request
     */
    async createDocumentExclusionTermRequestOpts(requestParameters: CreateDocumentExclusionTermOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createDocumentExclusionTermRequest'] == null) {
            throw new runtime.RequiredError(
                'createDocumentExclusionTermRequest',
                'Required parameter "createDocumentExclusionTermRequest" was null or undefined when calling createDocumentExclusionTerm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/document-exclusion-terms`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDocumentExclusionTermRequestToJSON(requestParameters['createDocumentExclusionTermRequest']),
        };
    }

    /**
     * Create a new document exclusion term for a specific organization and facility
     * Create document exclusion term
     */
    async createDocumentExclusionTermRaw(requestParameters: CreateDocumentExclusionTermOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDocumentExclusionTerm201Response>> {
        const requestOptions = await this.createDocumentExclusionTermRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDocumentExclusionTerm201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new document exclusion term for a specific organization and facility
     * Create document exclusion term
     */
    async createDocumentExclusionTerm(requestParameters: CreateDocumentExclusionTermOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDocumentExclusionTerm201Response> {
        const response = await this.createDocumentExclusionTermRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createFacilityCustomTag without sending the request
     */
    async createFacilityCustomTagRequestOpts(requestParameters: CreateFacilityCustomTagOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createFacilityCustomTagRequest'] == null) {
            throw new runtime.RequiredError(
                'createFacilityCustomTagRequest',
                'Required parameter "createFacilityCustomTagRequest" was null or undefined when calling createFacilityCustomTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facility-custom-tags`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFacilityCustomTagRequestToJSON(requestParameters['createFacilityCustomTagRequest']),
        };
    }

    /**
     * Create a facility custom tag and apply it to its facilities
     */
    async createFacilityCustomTagRaw(requestParameters: CreateFacilityCustomTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityCustomTag201Response>> {
        const requestOptions = await this.createFacilityCustomTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityCustomTag201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a facility custom tag and apply it to its facilities
     */
    async createFacilityCustomTag(requestParameters: CreateFacilityCustomTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityCustomTag201Response> {
        const response = await this.createFacilityCustomTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createFacilityRegion without sending the request
     */
    async createFacilityRegionRequestOpts(requestParameters: CreateFacilityRegionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createFacilityRegionRequest'] == null) {
            throw new runtime.RequiredError(
                'createFacilityRegionRequest',
                'Required parameter "createFacilityRegionRequest" was null or undefined when calling createFacilityRegion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facility-regions`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFacilityRegionRequestToJSON(requestParameters['createFacilityRegionRequest']),
        };
    }

    /**
     * Create a facility region and assign its facilities
     */
    async createFacilityRegionRaw(requestParameters: CreateFacilityRegionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityRegion201Response>> {
        const requestOptions = await this.createFacilityRegionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityRegion201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a facility region and assign its facilities
     */
    async createFacilityRegion(requestParameters: CreateFacilityRegionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityRegion201Response> {
        const response = await this.createFacilityRegionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createFacilityServiceArea without sending the request
     */
    async createFacilityServiceAreaRequestOpts(requestParameters: CreateFacilityServiceAreaOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling createFacilityServiceArea().'
            );
        }

        if (requestParameters['createFacilityServiceAreaRequest'] == null) {
            throw new runtime.RequiredError(
                'createFacilityServiceAreaRequest',
                'Required parameter "createFacilityServiceAreaRequest" was null or undefined when calling createFacilityServiceArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facilities/{facility_id}/service-areas`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFacilityServiceAreaRequestToJSON(requestParameters['createFacilityServiceAreaRequest']),
        };
    }

    /**
     * Create a service area entry for a facility
     */
    async createFacilityServiceAreaRaw(requestParameters: CreateFacilityServiceAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityServiceArea201Response>> {
        const requestOptions = await this.createFacilityServiceAreaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityServiceArea201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a service area entry for a facility
     */
    async createFacilityServiceArea(requestParameters: CreateFacilityServiceAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityServiceArea201Response> {
        const response = await this.createFacilityServiceAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createFacilityServiceAreaUploadUrl without sending the request
     */
    async createFacilityServiceAreaUploadUrlRequestOpts(requestParameters: CreateFacilityServiceAreaUploadUrlRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling createFacilityServiceAreaUploadUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{facility_id}/service-areas/upload-url`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a short-lived signed S3 URL the client can `PUT` the CSV to, plus the `s3_key` to pass to the bulk-import endpoint. 
     * Get a presigned S3 URL for uploading a service area CSV
     */
    async createFacilityServiceAreaUploadUrlRaw(requestParameters: CreateFacilityServiceAreaUploadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityServiceAreaUploadUrl200Response>> {
        const requestOptions = await this.createFacilityServiceAreaUploadUrlRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityServiceAreaUploadUrl200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a short-lived signed S3 URL the client can `PUT` the CSV to, plus the `s3_key` to pass to the bulk-import endpoint. 
     * Get a presigned S3 URL for uploading a service area CSV
     */
    async createFacilityServiceAreaUploadUrl(requestParameters: CreateFacilityServiceAreaUploadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityServiceAreaUploadUrl200Response> {
        const response = await this.createFacilityServiceAreaUploadUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createFaxReferral without sending the request
     */
    async createFaxReferralRequestOpts(requestParameters: CreateFaxReferralRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createFaxReferral().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/efax/faxes/{id}/create-referral`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Create a new referral from a fax document
     */
    async createFaxReferralRaw(requestParameters: CreateFaxReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createFaxReferralRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a new referral from a fax document
     */
    async createFaxReferral(requestParameters: CreateFaxReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createFaxReferralRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for createFilterView without sending the request
     */
    async createFilterViewRequestOpts(requestParameters: CreateFilterViewOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createFilterViewRequest'] == null) {
            throw new runtime.RequiredError(
                'createFilterViewRequest',
                'Required parameter "createFilterViewRequest" was null or undefined when calling createFilterView().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/filter-views`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFilterViewRequestToJSON(requestParameters['createFilterViewRequest']),
        };
    }

    /**
     * Create a filter view
     */
    async createFilterViewRaw(requestParameters: CreateFilterViewOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFilterView201Response>> {
        const requestOptions = await this.createFilterViewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFilterView201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a filter view
     */
    async createFilterView(requestParameters: CreateFilterViewOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFilterView201Response> {
        const response = await this.createFilterViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createLeadAdditionalDocuments without sending the request
     */
    async createLeadAdditionalDocumentsRequestOpts(requestParameters: CreateLeadAdditionalDocumentsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createLeadAdditionalDocuments().'
            );
        }

        if (requestParameters['createLeadAdditionalDocumentsRequest'] == null) {
            throw new runtime.RequiredError(
                'createLeadAdditionalDocumentsRequest',
                'Required parameter "createLeadAdditionalDocumentsRequest" was null or undefined when calling createLeadAdditionalDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/additional-documents/bulk`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLeadAdditionalDocumentsRequestToJSON(requestParameters['createLeadAdditionalDocumentsRequest']),
        };
    }

    /**
     * Create lead additional documents
     */
    async createLeadAdditionalDocumentsRaw(requestParameters: CreateLeadAdditionalDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createLeadAdditionalDocumentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create lead additional documents
     */
    async createLeadAdditionalDocuments(requestParameters: CreateLeadAdditionalDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createLeadAdditionalDocumentsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for createLeadInfo without sending the request
     */
    async createLeadInfoRequestOpts(requestParameters: CreateLeadInfoOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createLeadInfoRequest'] == null) {
            throw new runtime.RequiredError(
                'createLeadInfoRequest',
                'Required parameter "createLeadInfoRequest" was null or undefined when calling createLeadInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/lead-info`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLeadInfoRequestToJSON(requestParameters['createLeadInfoRequest']),
        };
    }

    /**
     * Create a screener lead info
     */
    async createLeadInfoRaw(requestParameters: CreateLeadInfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeadInfo201Response>> {
        const requestOptions = await this.createLeadInfoRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadInfo201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener lead info
     */
    async createLeadInfo(requestParameters: CreateLeadInfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeadInfo201Response> {
        const response = await this.createLeadInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createLeadWaitlist without sending the request
     */
    async createLeadWaitlistRequestOpts(requestParameters: CreateLeadWaitlistRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createLeadWaitlist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/waitlist`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Create a lead waitlist record
     */
    async createLeadWaitlistRaw(requestParameters: CreateLeadWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeadWaitlistStatus200Response>> {
        const requestOptions = await this.createLeadWaitlistRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLeadWaitlistStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Create a lead waitlist record
     */
    async createLeadWaitlist(requestParameters: CreateLeadWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeadWaitlistStatus200Response> {
        const response = await this.createLeadWaitlistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createLeadWaitlistUpdate without sending the request
     */
    async createLeadWaitlistUpdateRequestOpts(requestParameters: CreateLeadWaitlistUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['waitlistId'] == null) {
            throw new runtime.RequiredError(
                'waitlistId',
                'Required parameter "waitlistId" was null or undefined when calling createLeadWaitlistUpdate().'
            );
        }

        if (requestParameters['findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner'] == null) {
            throw new runtime.RequiredError(
                'findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner',
                'Required parameter "findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner" was null or undefined when calling createLeadWaitlistUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/lead-waitlist/{waitlist_id}/updates`;
        urlPath = urlPath.replace('{waitlist_id}', encodeURIComponent(String(requestParameters['waitlistId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerToJSON(requestParameters['findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner']),
        };
    }

    /**
     * Create a lead waitlist update record
     */
    async createLeadWaitlistUpdateRaw(requestParameters: CreateLeadWaitlistUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeadWaitlistUpdate201Response>> {
        const requestOptions = await this.createLeadWaitlistUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadWaitlistUpdate201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a lead waitlist update record
     */
    async createLeadWaitlistUpdate(requestParameters: CreateLeadWaitlistUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeadWaitlistUpdate201Response> {
        const response = await this.createLeadWaitlistUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createLeadsBulk without sending the request
     */
    async createLeadsBulkRequestOpts(requestParameters: CreateLeadsBulkOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createLeadsBulkRequest'] == null) {
            throw new runtime.RequiredError(
                'createLeadsBulkRequest',
                'Required parameter "createLeadsBulkRequest" was null or undefined when calling createLeadsBulk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/bulk`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLeadsBulkRequestToJSON(requestParameters['createLeadsBulkRequest']),
        };
    }

    /**
     * Create multiple screener leads for specified facilities
     */
    async createLeadsBulkRaw(requestParameters: CreateLeadsBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createLeadsBulkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create multiple screener leads for specified facilities
     */
    async createLeadsBulk(requestParameters: CreateLeadsBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createLeadsBulkRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for createMatrixCarePatient without sending the request
     */
    async createMatrixCarePatientRequestOpts(requestParameters: CreateMatrixCarePatientOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createMatrixCarePatient().'
            );
        }

        if (requestParameters['createMatrixCarePatientRequest'] == null) {
            throw new runtime.RequiredError(
                'createMatrixCarePatientRequest',
                'Required parameter "createMatrixCarePatientRequest" was null or undefined when calling createMatrixCarePatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/matrix-care/patient`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMatrixCarePatientRequestToJSON(requestParameters['createMatrixCarePatientRequest']),
        };
    }

    /**
     * Create a MatrixCare patient
     */
    async createMatrixCarePatientRaw(requestParameters: CreateMatrixCarePatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateMatrixCarePatient201Response>> {
        const requestOptions = await this.createMatrixCarePatientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateMatrixCarePatient201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a MatrixCare patient
     */
    async createMatrixCarePatient(requestParameters: CreateMatrixCarePatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateMatrixCarePatient201Response> {
        const response = await this.createMatrixCarePatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createMatrixCarePatientDetails without sending the request
     */
    async createMatrixCarePatientDetailsRequestOpts(requestParameters: CreateMatrixCarePatientDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling createMatrixCarePatientDetails().'
            );
        }

        if (requestParameters['matrixCarePatientDetails'] == null) {
            throw new runtime.RequiredError(
                'matrixCarePatientDetails',
                'Required parameter "matrixCarePatientDetails" was null or undefined when calling createMatrixCarePatientDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/matrix-care/patient/details`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MatrixCarePatientDetailsToJSON(requestParameters['matrixCarePatientDetails']),
        };
    }

    /**
     * Create details for a MatrixCare patient
     */
    async createMatrixCarePatientDetailsRaw(requestParameters: CreateMatrixCarePatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneMatrixCarePatientDetails200Response>> {
        const requestOptions = await this.createMatrixCarePatientDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneMatrixCarePatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Create details for a MatrixCare patient
     */
    async createMatrixCarePatientDetails(requestParameters: CreateMatrixCarePatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneMatrixCarePatientDetails200Response> {
        const response = await this.createMatrixCarePatientDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createOrganizationIPWhitelist without sending the request
     */
    async createOrganizationIPWhitelistRequestOpts(requestParameters: CreateOrganizationIPWhitelistOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createOrganizationIPWhitelistRequest'] == null) {
            throw new runtime.RequiredError(
                'createOrganizationIPWhitelistRequest',
                'Required parameter "createOrganizationIPWhitelistRequest" was null or undefined when calling createOrganizationIPWhitelist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/ip-whitelist`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrganizationIPWhitelistRequestToJSON(requestParameters['createOrganizationIPWhitelistRequest']),
        };
    }

    /**
     * Add a new IP address to the organization\'s whitelist
     * Create IP whitelist entry for an organization
     */
    async createOrganizationIPWhitelistRaw(requestParameters: CreateOrganizationIPWhitelistOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrganizationIPWhitelistResponse>> {
        const requestOptions = await this.createOrganizationIPWhitelistRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOrganizationIPWhitelistResponseFromJSON(jsonValue));
    }

    /**
     * Add a new IP address to the organization\'s whitelist
     * Create IP whitelist entry for an organization
     */
    async createOrganizationIPWhitelist(requestParameters: CreateOrganizationIPWhitelistOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrganizationIPWhitelistResponse> {
        const response = await this.createOrganizationIPWhitelistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createOrganizationState without sending the request
     */
    async createOrganizationStateRequestOpts(requestParameters: CreateOrganizationStateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['organizationState'] == null) {
            throw new runtime.RequiredError(
                'organizationState',
                'Required parameter "organizationState" was null or undefined when calling createOrganizationState().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/organization-states`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationStateToJSON(requestParameters['organizationState']),
        };
    }

    /**
     * Create a screener organization state
     */
    async createOrganizationStateRaw(requestParameters: CreateOrganizationStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrganizationState201Response>> {
        const requestOptions = await this.createOrganizationStateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOrganizationState201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener organization state
     */
    async createOrganizationState(requestParameters: CreateOrganizationStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrganizationState201Response> {
        const response = await this.createOrganizationStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createOrganizationStateTownsBulk without sending the request
     */
    async createOrganizationStateTownsBulkRequestOpts(requestParameters: CreateOrganizationStateTownsBulkOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createOrganizationStateTownsBulkRequest'] == null) {
            throw new runtime.RequiredError(
                'createOrganizationStateTownsBulkRequest',
                'Required parameter "createOrganizationStateTownsBulkRequest" was null or undefined when calling createOrganizationStateTownsBulk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/organization-state-towns/bulk`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrganizationStateTownsBulkRequestToJSON(requestParameters['createOrganizationStateTownsBulkRequest']),
        };
    }

    /**
     * Create multiple towns for an organization state
     */
    async createOrganizationStateTownsBulkRaw(requestParameters: CreateOrganizationStateTownsBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrganizationStateTownsBulk201Response>> {
        const requestOptions = await this.createOrganizationStateTownsBulkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOrganizationStateTownsBulk201ResponseFromJSON(jsonValue));
    }

    /**
     * Create multiple towns for an organization state
     */
    async createOrganizationStateTownsBulk(requestParameters: CreateOrganizationStateTownsBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrganizationStateTownsBulk201Response> {
        const response = await this.createOrganizationStateTownsBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createReferralRecipientConfig without sending the request
     */
    async createReferralRecipientConfigRequestOpts(requestParameters: CreateReferralRecipientConfigOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createReferralRecipientConfigRequest'] == null) {
            throw new runtime.RequiredError(
                'createReferralRecipientConfigRequest',
                'Required parameter "createReferralRecipientConfigRequest" was null or undefined when calling createReferralRecipientConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/referral-recipient-configs`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReferralRecipientConfigRequestToJSON(requestParameters['createReferralRecipientConfigRequest']),
        };
    }

    /**
     * Create a referral recipient config for an accessible sender facility
     */
    async createReferralRecipientConfigRaw(requestParameters: CreateReferralRecipientConfigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateReferralRecipientConfig201Response>> {
        const requestOptions = await this.createReferralRecipientConfigRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateReferralRecipientConfig201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a referral recipient config for an accessible sender facility
     */
    async createReferralRecipientConfig(requestParameters: CreateReferralRecipientConfigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateReferralRecipientConfig201Response> {
        const response = await this.createReferralRecipientConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createScreenerAdmissionFlag without sending the request
     */
    async createScreenerAdmissionFlagRequestOpts(requestParameters: CreateScreenerAdmissionFlagRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['findAllScreenerAdmissionFlags200ResponseDataInner'] == null) {
            throw new runtime.RequiredError(
                'findAllScreenerAdmissionFlags200ResponseDataInner',
                'Required parameter "findAllScreenerAdmissionFlags200ResponseDataInner" was null or undefined when calling createScreenerAdmissionFlag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/screener-admission-flags`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON(requestParameters['findAllScreenerAdmissionFlags200ResponseDataInner']),
        };
    }

    /**
     * Create a screener admission flag
     * Create a screener admission flag
     */
    async createScreenerAdmissionFlagRaw(requestParameters: CreateScreenerAdmissionFlagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateScreenerAdmissionFlag201Response>> {
        const requestOptions = await this.createScreenerAdmissionFlagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateScreenerAdmissionFlag201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener admission flag
     * Create a screener admission flag
     */
    async createScreenerAdmissionFlag(requestParameters: CreateScreenerAdmissionFlagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateScreenerAdmissionFlag201Response> {
        const response = await this.createScreenerAdmissionFlagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createScreenerLeadTag without sending the request
     */
    async createScreenerLeadTagRequestOpts(requestParameters: CreateScreenerLeadTagRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner'] == null) {
            throw new runtime.RequiredError(
                'findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner',
                'Required parameter "findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner" was null or undefined when calling createScreenerLeadTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/screener-lead-tags`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSON(requestParameters['findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner']),
        };
    }

    /**
     * Create a screener lead tag
     * Create a screener lead tag
     */
    async createScreenerLeadTagRaw(requestParameters: CreateScreenerLeadTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateScreenerLeadTag201Response>> {
        const requestOptions = await this.createScreenerLeadTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateScreenerLeadTag201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener lead tag
     * Create a screener lead tag
     */
    async createScreenerLeadTag(requestParameters: CreateScreenerLeadTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateScreenerLeadTag201Response> {
        const response = await this.createScreenerLeadTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createSourceTag without sending the request
     */
    async createSourceTagRequestOpts(requestParameters: CreateSourceTagOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createSourceTagRequest'] == null) {
            throw new runtime.RequiredError(
                'createSourceTagRequest',
                'Required parameter "createSourceTagRequest" was null or undefined when calling createSourceTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/source-tags`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSourceTagRequestToJSON(requestParameters['createSourceTagRequest']),
        };
    }

    /**
     * Create a screener source tag
     */
    async createSourceTagRaw(requestParameters: CreateSourceTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSourceTag201Response>> {
        const requestOptions = await this.createSourceTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSourceTag201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener source tag
     */
    async createSourceTag(requestParameters: CreateSourceTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSourceTag201Response> {
        const response = await this.createSourceTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteAdditionalDocumentForLead without sending the request
     */
    async deleteAdditionalDocumentForLeadRequestOpts(requestParameters: DeleteAdditionalDocumentForLeadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling deleteAdditionalDocumentForLead().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling deleteAdditionalDocumentForLead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/additional-documents/{document_id}`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{document_id}', encodeURIComponent(String(requestParameters['documentId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete additional document for a screener lead by ID
     */
    async deleteAdditionalDocumentForLeadRaw(requestParameters: DeleteAdditionalDocumentForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteAdditionalDocumentForLeadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete additional document for a screener lead by ID
     */
    async deleteAdditionalDocumentForLead(requestParameters: DeleteAdditionalDocumentForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdditionalDocumentForLeadRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteCriteria without sending the request
     */
    async deleteCriteriaRequestOpts(requestParameters: DeleteCriteriaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['criteriaId'] == null) {
            throw new runtime.RequiredError(
                'criteriaId',
                'Required parameter "criteriaId" was null or undefined when calling deleteCriteria().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/criteria/{criteria_id}`;
        urlPath = urlPath.replace('{criteria_id}', encodeURIComponent(String(requestParameters['criteriaId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a criteria
     * Delete a criteria
     */
    async deleteCriteriaRaw(requestParameters: DeleteCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteCriteriaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a criteria
     * Delete a criteria
     */
    async deleteCriteria(requestParameters: DeleteCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCriteriaRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteCriteriaCategory without sending the request
     */
    async deleteCriteriaCategoryRequestOpts(requestParameters: DeleteCriteriaCategoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling deleteCriteriaCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/criteria/categories/{category_id}`;
        urlPath = urlPath.replace('{category_id}', encodeURIComponent(String(requestParameters['categoryId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a criteria category
     * Delete a criteria category
     */
    async deleteCriteriaCategoryRaw(requestParameters: DeleteCriteriaCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteCriteriaCategoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a criteria category
     * Delete a criteria category
     */
    async deleteCriteriaCategory(requestParameters: DeleteCriteriaCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCriteriaCategoryRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteCriteriaTargets without sending the request
     */
    async deleteCriteriaTargetsRequestOpts(requestParameters: DeleteCriteriaTargetsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['criteriaId'] == null) {
            throw new runtime.RequiredError(
                'criteriaId',
                'Required parameter "criteriaId" was null or undefined when calling deleteCriteriaTargets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/criteria/targets/{criteria_id}`;
        urlPath = urlPath.replace('{criteria_id}', encodeURIComponent(String(requestParameters['criteriaId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Soft delete a screener criteria and all of its targets in a single transaction
     * Delete a criteria and its targets
     */
    async deleteCriteriaTargetsRaw(requestParameters: DeleteCriteriaTargetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteCriteriaTargetsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft delete a screener criteria and all of its targets in a single transaction
     * Delete a criteria and its targets
     */
    async deleteCriteriaTargets(requestParameters: DeleteCriteriaTargetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCriteriaTargetsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteDocumentExclusionTerm without sending the request
     */
    async deleteDocumentExclusionTermRequestOpts(requestParameters: DeleteDocumentExclusionTermRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['termId'] == null) {
            throw new runtime.RequiredError(
                'termId',
                'Required parameter "termId" was null or undefined when calling deleteDocumentExclusionTerm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/document-exclusion-terms/{term_id}`;
        urlPath = urlPath.replace('{term_id}', encodeURIComponent(String(requestParameters['termId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete an existing document exclusion term
     * Delete document exclusion term
     */
    async deleteDocumentExclusionTermRaw(requestParameters: DeleteDocumentExclusionTermRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteDocumentExclusionTermRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an existing document exclusion term
     * Delete document exclusion term
     */
    async deleteDocumentExclusionTerm(requestParameters: DeleteDocumentExclusionTermRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDocumentExclusionTermRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteFacilityCustomTag without sending the request
     */
    async deleteFacilityCustomTagRequestOpts(requestParameters: DeleteFacilityCustomTagRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteFacilityCustomTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facility-custom-tags/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a facility custom tag and remove its taggings
     */
    async deleteFacilityCustomTagRaw(requestParameters: DeleteFacilityCustomTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteFacilityRegion200Response>> {
        const requestOptions = await this.deleteFacilityCustomTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteFacilityRegion200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete a facility custom tag and remove its taggings
     */
    async deleteFacilityCustomTag(requestParameters: DeleteFacilityCustomTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteFacilityRegion200Response> {
        const response = await this.deleteFacilityCustomTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteFacilityRegion without sending the request
     */
    async deleteFacilityRegionRequestOpts(requestParameters: DeleteFacilityRegionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteFacilityRegion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facility-regions/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a facility region and detach its facilities
     */
    async deleteFacilityRegionRaw(requestParameters: DeleteFacilityRegionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteFacilityRegion200Response>> {
        const requestOptions = await this.deleteFacilityRegionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteFacilityRegion200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete a facility region and detach its facilities
     */
    async deleteFacilityRegion(requestParameters: DeleteFacilityRegionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteFacilityRegion200Response> {
        const response = await this.deleteFacilityRegionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteFacilityServiceArea without sending the request
     */
    async deleteFacilityServiceAreaRequestOpts(requestParameters: DeleteFacilityServiceAreaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling deleteFacilityServiceArea().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteFacilityServiceArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{facility_id}/service-areas/{id}`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a service area entry for a facility
     */
    async deleteFacilityServiceAreaRaw(requestParameters: DeleteFacilityServiceAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteFacilityServiceAreaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a service area entry for a facility
     */
    async deleteFacilityServiceArea(requestParameters: DeleteFacilityServiceAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFacilityServiceAreaRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteFilterViewById without sending the request
     */
    async deleteFilterViewByIdRequestOpts(requestParameters: DeleteFilterViewByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteFilterViewById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/filter-views/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a filter view
     */
    async deleteFilterViewByIdRaw(requestParameters: DeleteFilterViewByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteFilterViewByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a filter view
     */
    async deleteFilterViewById(requestParameters: DeleteFilterViewByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFilterViewByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteOrganizationIPWhitelist without sending the request
     */
    async deleteOrganizationIPWhitelistRequestOpts(requestParameters: DeleteOrganizationIPWhitelistRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['ipAddress'] == null) {
            throw new runtime.RequiredError(
                'ipAddress',
                'Required parameter "ipAddress" was null or undefined when calling deleteOrganizationIPWhitelist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ip-whitelist/{ip_address}`;
        urlPath = urlPath.replace('{ip_address}', encodeURIComponent(String(requestParameters['ipAddress'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Remove an IP address from the organization\'s whitelist
     * Delete IP whitelist entry
     */
    async deleteOrganizationIPWhitelistRaw(requestParameters: DeleteOrganizationIPWhitelistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteOrganizationIPWhitelistResponse>> {
        const requestOptions = await this.deleteOrganizationIPWhitelistRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteOrganizationIPWhitelistResponseFromJSON(jsonValue));
    }

    /**
     * Remove an IP address from the organization\'s whitelist
     * Delete IP whitelist entry
     */
    async deleteOrganizationIPWhitelist(requestParameters: DeleteOrganizationIPWhitelistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteOrganizationIPWhitelistResponse> {
        const response = await this.deleteOrganizationIPWhitelistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteOrganizationStateById without sending the request
     */
    async deleteOrganizationStateByIdRequestOpts(requestParameters: DeleteOrganizationStateByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteOrganizationStateById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/organization-states/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a screener organization state
     */
    async deleteOrganizationStateByIdRaw(requestParameters: DeleteOrganizationStateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteOrganizationStateByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener organization state
     */
    async deleteOrganizationStateById(requestParameters: DeleteOrganizationStateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOrganizationStateByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteOrganizationStateTownById without sending the request
     */
    async deleteOrganizationStateTownByIdRequestOpts(requestParameters: DeleteOrganizationStateTownByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteOrganizationStateTownById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/organization-state-towns/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a screener organization state town
     */
    async deleteOrganizationStateTownByIdRaw(requestParameters: DeleteOrganizationStateTownByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteOrganizationStateTownByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener organization state town
     */
    async deleteOrganizationStateTownById(requestParameters: DeleteOrganizationStateTownByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOrganizationStateTownByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteReferralRecipientConfig without sending the request
     */
    async deleteReferralRecipientConfigRequestOpts(requestParameters: DeleteReferralRecipientConfigRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteReferralRecipientConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/referral-recipient-configs/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Soft-delete a referral recipient config
     */
    async deleteReferralRecipientConfigRaw(requestParameters: DeleteReferralRecipientConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReferralRecipientConfig200Response>> {
        const requestOptions = await this.deleteReferralRecipientConfigRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReferralRecipientConfig200ResponseFromJSON(jsonValue));
    }

    /**
     * Soft-delete a referral recipient config
     */
    async deleteReferralRecipientConfig(requestParameters: DeleteReferralRecipientConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReferralRecipientConfig200Response> {
        const response = await this.deleteReferralRecipientConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteScreenerAdmissionFlagById without sending the request
     */
    async deleteScreenerAdmissionFlagByIdRequestOpts(requestParameters: DeleteScreenerAdmissionFlagByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteScreenerAdmissionFlagById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-admission-flags/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a screener admission flag by ID
     */
    async deleteScreenerAdmissionFlagByIdRaw(requestParameters: DeleteScreenerAdmissionFlagByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteScreenerAdmissionFlagByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener admission flag by ID
     */
    async deleteScreenerAdmissionFlagById(requestParameters: DeleteScreenerAdmissionFlagByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScreenerAdmissionFlagByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteScreenerLeadTag without sending the request
     */
    async deleteScreenerLeadTagRequestOpts(requestParameters: DeleteScreenerLeadTagRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteScreenerLeadTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-lead-tags/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete screener lead tag
     * Delete screener lead tag
     */
    async deleteScreenerLeadTagRaw(requestParameters: DeleteScreenerLeadTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteScreenerLeadTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete screener lead tag
     * Delete screener lead tag
     */
    async deleteScreenerLeadTag(requestParameters: DeleteScreenerLeadTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScreenerLeadTagRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteScreenerTagById without sending the request
     */
    async deleteScreenerTagByIdRequestOpts(requestParameters: DeleteScreenerTagByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteScreenerTagById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-tags/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a screener tag by ID
     */
    async deleteScreenerTagByIdRaw(requestParameters: DeleteScreenerTagByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteScreenerTagByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener tag by ID
     */
    async deleteScreenerTagById(requestParameters: DeleteScreenerTagByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScreenerTagByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for editMissingInfoFollowUpDraft without sending the request
     */
    async editMissingInfoFollowUpDraftRequestOpts(requestParameters: EditMissingInfoFollowUpDraftOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling editMissingInfoFollowUpDraft().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling editMissingInfoFollowUpDraft().'
            );
        }

        if (requestParameters['editMissingInfoFollowUpDraftRequest'] == null) {
            throw new runtime.RequiredError(
                'editMissingInfoFollowUpDraftRequest',
                'Required parameter "editMissingInfoFollowUpDraftRequest" was null or undefined when calling editMissingInfoFollowUpDraft().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/missing-info-follow-ups/{id}/draft`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EditMissingInfoFollowUpDraftRequestToJSON(requestParameters['editMissingInfoFollowUpDraftRequest']),
        };
    }

    /**
     * Edit a missing-info follow-up draft
     */
    async editMissingInfoFollowUpDraftRaw(requestParameters: EditMissingInfoFollowUpDraftOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EditMissingInfoFollowUpDraft200Response>> {
        const requestOptions = await this.editMissingInfoFollowUpDraftRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EditMissingInfoFollowUpDraft200ResponseFromJSON(jsonValue));
    }

    /**
     * Edit a missing-info follow-up draft
     */
    async editMissingInfoFollowUpDraft(requestParameters: EditMissingInfoFollowUpDraftOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EditMissingInfoFollowUpDraft200Response> {
        const response = await this.editMissingInfoFollowUpDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for exchangeLead without sending the request
     */
    async exchangeLeadRequestOpts(requestParameters: ExchangeLeadOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling exchangeLead().'
            );
        }

        if (requestParameters['exchangeLeadRequest'] == null) {
            throw new runtime.RequiredError(
                'exchangeLeadRequest',
                'Required parameter "exchangeLeadRequest" was null or undefined when calling exchangeLead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/exchange`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExchangeLeadRequestToJSON(requestParameters['exchangeLeadRequest']),
        };
    }

    /**
     * Exchange a lead to another facility
     */
    async exchangeLeadRaw(requestParameters: ExchangeLeadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExchangeLeadResponse>> {
        const requestOptions = await this.exchangeLeadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExchangeLeadResponseFromJSON(jsonValue));
    }

    /**
     * Exchange a lead to another facility
     */
    async exchangeLead(requestParameters: ExchangeLeadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExchangeLeadResponse> {
        const response = await this.exchangeLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for executeBulkUploadDocuments without sending the request
     */
    async executeBulkUploadDocumentsRequestOpts(requestParameters: ExecuteBulkUploadDocumentsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling executeBulkUploadDocuments().'
            );
        }

        if (requestParameters['executeBulkUploadDocumentsRequest'] == null) {
            throw new runtime.RequiredError(
                'executeBulkUploadDocumentsRequest',
                'Required parameter "executeBulkUploadDocumentsRequest" was null or undefined when calling executeBulkUploadDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/bulk-upload-documents`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExecuteBulkUploadDocumentsRequestToJSON(requestParameters['executeBulkUploadDocumentsRequest']),
        };
    }

    /**
     * Upload the same document(s) to multiple instances
     */
    async executeBulkUploadDocumentsRaw(requestParameters: ExecuteBulkUploadDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExecuteInstanceBulkDecision200Response>> {
        const requestOptions = await this.executeBulkUploadDocumentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExecuteInstanceBulkDecision200ResponseFromJSON(jsonValue));
    }

    /**
     * Upload the same document(s) to multiple instances
     */
    async executeBulkUploadDocuments(requestParameters: ExecuteBulkUploadDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExecuteInstanceBulkDecision200Response> {
        const response = await this.executeBulkUploadDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for executeInstanceBulkDecision without sending the request
     */
    async executeInstanceBulkDecisionRequestOpts(requestParameters: ExecuteInstanceBulkDecisionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling executeInstanceBulkDecision().'
            );
        }

        if (requestParameters['instanceBulkDecisionRequest'] == null) {
            throw new runtime.RequiredError(
                'instanceBulkDecisionRequest',
                'Required parameter "instanceBulkDecisionRequest" was null or undefined when calling executeInstanceBulkDecision().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/bulk-decision`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InstanceBulkDecisionRequestToJSON(requestParameters['instanceBulkDecisionRequest']),
        };
    }

    /**
     * Apply a review stage decision to multiple instances
     */
    async executeInstanceBulkDecisionRaw(requestParameters: ExecuteInstanceBulkDecisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExecuteInstanceBulkDecision200Response>> {
        const requestOptions = await this.executeInstanceBulkDecisionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExecuteInstanceBulkDecision200ResponseFromJSON(jsonValue));
    }

    /**
     * Apply a review stage decision to multiple instances
     */
    async executeInstanceBulkDecision(requestParameters: ExecuteInstanceBulkDecisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExecuteInstanceBulkDecision200Response> {
        const response = await this.executeInstanceBulkDecisionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for executeInstanceBulkLost without sending the request
     */
    async executeInstanceBulkLostRequestOpts(requestParameters: ExecuteInstanceBulkLostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling executeInstanceBulkLost().'
            );
        }

        if (requestParameters['instanceBulkLostRequest'] == null) {
            throw new runtime.RequiredError(
                'instanceBulkLostRequest',
                'Required parameter "instanceBulkLostRequest" was null or undefined when calling executeInstanceBulkLost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/bulk-lost`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InstanceBulkLostRequestToJSON(requestParameters['instanceBulkLostRequest']),
        };
    }

    /**
     * Mark multiple instances as Lost
     */
    async executeInstanceBulkLostRaw(requestParameters: ExecuteInstanceBulkLostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExecuteInstanceBulkDecision200Response>> {
        const requestOptions = await this.executeInstanceBulkLostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExecuteInstanceBulkDecision200ResponseFromJSON(jsonValue));
    }

    /**
     * Mark multiple instances as Lost
     */
    async executeInstanceBulkLost(requestParameters: ExecuteInstanceBulkLostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExecuteInstanceBulkDecision200Response> {
        const response = await this.executeInstanceBulkLostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllBedRooms without sending the request
     */
    async findAllBedRoomsRequestOpts(requestParameters: FindAllBedRoomsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['unitId'] == null) {
            throw new runtime.RequiredError(
                'unitId',
                'Required parameter "unitId" was null or undefined when calling findAllBedRooms().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['unitId'] != null) {
            queryParameters['unit_id'] = requestParameters['unitId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/bed-rooms`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all bed rooms
     * Find all bed rooms
     */
    async findAllBedRoomsRaw(requestParameters: FindAllBedRoomsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllBedRooms200Response>> {
        const requestOptions = await this.findAllBedRoomsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllBedRooms200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all bed rooms
     * Find all bed rooms
     */
    async findAllBedRooms(requestParameters: FindAllBedRoomsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllBedRooms200Response> {
        const response = await this.findAllBedRoomsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllBedTypes without sending the request
     */
    async findAllBedTypesRequestOpts(requestParameters: FindAllBedTypesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllBedTypes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/bed-types`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve bed types
     * Fine all bed types
     */
    async findAllBedTypesRaw(requestParameters: FindAllBedTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllBedTypes200Response>> {
        const requestOptions = await this.findAllBedTypesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllBedTypes200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve bed types
     * Fine all bed types
     */
    async findAllBedTypes(requestParameters: FindAllBedTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllBedTypes200Response> {
        const response = await this.findAllBedTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllBeds without sending the request
     */
    async findAllBedsRequestOpts(requestParameters: FindAllBedsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllBeds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['bedTypeIds'] != null) {
            queryParameters['bed_type_ids'] = requestParameters['bedTypeIds'];
        }

        if (requestParameters['includeOccupied'] != null) {
            queryParameters['include_occupied'] = requestParameters['includeOccupied'];
        }

        if (requestParameters['availabilityFrom'] != null) {
            queryParameters['availability_from'] = requestParameters['availabilityFrom'];
        }

        if (requestParameters['availabilityTo'] != null) {
            queryParameters['availability_to'] = requestParameters['availabilityTo'];
        }

        if (requestParameters['roomId'] != null) {
            queryParameters['room_id'] = requestParameters['roomId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/beds`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve beds for a facility
     * Find all beds
     */
    async findAllBedsRaw(requestParameters: FindAllBedsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllBeds200Response>> {
        const requestOptions = await this.findAllBedsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllBeds200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve beds for a facility
     * Find all beds
     */
    async findAllBeds(requestParameters: FindAllBedsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllBeds200Response> {
        const response = await this.findAllBedsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllCriteria without sending the request
     */
    async findAllCriteriaRequestOpts(requestParameters: FindAllCriteriaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllCriteria().'
            );
        }

        if (requestParameters['isInformational'] == null) {
            throw new runtime.RequiredError(
                'isInformational',
                'Required parameter "isInformational" was null or undefined when calling findAllCriteria().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['isInformational'] != null) {
            queryParameters['is_informational'] = requestParameters['isInformational'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/criteria`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all criteria
     * Find all criteria
     */
    async findAllCriteriaRaw(requestParameters: FindAllCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllCriteria200Response>> {
        const requestOptions = await this.findAllCriteriaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllCriteria200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all criteria
     * Find all criteria
     */
    async findAllCriteria(requestParameters: FindAllCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllCriteria200Response> {
        const response = await this.findAllCriteriaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllCriteriaCategories without sending the request
     */
    async findAllCriteriaCategoriesRequestOpts(requestParameters: FindAllCriteriaCategoriesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/criteria/categories`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all criteria categories
     * Find all criteria categories
     */
    async findAllCriteriaCategoriesRaw(requestParameters: FindAllCriteriaCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllCriteriaCategories200Response>> {
        const requestOptions = await this.findAllCriteriaCategoriesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllCriteriaCategories200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all criteria categories
     * Find all criteria categories
     */
    async findAllCriteriaCategories(requestParameters: FindAllCriteriaCategoriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllCriteriaCategories200Response> {
        const response = await this.findAllCriteriaCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllCriteriaTargets without sending the request
     */
    async findAllCriteriaTargetsRequestOpts(requestParameters: FindAllCriteriaTargetsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['criteriaType'] != null) {
            queryParameters['criteria_type'] = requestParameters['criteriaType'];
        }

        if (requestParameters['categoryId'] != null) {
            queryParameters['category_id'] = requestParameters['categoryId'];
        }

        if (requestParameters['qualifier'] != null) {
            queryParameters['qualifier'] = requestParameters['qualifier'];
        }

        if (requestParameters['appliesToFacilityId'] != null) {
            queryParameters['applies_to_facility_id'] = requestParameters['appliesToFacilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/criteria/targets`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all criteria grouped with their facility/system-tag targets
     * Find all criteria targets
     */
    async findAllCriteriaTargetsRaw(requestParameters: FindAllCriteriaTargetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllCriteriaTargets200Response>> {
        const requestOptions = await this.findAllCriteriaTargetsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllCriteriaTargets200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all criteria grouped with their facility/system-tag targets
     * Find all criteria targets
     */
    async findAllCriteriaTargets(requestParameters: FindAllCriteriaTargetsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllCriteriaTargets200Response> {
        const response = await this.findAllCriteriaTargetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllExecutionsAvailableByFacilityId without sending the request
     */
    async findAllExecutionsAvailableByFacilityIdRequestOpts(requestParameters: FindAllExecutionsAvailableByFacilityIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityIds'] == null) {
            throw new runtime.RequiredError(
                'facilityIds',
                'Required parameter "facilityIds" was null or undefined when calling findAllExecutionsAvailableByFacilityId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityIds'] != null) {
            queryParameters['facility_ids'] = requestParameters['facilityIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/executions-available`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get screener executions available for facilites
     */
    async findAllExecutionsAvailableByFacilityIdRaw(requestParameters: FindAllExecutionsAvailableByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllExecutionsAvailableByFacilityId200Response>> {
        const requestOptions = await this.findAllExecutionsAvailableByFacilityIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllExecutionsAvailableByFacilityId200ResponseFromJSON(jsonValue));
    }

    /**
     * Get screener executions available for facilites
     */
    async findAllExecutionsAvailableByFacilityId(requestParameters: FindAllExecutionsAvailableByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllExecutionsAvailableByFacilityId200Response> {
        const response = await this.findAllExecutionsAvailableByFacilityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllFacilityCustomTags without sending the request
     */
    async findAllFacilityCustomTagsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facility-custom-tags`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List the organization\'s facility custom tags
     */
    async findAllFacilityCustomTagsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllFacilityCustomTags200Response>> {
        const requestOptions = await this.findAllFacilityCustomTagsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllFacilityCustomTags200ResponseFromJSON(jsonValue));
    }

    /**
     * List the organization\'s facility custom tags
     */
    async findAllFacilityCustomTags(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllFacilityCustomTags200Response> {
        const response = await this.findAllFacilityCustomTagsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllFacilityRegions without sending the request
     */
    async findAllFacilityRegionsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facility-regions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List the organization\'s facility regions
     */
    async findAllFacilityRegionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllFacilityRegions200Response>> {
        const requestOptions = await this.findAllFacilityRegionsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllFacilityRegions200ResponseFromJSON(jsonValue));
    }

    /**
     * List the organization\'s facility regions
     */
    async findAllFacilityRegions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllFacilityRegions200Response> {
        const response = await this.findAllFacilityRegionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllFacilityServiceAreas without sending the request
     */
    async findAllFacilityServiceAreasRequestOpts(requestParameters: FindAllFacilityServiceAreasRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllFacilityServiceAreas().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{facility_id}/service-areas`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the facility\'s configured service areas (Accept/Review/Decline). Returns an empty list when the `service_area_enabled` screener setting is not Enabled for the facility. 
     * Find all service areas for a facility
     */
    async findAllFacilityServiceAreasRaw(requestParameters: FindAllFacilityServiceAreasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllFacilityServiceAreas200Response>> {
        const requestOptions = await this.findAllFacilityServiceAreasRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllFacilityServiceAreas200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the facility\'s configured service areas (Accept/Review/Decline). Returns an empty list when the `service_area_enabled` screener setting is not Enabled for the facility. 
     * Find all service areas for a facility
     */
    async findAllFacilityServiceAreas(requestParameters: FindAllFacilityServiceAreasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllFacilityServiceAreas200Response> {
        const response = await this.findAllFacilityServiceAreasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllFaxes without sending the request
     */
    async findAllFaxesRequestOpts(requestParameters: FindAllFaxesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['facilityType'] != null) {
            queryParameters['facility_type'] = requestParameters['facilityType'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/efax/faxes`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a paginated list of faxes a facility or organization has received
     */
    async findAllFaxesRaw(requestParameters: FindAllFaxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllFaxes200Response>> {
        const requestOptions = await this.findAllFaxesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllFaxes200ResponseFromJSON(jsonValue));
    }

    /**
     * Get a paginated list of faxes a facility or organization has received
     */
    async findAllFaxes(requestParameters: FindAllFaxesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllFaxes200Response> {
        const response = await this.findAllFaxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllFilterViews without sending the request
     */
    async findAllFilterViewsRequestOpts(requestParameters: FindAllFilterViewsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['scope'] == null) {
            throw new runtime.RequiredError(
                'scope',
                'Required parameter "scope" was null or undefined when calling findAllFilterViews().'
            );
        }

        if (requestParameters['viewKey'] == null) {
            throw new runtime.RequiredError(
                'viewKey',
                'Required parameter "viewKey" was null or undefined when calling findAllFilterViews().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        if (requestParameters['viewKey'] != null) {
            queryParameters['view_key'] = requestParameters['viewKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/filter-views`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find all filter views for the current user and scope
     */
    async findAllFilterViewsRaw(requestParameters: FindAllFilterViewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllFilterViews200Response>> {
        const requestOptions = await this.findAllFilterViewsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllFilterViews200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all filter views for the current user and scope
     */
    async findAllFilterViews(requestParameters: FindAllFilterViewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllFilterViews200Response> {
        const response = await this.findAllFilterViewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllIcd10Codes without sending the request
     */
    async findAllIcd10CodesRequestOpts(requestParameters: FindAllIcd10CodesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/icd10-codes`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find all ICD 10 codes
     */
    async findAllIcd10CodesRaw(requestParameters: FindAllIcd10CodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllIcd10Codes200Response>> {
        const requestOptions = await this.findAllIcd10CodesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllIcd10Codes200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all ICD 10 codes
     */
    async findAllIcd10Codes(requestParameters: FindAllIcd10CodesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllIcd10Codes200Response> {
        const response = await this.findAllIcd10CodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllIntegrationEventsByFacilityId without sending the request
     */
    async findAllIntegrationEventsByFacilityIdRequestOpts(requestParameters: FindAllIntegrationEventsByFacilityIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllIntegrationEventsByFacilityId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/integration-events/{facility_id}`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find all integration events by facility ID
     */
    async findAllIntegrationEventsByFacilityIdRaw(requestParameters: FindAllIntegrationEventsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllIntegrationEventsByFacilityId200Response>> {
        const requestOptions = await this.findAllIntegrationEventsByFacilityIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllIntegrationEventsByFacilityId200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all integration events by facility ID
     */
    async findAllIntegrationEventsByFacilityId(requestParameters: FindAllIntegrationEventsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllIntegrationEventsByFacilityId200Response> {
        const response = await this.findAllIntegrationEventsByFacilityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllOrganizationIPWhitelist without sending the request
     */
    async findAllOrganizationIPWhitelistRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ip-whitelist`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all IP addresses whitelisted for an organization
     * Find all IP whitelist entries for an organization
     */
    async findAllOrganizationIPWhitelistRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllOrganizationIPWhitelistResponse>> {
        const requestOptions = await this.findAllOrganizationIPWhitelistRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllOrganizationIPWhitelistResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all IP addresses whitelisted for an organization
     * Find all IP whitelist entries for an organization
     */
    async findAllOrganizationIPWhitelist(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllOrganizationIPWhitelistResponse> {
        const response = await this.findAllOrganizationIPWhitelistRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllOrganizationStates without sending the request
     */
    async findAllOrganizationStatesRequestOpts(requestParameters: FindAllOrganizationStatesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling findAllOrganizationStates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/organization-states`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fine all organization states
     */
    async findAllOrganizationStatesRaw(requestParameters: FindAllOrganizationStatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllOrganizationStates200Response>> {
        const requestOptions = await this.findAllOrganizationStatesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllOrganizationStates200ResponseFromJSON(jsonValue));
    }

    /**
     * Fine all organization states
     */
    async findAllOrganizationStates(requestParameters: FindAllOrganizationStatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllOrganizationStates200Response> {
        const response = await this.findAllOrganizationStatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllReferralCareAttributes without sending the request
     */
    async findAllReferralCareAttributesRequestOpts(requestParameters: FindAllReferralCareAttributesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllReferralCareAttributes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['category'] != null) {
            queryParameters['category'] = requestParameters['category'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/referral-care-attributes`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get referral care attributes applicable to a facility
     */
    async findAllReferralCareAttributesRaw(requestParameters: FindAllReferralCareAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllReferralCareAttributes200Response>> {
        const requestOptions = await this.findAllReferralCareAttributesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllReferralCareAttributes200ResponseFromJSON(jsonValue));
    }

    /**
     * Get referral care attributes applicable to a facility
     */
    async findAllReferralCareAttributes(requestParameters: FindAllReferralCareAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllReferralCareAttributes200Response> {
        const response = await this.findAllReferralCareAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllReferralRecipientConfigs without sending the request
     */
    async findAllReferralRecipientConfigsRequestOpts(requestParameters: FindAllReferralRecipientConfigsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['senderFacilityId'] != null) {
            queryParameters['sender_facility_id'] = requestParameters['senderFacilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/referral-recipient-configs`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List active referral recipient configs for accessible sender facilities
     */
    async findAllReferralRecipientConfigsRaw(requestParameters: FindAllReferralRecipientConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllReferralRecipientConfigs200Response>> {
        const requestOptions = await this.findAllReferralRecipientConfigsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllReferralRecipientConfigs200ResponseFromJSON(jsonValue));
    }

    /**
     * List active referral recipient configs for accessible sender facilities
     */
    async findAllReferralRecipientConfigs(requestParameters: FindAllReferralRecipientConfigsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllReferralRecipientConfigs200Response> {
        const response = await this.findAllReferralRecipientConfigsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllScheduledScreenerResidents without sending the request
     */
    async findAllScheduledScreenerResidentsRequestOpts(requestParameters: FindAllScheduledScreenerResidentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllScheduledScreenerResidents().'
            );
        }

        if (requestParameters['scheduledOccupancyType'] == null) {
            throw new runtime.RequiredError(
                'scheduledOccupancyType',
                'Required parameter "scheduledOccupancyType" was null or undefined when calling findAllScheduledScreenerResidents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = runtime.serializeDate(requestParameters['startDate'] as any);
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = runtime.serializeDate(requestParameters['endDate'] as any);
        }

        if (requestParameters['scheduledOccupancyType'] != null) {
            queryParameters['scheduled_occupancy_type'] = requestParameters['scheduledOccupancyType'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sourceId'] != null) {
            queryParameters['source_id'] = requestParameters['sourceId'];
        }

        if (requestParameters['connector'] != null) {
            queryParameters['connector'] = requestParameters['connector'];
        }

        if (requestParameters['bedTypeId'] != null) {
            queryParameters['bed_type_id'] = requestParameters['bedTypeId'];
        }

        if (requestParameters['includeCancelled'] != null) {
            queryParameters['include_cancelled'] = requestParameters['includeCancelled'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-residents/scheduled-occupancies`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all scheduled screener residents
     * Find all scheduled screener residents
     */
    async findAllScheduledScreenerResidentsRaw(requestParameters: FindAllScheduledScreenerResidentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerResidents200Response>> {
        const requestOptions = await this.findAllScheduledScreenerResidentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerResidents200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all scheduled screener residents
     * Find all scheduled screener residents
     */
    async findAllScheduledScreenerResidents(requestParameters: FindAllScheduledScreenerResidentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerResidents200Response> {
        const response = await this.findAllScheduledScreenerResidentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllScreenerAdmissionFlags without sending the request
     */
    async findAllScreenerAdmissionFlagsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-admission-flags`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all screener admission flags
     */
    async findAllScreenerAdmissionFlagsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerAdmissionFlags200Response>> {
        const requestOptions = await this.findAllScreenerAdmissionFlagsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerAdmissionFlags200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all screener admission flags
     */
    async findAllScreenerAdmissionFlags(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerAdmissionFlags200Response> {
        const response = await this.findAllScreenerAdmissionFlagsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllScreenerBedUnits without sending the request
     */
    async findAllScreenerBedUnitsRequestOpts(requestParameters: FindAllScreenerBedUnitsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllScreenerBedUnits().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-bed-units`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all screener bed units
     * Find all screener bed units
     */
    async findAllScreenerBedUnitsRaw(requestParameters: FindAllScreenerBedUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerBedUnits200Response>> {
        const requestOptions = await this.findAllScreenerBedUnitsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerBedUnits200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all screener bed units
     * Find all screener bed units
     */
    async findAllScreenerBedUnits(requestParameters: FindAllScreenerBedUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerBedUnits200Response> {
        const response = await this.findAllScreenerBedUnitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllScreenerLeadWaitlist without sending the request
     */
    async findAllScreenerLeadWaitlistRequestOpts(requestParameters: FindAllScreenerLeadWaitlistRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllScreenerLeadWaitlist().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sourceId'] != null) {
            queryParameters['source_id'] = requestParameters['sourceId'];
        }

        if (requestParameters['admissionStatus'] != null) {
            queryParameters['admission_status'] = requestParameters['admissionStatus'];
        }

        if (requestParameters['statusId'] != null) {
            queryParameters['status_id'] = requestParameters['statusId'];
        }

        if (requestParameters['includeEmptyAdmission'] != null) {
            queryParameters['include_empty_admission'] = requestParameters['includeEmptyAdmission'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/waitlist`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve screener leads in waitlist
     * Get all leads in waitlist
     */
    async findAllScreenerLeadWaitlistRaw(requestParameters: FindAllScreenerLeadWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerLeadWaitlist200Response>> {
        const requestOptions = await this.findAllScreenerLeadWaitlistRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerLeadWaitlist200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve screener leads in waitlist
     * Get all leads in waitlist
     */
    async findAllScreenerLeadWaitlist(requestParameters: FindAllScreenerLeadWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerLeadWaitlist200Response> {
        const response = await this.findAllScreenerLeadWaitlistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllScreenerResidents without sending the request
     */
    async findAllScreenerResidentsRequestOpts(requestParameters: FindAllScreenerResidentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllScreenerResidents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sourceId'] != null) {
            queryParameters['source_id'] = requestParameters['sourceId'];
        }

        if (requestParameters['bedTypeId'] != null) {
            queryParameters['bed_type_id'] = requestParameters['bedTypeId'];
        }

        if (requestParameters['onlyTodayActivity'] != null) {
            queryParameters['only_today_activity'] = requestParameters['onlyTodayActivity'];
        }

        if (requestParameters['stayType'] != null) {
            queryParameters['stay_type'] = requestParameters['stayType'];
        }

        if (requestParameters['payerType'] != null) {
            queryParameters['payer_type'] = requestParameters['payerType'];
        }

        if (requestParameters['payer'] != null) {
            queryParameters['payer'] = requestParameters['payer'];
        }

        if (requestParameters['payerSource'] != null) {
            queryParameters['payer_source'] = requestParameters['payerSource'];
        }

        if (requestParameters['includeNullPayerType'] != null) {
            queryParameters['include_null_payer_type'] = requestParameters['includeNullPayerType'];
        }

        if (requestParameters['includeNullPayerSource'] != null) {
            queryParameters['include_null_payer_source'] = requestParameters['includeNullPayerSource'];
        }

        if (requestParameters['admissionStatus'] != null) {
            queryParameters['admission_status'] = requestParameters['admissionStatus'];
        }

        if (requestParameters['clinicalCareNeeds'] != null) {
            queryParameters['clinical_care_needs'] = requestParameters['clinicalCareNeeds'];
        }

        if (requestParameters['programs'] != null) {
            queryParameters['programs'] = requestParameters['programs'];
        }

        if (requestParameters['typesOfCare'] != null) {
            queryParameters['types_of_care'] = requestParameters['typesOfCare'];
        }

        if (requestParameters['tags'] != null) {
            queryParameters['tags'] = requestParameters['tags'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-residents`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve screener residents for a facility
     * Find all screener residents
     */
    async findAllScreenerResidentsRaw(requestParameters: FindAllScreenerResidentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerResidents200Response>> {
        const requestOptions = await this.findAllScreenerResidentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerResidents200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve screener residents for a facility
     * Find all screener residents
     */
    async findAllScreenerResidents(requestParameters: FindAllScreenerResidentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerResidents200Response> {
        const response = await this.findAllScreenerResidentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllScreenerTags without sending the request
     */
    async findAllScreenerTagsRequestOpts(requestParameters: FindAllScreenerTagsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllScreenerTags().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-tags`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all screener tags
     */
    async findAllScreenerTagsRaw(requestParameters: FindAllScreenerTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerTags200Response>> {
        const requestOptions = await this.findAllScreenerTagsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerTags200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all screener tags
     */
    async findAllScreenerTags(requestParameters: FindAllScreenerTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerTags200Response> {
        const response = await this.findAllScreenerTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllSourceAllowNames without sending the request
     */
    async findAllSourceAllowNamesRequestOpts(requestParameters: FindAllSourceAllowNamesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling findAllSourceAllowNames().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/source-allow-names/{facility_id}`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find all source allow names for a facility
     * Find all source allow names
     */
    async findAllSourceAllowNamesRaw(requestParameters: FindAllSourceAllowNamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllSourceAllowNames200Response>> {
        const requestOptions = await this.findAllSourceAllowNamesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllSourceAllowNames200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all source allow names for a facility
     * Find all source allow names
     */
    async findAllSourceAllowNames(requestParameters: FindAllSourceAllowNamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllSourceAllowNames200Response> {
        const response = await this.findAllSourceAllowNamesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllSourceOptions without sending the request
     */
    async findAllSourceOptionsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/sources/options`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all non-deleted sources for the organization as lightweight picker options
     * Find all source options
     */
    async findAllSourceOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllSourceOptions200Response>> {
        const requestOptions = await this.findAllSourceOptionsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllSourceOptions200ResponseFromJSON(jsonValue));
    }

    /**
     * List all non-deleted sources for the organization as lightweight picker options
     * Find all source options
     */
    async findAllSourceOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllSourceOptions200Response> {
        const response = await this.findAllSourceOptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllSourceTags without sending the request
     */
    async findAllSourceTagsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/source-tags`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all screener source tags
     */
    async findAllSourceTagsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllSourceTags200Response>> {
        const requestOptions = await this.findAllSourceTagsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllSourceTags200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all screener source tags
     */
    async findAllSourceTags(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllSourceTags200Response> {
        const response = await this.findAllSourceTagsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findBulkUploadDocumentCandidates without sending the request
     */
    async findBulkUploadDocumentCandidatesRequestOpts(requestParameters: FindBulkUploadDocumentCandidatesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findBulkUploadDocumentCandidates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/bulk-upload-document-candidates`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find eligible instances to apply a bulk document upload to
     */
    async findBulkUploadDocumentCandidatesRaw(requestParameters: FindBulkUploadDocumentCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindInstanceBulkDecisionCandidates200Response>> {
        const requestOptions = await this.findBulkUploadDocumentCandidatesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindInstanceBulkDecisionCandidates200ResponseFromJSON(jsonValue));
    }

    /**
     * Find eligible instances to apply a bulk document upload to
     */
    async findBulkUploadDocumentCandidates(requestParameters: FindBulkUploadDocumentCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindInstanceBulkDecisionCandidates200Response> {
        const response = await this.findBulkUploadDocumentCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findHomeHealthPractitionerAssignments without sending the request
     */
    async findHomeHealthPractitionerAssignmentsRequestOpts(requestParameters: FindHomeHealthPractitionerAssignmentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findHomeHealthPractitionerAssignments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/home-health-practitioner-assignments`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List current home-health practitioner assignments for a lead
     */
    async findHomeHealthPractitionerAssignmentsRaw(requestParameters: FindHomeHealthPractitionerAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindHomeHealthPractitionerAssignments200Response>> {
        const requestOptions = await this.findHomeHealthPractitionerAssignmentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindHomeHealthPractitionerAssignments200ResponseFromJSON(jsonValue));
    }

    /**
     * List current home-health practitioner assignments for a lead
     */
    async findHomeHealthPractitionerAssignments(requestParameters: FindHomeHealthPractitionerAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindHomeHealthPractitionerAssignments200Response> {
        const response = await this.findHomeHealthPractitionerAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findInstanceBulkDecisionCandidates without sending the request
     */
    async findInstanceBulkDecisionCandidatesRequestOpts(requestParameters: FindInstanceBulkDecisionCandidatesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findInstanceBulkDecisionCandidates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/bulk-decision-candidates`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find eligible and excluded instances for a bulk review stage decision
     */
    async findInstanceBulkDecisionCandidatesRaw(requestParameters: FindInstanceBulkDecisionCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindInstanceBulkDecisionCandidates200Response>> {
        const requestOptions = await this.findInstanceBulkDecisionCandidatesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindInstanceBulkDecisionCandidates200ResponseFromJSON(jsonValue));
    }

    /**
     * Find eligible and excluded instances for a bulk review stage decision
     */
    async findInstanceBulkDecisionCandidates(requestParameters: FindInstanceBulkDecisionCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindInstanceBulkDecisionCandidates200Response> {
        const response = await this.findInstanceBulkDecisionCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findInstanceBulkLostCandidates without sending the request
     */
    async findInstanceBulkLostCandidatesRequestOpts(requestParameters: FindInstanceBulkLostCandidatesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findInstanceBulkLostCandidates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/bulk-lost-candidates`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find eligible and excluded instances for a bulk mark as lost
     */
    async findInstanceBulkLostCandidatesRaw(requestParameters: FindInstanceBulkLostCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindInstanceBulkDecisionCandidates200Response>> {
        const requestOptions = await this.findInstanceBulkLostCandidatesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindInstanceBulkDecisionCandidates200ResponseFromJSON(jsonValue));
    }

    /**
     * Find eligible and excluded instances for a bulk mark as lost
     */
    async findInstanceBulkLostCandidates(requestParameters: FindInstanceBulkLostCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindInstanceBulkDecisionCandidates200Response> {
        const response = await this.findInstanceBulkLostCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findOneBed without sending the request
     */
    async findOneBedRequestOpts(requestParameters: FindOneBedRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['bedId'] == null) {
            throw new runtime.RequiredError(
                'bedId',
                'Required parameter "bedId" was null or undefined when calling findOneBed().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/beds/{bed_id}`;
        urlPath = urlPath.replace('{bed_id}', encodeURIComponent(String(requestParameters['bedId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find a bed by ID
     */
    async findOneBedRaw(requestParameters: FindOneBedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneBed200Response>> {
        const requestOptions = await this.findOneBedRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneBed200ResponseFromJSON(jsonValue));
    }

    /**
     * Find a bed by ID
     */
    async findOneBed(requestParameters: FindOneBedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneBed200Response> {
        const response = await this.findOneBedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findOneMatrixCarePatientDetails without sending the request
     */
    async findOneMatrixCarePatientDetailsRequestOpts(requestParameters: FindOneMatrixCarePatientDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling findOneMatrixCarePatientDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/matrix-care/patient/details`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find One MatrixCare patient\'s details
     */
    async findOneMatrixCarePatientDetailsRaw(requestParameters: FindOneMatrixCarePatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneMatrixCarePatientDetails200Response>> {
        const requestOptions = await this.findOneMatrixCarePatientDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneMatrixCarePatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Find One MatrixCare patient\'s details
     */
    async findOneMatrixCarePatientDetails(requestParameters: FindOneMatrixCarePatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneMatrixCarePatientDetails200Response> {
        const response = await this.findOneMatrixCarePatientDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAllowedRecipients without sending the request
     */
    async getAllowedRecipientsRequestOpts(requestParameters: GetAllowedRecipientsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['senderFacilityId'] == null) {
            throw new runtime.RequiredError(
                'senderFacilityId',
                'Required parameter "senderFacilityId" was null or undefined when calling getAllowedRecipients().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['senderFacilityId'] != null) {
            queryParameters['sender_facility_id'] = requestParameters['senderFacilityId'];
        }

        if (requestParameters['referralType'] != null) {
            queryParameters['referral_type'] = requestParameters['referralType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/referrals/allowed-recipients`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the allowed Dialyze Direct recipient facilities for a given sender SNF facility
     */
    async getAllowedRecipientsRaw(requestParameters: GetAllowedRecipientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllowedRecipients200Response>> {
        const requestOptions = await this.getAllowedRecipientsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllowedRecipients200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the allowed Dialyze Direct recipient facilities for a given sender SNF facility
     */
    async getAllowedRecipients(requestParameters: GetAllowedRecipientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllowedRecipients200Response> {
        const response = await this.getAllowedRecipientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAnalysisResultHistory without sending the request
     */
    async getAnalysisResultHistoryRequestOpts(requestParameters: GetAnalysisResultHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getAnalysisResultHistory().'
            );
        }

        if (requestParameters['resultId'] == null) {
            throw new runtime.RequiredError(
                'resultId',
                'Required parameter "resultId" was null or undefined when calling getAnalysisResultHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/analysis-results/{result_id}/history`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{result_id}', encodeURIComponent(String(requestParameters['resultId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve the override history for a specific analysis result
     * Get analysis result override history
     */
    async getAnalysisResultHistoryRaw(requestParameters: GetAnalysisResultHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAnalysisResultHistory200Response>> {
        const requestOptions = await this.getAnalysisResultHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAnalysisResultHistory200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve the override history for a specific analysis result
     * Get analysis result override history
     */
    async getAnalysisResultHistory(requestParameters: GetAnalysisResultHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAnalysisResultHistory200Response> {
        const response = await this.getAnalysisResultHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDocumentExclusionTerms without sending the request
     */
    async getDocumentExclusionTermsRequestOpts(requestParameters: GetDocumentExclusionTermsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling getDocumentExclusionTerms().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/document-exclusion-terms`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve document exclusion terms for a facility
     * Get document exclusion terms
     */
    async getDocumentExclusionTermsRaw(requestParameters: GetDocumentExclusionTermsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDocumentExclusionTerms200Response>> {
        const requestOptions = await this.getDocumentExclusionTermsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDocumentExclusionTerms200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve document exclusion terms for a facility
     * Get document exclusion terms
     */
    async getDocumentExclusionTerms(requestParameters: GetDocumentExclusionTermsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDocumentExclusionTerms200Response> {
        const response = await this.getDocumentExclusionTermsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getFacilityBedOccupancyStats without sending the request
     */
    async getFacilityBedOccupancyStatsRequestOpts(requestParameters: GetFacilityBedOccupancyStatsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling getFacilityBedOccupancyStats().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-residents/stats`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve facility bed occupancy stats
     * Get facility bed occupancy stats
     */
    async getFacilityBedOccupancyStatsRaw(requestParameters: GetFacilityBedOccupancyStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacilityBedOccupancyStats200Response>> {
        const requestOptions = await this.getFacilityBedOccupancyStatsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacilityBedOccupancyStats200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve facility bed occupancy stats
     * Get facility bed occupancy stats
     */
    async getFacilityBedOccupancyStats(requestParameters: GetFacilityBedOccupancyStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacilityBedOccupancyStats200Response> {
        const response = await this.getFacilityBedOccupancyStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getFacilityInvoiceStatuses without sending the request
     */
    async getFacilityInvoiceStatusesRequestOpts(requestParameters: GetFacilityInvoiceStatusesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling getFacilityInvoiceStatuses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{facility_id}/invoice-statuses`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve unpaid invoice statuses for a facility including organization-level payers
     * Get unpaid invoice statuses
     */
    async getFacilityInvoiceStatusesRaw(requestParameters: GetFacilityInvoiceStatusesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacilityInvoiceStatuses200Response>> {
        const requestOptions = await this.getFacilityInvoiceStatusesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacilityInvoiceStatuses200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve unpaid invoice statuses for a facility including organization-level payers
     * Get unpaid invoice statuses
     */
    async getFacilityInvoiceStatuses(requestParameters: GetFacilityInvoiceStatusesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacilityInvoiceStatuses200Response> {
        const response = await this.getFacilityInvoiceStatusesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getFacilityScreenerSettings without sending the request
     */
    async getFacilityScreenerSettingsRequestOpts(requestParameters: GetFacilityScreenerSettingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityIds'] == null) {
            throw new runtime.RequiredError(
                'facilityIds',
                'Required parameter "facilityIds" was null or undefined when calling getFacilityScreenerSettings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityIds'] != null) {
            queryParameters['facility_ids'] = requestParameters['facilityIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facility-screener-settings`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve all FE-readable screener settings (resolved via facility > org > default hierarchy) for the provided facility IDs.
     * Get FE-readable screener settings for multiple facilities
     */
    async getFacilityScreenerSettingsRaw(requestParameters: GetFacilityScreenerSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacilityScreenerSettings200Response>> {
        const requestOptions = await this.getFacilityScreenerSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacilityScreenerSettings200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all FE-readable screener settings (resolved via facility > org > default hierarchy) for the provided facility IDs.
     * Get FE-readable screener settings for multiple facilities
     */
    async getFacilityScreenerSettings(requestParameters: GetFacilityScreenerSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacilityScreenerSettings200Response> {
        const response = await this.getFacilityScreenerSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getLeadDiagnoses without sending the request
     */
    async getLeadDiagnosesRequestOpts(requestParameters: GetLeadDiagnosesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getLeadDiagnoses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-leads/{lead_id}/diagnoses`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get generated ICD-10 diagnoses for a lead
     */
    async getLeadDiagnosesRaw(requestParameters: GetLeadDiagnosesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeadDiagnoses200Response>> {
        const requestOptions = await this.getLeadDiagnosesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeadDiagnoses200ResponseFromJSON(jsonValue));
    }

    /**
     * Get generated ICD-10 diagnoses for a lead
     */
    async getLeadDiagnoses(requestParameters: GetLeadDiagnosesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeadDiagnoses200Response> {
        const response = await this.getLeadDiagnosesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getLeadExchangeDestinations without sending the request
     */
    async getLeadExchangeDestinationsRequestOpts(requestParameters: GetLeadExchangeDestinationsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling getLeadExchangeDestinations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{facility_id}/exchange-destinations`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * `facility_id` is the referral\'s **originating** facility - the facility that first received it - which for a lead is `original_facility_id ?? facility_id`.  Returns `disabled` when the `lead_exchange` screener setting is not enabled for the originating facility, `no_destinations` when nothing the caller can access is eligible, and otherwise the eligible facilities. Eligibility is the configured destination override list for the originating facility (an empty configuration means every facility in the organization) intersected with the caller\'s facility access. The originating facility itself is always eligible so a moved referral can be sent back.  Callers must drop the referral\'s current facility from the returned list: a referral cannot be moved to the facility it already sits in. 
     * Find the facilities a referral originating at this facility may be moved to
     */
    async getLeadExchangeDestinationsRaw(requestParameters: GetLeadExchangeDestinationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeadExchangeDestinationsResponse>> {
        const requestOptions = await this.getLeadExchangeDestinationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeadExchangeDestinationsResponseFromJSON(jsonValue));
    }

    /**
     * `facility_id` is the referral\'s **originating** facility - the facility that first received it - which for a lead is `original_facility_id ?? facility_id`.  Returns `disabled` when the `lead_exchange` screener setting is not enabled for the originating facility, `no_destinations` when nothing the caller can access is eligible, and otherwise the eligible facilities. Eligibility is the configured destination override list for the originating facility (an empty configuration means every facility in the organization) intersected with the caller\'s facility access. The originating facility itself is always eligible so a moved referral can be sent back.  Callers must drop the referral\'s current facility from the returned list: a referral cannot be moved to the facility it already sits in. 
     * Find the facilities a referral originating at this facility may be moved to
     */
    async getLeadExchangeDestinations(requestParameters: GetLeadExchangeDestinationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeadExchangeDestinationsResponse> {
        const response = await this.getLeadExchangeDestinationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getLeadShadowDecision without sending the request
     */
    async getLeadShadowDecisionRequestOpts(requestParameters: GetLeadShadowDecisionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling getLeadShadowDecision().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/shadow-decision`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the latest `shadow_admission_decisions` row for the lead as-is. The FE is responsible for mapping the 5 backend subsystems (clinical / financial / safety / administrative / occupancy) onto its 4 UI sub-tabs (Admission Package / Insurance / Background / Bed Availability). 
     * Get the latest shadow admission decision for a lead
     */
    async getLeadShadowDecisionRaw(requestParameters: GetLeadShadowDecisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeadShadowDecision200Response>> {
        const requestOptions = await this.getLeadShadowDecisionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeadShadowDecision200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the latest `shadow_admission_decisions` row for the lead as-is. The FE is responsible for mapping the 5 backend subsystems (clinical / financial / safety / administrative / occupancy) onto its 4 UI sub-tabs (Admission Package / Insurance / Background / Bed Availability). 
     * Get the latest shadow admission decision for a lead
     */
    async getLeadShadowDecision(requestParameters: GetLeadShadowDecisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeadShadowDecision200Response> {
        const response = await this.getLeadShadowDecisionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getLeadStageCounts without sending the request
     */
    async getLeadStageCountsRequestOpts(requestParameters: GetLeadStageCountsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['sourceId'] != null) {
            queryParameters['source_id'] = requestParameters['sourceId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['suggestion'] != null) {
            queryParameters['suggestion'] = requestParameters['suggestion'];
        }

        if (requestParameters['connector'] != null) {
            queryParameters['connector'] = requestParameters['connector'];
        }

        if (requestParameters['payerType'] != null) {
            queryParameters['payer_type'] = requestParameters['payerType'];
        }

        if (requestParameters['payer'] != null) {
            queryParameters['payer'] = requestParameters['payer'];
        }

        if (requestParameters['payerSource'] != null) {
            queryParameters['payer_source'] = requestParameters['payerSource'];
        }

        if (requestParameters['includeNullPayerType'] != null) {
            queryParameters['include_null_payer_type'] = requestParameters['includeNullPayerType'];
        }

        if (requestParameters['includeNullPayerSource'] != null) {
            queryParameters['include_null_payer_source'] = requestParameters['includeNullPayerSource'];
        }

        if (requestParameters['pccStatus'] != null) {
            queryParameters['pcc_status'] = requestParameters['pccStatus'];
        }

        if (requestParameters['matrixCareStatus'] != null) {
            queryParameters['matrix_care_status'] = requestParameters['matrixCareStatus'];
        }

        if (requestParameters['hasNewHospitalMessages'] != null) {
            queryParameters['has_new_hospital_messages'] = requestParameters['hasNewHospitalMessages'];
        }

        if (requestParameters['hasNewDocuments'] != null) {
            queryParameters['has_new_documents'] = requestParameters['hasNewDocuments'];
        }

        if (requestParameters['assigneeUserIds'] != null) {
            queryParameters['assignee_user_ids'] = requestParameters['assigneeUserIds'];
        }

        if (requestParameters['unassigned'] != null) {
            queryParameters['unassigned'] = requestParameters['unassigned'];
        }

        if (requestParameters['clinicalCareNeeds'] != null) {
            queryParameters['clinical_care_needs'] = requestParameters['clinicalCareNeeds'];
        }

        if (requestParameters['programs'] != null) {
            queryParameters['programs'] = requestParameters['programs'];
        }

        if (requestParameters['typesOfCare'] != null) {
            queryParameters['types_of_care'] = requestParameters['typesOfCare'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/kanban-stage-counts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns per-cell lead counts over the same filter set as FindAllLeads, but without the status_id / admission_status constraints (those dimensions are the grouping keys, not filters). Counts individual leads (not duplicate groups). Cancelled leads are always excluded.
     * Get screener lead counts grouped by review stage and admission status
     */
    async getLeadStageCountsRaw(requestParameters: GetLeadStageCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeadStageCounts200Response>> {
        const requestOptions = await this.getLeadStageCountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeadStageCounts200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns per-cell lead counts over the same filter set as FindAllLeads, but without the status_id / admission_status constraints (those dimensions are the grouping keys, not filters). Counts individual leads (not duplicate groups). Cancelled leads are always excluded.
     * Get screener lead counts grouped by review stage and admission status
     */
    async getLeadStageCounts(requestParameters: GetLeadStageCountsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeadStageCounts200Response> {
        const response = await this.getLeadStageCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOneFacilitySetting without sending the request
     */
    async getOneFacilitySettingRequestOpts(requestParameters: GetOneFacilitySettingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling getOneFacilitySetting().'
            );
        }

        if (requestParameters['settingName'] == null) {
            throw new runtime.RequiredError(
                'settingName',
                'Required parameter "settingName" was null or undefined when calling getOneFacilitySetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{facility_id}/settings/{setting_name}`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));
        urlPath = urlPath.replace('{setting_name}', encodeURIComponent(String(requestParameters['settingName'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve individual facility setting value
     * Get facility setting value
     */
    async getOneFacilitySettingRaw(requestParameters: GetOneFacilitySettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOneFacilitySetting200Response>> {
        const requestOptions = await this.getOneFacilitySettingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOneFacilitySetting200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve individual facility setting value
     * Get facility setting value
     */
    async getOneFacilitySetting(requestParameters: GetOneFacilitySettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOneFacilitySetting200Response> {
        const response = await this.getOneFacilitySettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getScreenerSetting without sending the request
     */
    async getScreenerSettingRequestOpts(requestParameters: GetScreenerSettingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['settingName'] == null) {
            throw new runtime.RequiredError(
                'settingName',
                'Required parameter "settingName" was null or undefined when calling getScreenerSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/screener-settings/{setting_name}`;
        urlPath = urlPath.replace('{setting_name}', encodeURIComponent(String(requestParameters['settingName'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a screener setting for an organization
     * Get a screener setting
     */
    async getScreenerSettingRaw(requestParameters: GetScreenerSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetScreenerSetting200Response>> {
        const requestOptions = await this.getScreenerSettingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetScreenerSetting200ResponseFromJSON(jsonValue));
    }

    /**
     * Get a screener setting for an organization
     * Get a screener setting
     */
    async getScreenerSetting(requestParameters: GetScreenerSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetScreenerSetting200Response> {
        const response = await this.getScreenerSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSourceMergePreview without sending the request
     */
    async getSourceMergePreviewRequestOpts(requestParameters: GetSourceMergePreviewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sourceId'] == null) {
            throw new runtime.RequiredError(
                'sourceId',
                'Required parameter "sourceId" was null or undefined when calling getSourceMergePreview().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sourceToKeepId'] != null) {
            queryParameters['source_to_keep_id'] = requestParameters['sourceToKeepId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/sources/{source_id}/merge-preview`;
        urlPath = urlPath.replace('{source_id}', encodeURIComponent(String(requestParameters['sourceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Read-only preview of what the surviving source would look like after a merge. Writes nothing.
     * Preview the result of merging a source into another source
     */
    async getSourceMergePreviewRaw(requestParameters: GetSourceMergePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSourceMergePreview200Response>> {
        const requestOptions = await this.getSourceMergePreviewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSourceMergePreview200ResponseFromJSON(jsonValue));
    }

    /**
     * Read-only preview of what the surviving source would look like after a merge. Writes nothing.
     * Preview the result of merging a source into another source
     */
    async getSourceMergePreview(requestParameters: GetSourceMergePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSourceMergePreview200Response> {
        const response = await this.getSourceMergePreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUnreadFaxCount without sending the request
     */
    async getUnreadFaxCountRequestOpts(requestParameters: GetUnreadFaxCountRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['facilityType'] != null) {
            queryParameters['facility_type'] = requestParameters['facilityType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/efax/unread-count`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the count of unread faxes for a facility or all accessible facilities
     */
    async getUnreadFaxCountRaw(requestParameters: GetUnreadFaxCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUnreadFaxCount200Response>> {
        const requestOptions = await this.getUnreadFaxCountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUnreadFaxCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the count of unread faxes for a facility or all accessible facilities
     */
    async getUnreadFaxCount(requestParameters: GetUnreadFaxCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUnreadFaxCount200Response> {
        const response = await this.getUnreadFaxCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for linkFaxToReferral without sending the request
     */
    async linkFaxToReferralRequestOpts(requestParameters: LinkFaxToReferralOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling linkFaxToReferral().'
            );
        }

        if (requestParameters['linkFaxToReferralRequest'] == null) {
            throw new runtime.RequiredError(
                'linkFaxToReferralRequest',
                'Required parameter "linkFaxToReferralRequest" was null or undefined when calling linkFaxToReferral().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/efax/faxes/{id}/link-to-referral`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkFaxToReferralRequestToJSON(requestParameters['linkFaxToReferralRequest']),
        };
    }

    /**
     * Link a fax document to an existing referral
     */
    async linkFaxToReferralRaw(requestParameters: LinkFaxToReferralOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.linkFaxToReferralRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Link a fax document to an existing referral
     */
    async linkFaxToReferral(requestParameters: LinkFaxToReferralOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.linkFaxToReferralRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for listMissingInfoFollowUps without sending the request
     */
    async listMissingInfoFollowUpsRequestOpts(requestParameters: ListMissingInfoFollowUpsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling listMissingInfoFollowUps().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/missing-info-follow-ups`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List active missing-info follow-ups for a lead
     */
    async listMissingInfoFollowUpsRaw(requestParameters: ListMissingInfoFollowUpsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListMissingInfoFollowUps200Response>> {
        const requestOptions = await this.listMissingInfoFollowUpsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListMissingInfoFollowUps200ResponseFromJSON(jsonValue));
    }

    /**
     * List active missing-info follow-ups for a lead
     */
    async listMissingInfoFollowUps(requestParameters: ListMissingInfoFollowUpsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListMissingInfoFollowUps200Response> {
        const response = await this.listMissingInfoFollowUpsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mergeSources without sending the request
     */
    async mergeSourcesRequestOpts(requestParameters: MergeSourcesOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sourceId'] == null) {
            throw new runtime.RequiredError(
                'sourceId',
                'Required parameter "sourceId" was null or undefined when calling mergeSources().'
            );
        }

        if (requestParameters['mergeSourcesRequest'] == null) {
            throw new runtime.RequiredError(
                'mergeSourcesRequest',
                'Required parameter "mergeSourcesRequest" was null or undefined when calling mergeSources().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/sources/{source_id}/merge`;
        urlPath = urlPath.replace('{source_id}', encodeURIComponent(String(requestParameters['sourceId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MergeSourcesRequestToJSON(requestParameters['mergeSourcesRequest']),
        };
    }

    /**
     * Records source_to_keep_id as the surviving source on the source identified by source_id, transfers that source\'s own data and configuration, and soft-deletes it, all in a single transaction. Referrals and fax documents are never rewritten: they keep pointing at the merged-away source, which reports the survivor through merged_into. All-or-nothing: any failing step rolls back the whole merge.
     * Merge a source into another source
     */
    async mergeSourcesRaw(requestParameters: MergeSourcesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MergeSources200Response>> {
        const requestOptions = await this.mergeSourcesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MergeSources200ResponseFromJSON(jsonValue));
    }

    /**
     * Records source_to_keep_id as the surviving source on the source identified by source_id, transfers that source\'s own data and configuration, and soft-deletes it, all in a single transaction. Referrals and fax documents are never rewritten: they keep pointing at the merged-away source, which reports the survivor through merged_into. All-or-nothing: any failing step rolls back the whole merge.
     * Merge a source into another source
     */
    async mergeSources(requestParameters: MergeSourcesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MergeSources200Response> {
        const response = await this.mergeSourcesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for overrideAnalysisResult without sending the request
     */
    async overrideAnalysisResultRequestOpts(requestParameters: OverrideAnalysisResultOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling overrideAnalysisResult().'
            );
        }

        if (requestParameters['resultId'] == null) {
            throw new runtime.RequiredError(
                'resultId',
                'Required parameter "resultId" was null or undefined when calling overrideAnalysisResult().'
            );
        }

        if (requestParameters['overrideAnalysisResultRequest'] == null) {
            throw new runtime.RequiredError(
                'overrideAnalysisResultRequest',
                'Required parameter "overrideAnalysisResultRequest" was null or undefined when calling overrideAnalysisResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/analysis-results/{result_id}/override`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{result_id}', encodeURIComponent(String(requestParameters['resultId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OverrideAnalysisResultRequestToJSON(requestParameters['overrideAnalysisResultRequest']),
        };
    }

    /**
     * Override the criteria result of an analysis result with a new value and reason
     * Override an analysis result
     */
    async overrideAnalysisResultRaw(requestParameters: OverrideAnalysisResultOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OverrideAnalysisResult200Response>> {
        const requestOptions = await this.overrideAnalysisResultRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OverrideAnalysisResult200ResponseFromJSON(jsonValue));
    }

    /**
     * Override the criteria result of an analysis result with a new value and reason
     * Override an analysis result
     */
    async overrideAnalysisResult(requestParameters: OverrideAnalysisResultOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OverrideAnalysisResult200Response> {
        const response = await this.overrideAnalysisResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for pdfDownloader without sending the request
     */
    async pdfDownloaderRequestOpts(requestParameters: PdfDownloaderRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['documentIds'] == null) {
            throw new runtime.RequiredError(
                'documentIds',
                'Required parameter "documentIds" was null or undefined when calling pdfDownloader().'
            );
        }

        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling pdfDownloader().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['documentIds'] != null) {
            queryParameters['document_ids'] = requestParameters['documentIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/documents-download`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Combines multiple PDF documents and returns a signed URL for download
     * Download combined PDF documents
     */
    async pdfDownloaderRaw(requestParameters: PdfDownloaderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PdfDownloader200Response>> {
        const requestOptions = await this.pdfDownloaderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PdfDownloader200ResponseFromJSON(jsonValue));
    }

    /**
     * Combines multiple PDF documents and returns a signed URL for download
     * Download combined PDF documents
     */
    async pdfDownloader(requestParameters: PdfDownloaderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PdfDownloader200Response> {
        const response = await this.pdfDownloaderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for processIntegrationEvent without sending the request
     */
    async processIntegrationEventRequestOpts(requestParameters: ProcessIntegrationEventRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['integrationEventId'] == null) {
            throw new runtime.RequiredError(
                'integrationEventId',
                'Required parameter "integrationEventId" was null or undefined when calling processIntegrationEvent().'
            );
        }

        if (requestParameters['action'] == null) {
            throw new runtime.RequiredError(
                'action',
                'Required parameter "action" was null or undefined when calling processIntegrationEvent().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['action'] != null) {
            queryParameters['action'] = requestParameters['action'];
        }

        if (requestParameters['confirmation'] != null) {
            queryParameters['confirmation'] = requestParameters['confirmation'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/integration-events/action/{integration_event_id}`;
        urlPath = urlPath.replace('{integration_event_id}', encodeURIComponent(String(requestParameters['integrationEventId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Process an integration event
     */
    async processIntegrationEventRaw(requestParameters: ProcessIntegrationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.processIntegrationEventRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Process an integration event
     */
    async processIntegrationEvent(requestParameters: ProcessIntegrationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.processIntegrationEventRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for relocateScreenerResident without sending the request
     */
    async relocateScreenerResidentRequestOpts(requestParameters: RelocateScreenerResidentOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['residentId'] == null) {
            throw new runtime.RequiredError(
                'residentId',
                'Required parameter "residentId" was null or undefined when calling relocateScreenerResident().'
            );
        }

        if (requestParameters['relocateScreenerResidentRequest'] == null) {
            throw new runtime.RequiredError(
                'relocateScreenerResidentRequest',
                'Required parameter "relocateScreenerResidentRequest" was null or undefined when calling relocateScreenerResident().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/screener-residents/{resident_id}/relocate`;
        urlPath = urlPath.replace('{resident_id}', encodeURIComponent(String(requestParameters['residentId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RelocateScreenerResidentRequestToJSON(requestParameters['relocateScreenerResidentRequest']),
        };
    }

    /**
     * Relocate a screener resident to a new bed
     * Relocate screener resident
     */
    async relocateScreenerResidentRaw(requestParameters: RelocateScreenerResidentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelocateScreenerResident200Response>> {
        const requestOptions = await this.relocateScreenerResidentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelocateScreenerResident200ResponseFromJSON(jsonValue));
    }

    /**
     * Relocate a screener resident to a new bed
     * Relocate screener resident
     */
    async relocateScreenerResident(requestParameters: RelocateScreenerResidentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelocateScreenerResident200Response> {
        const response = await this.relocateScreenerResidentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for replaceHomeHealthPractitionerAssignments without sending the request
     */
    async replaceHomeHealthPractitionerAssignmentsRequestOpts(requestParameters: ReplaceHomeHealthPractitionerAssignmentsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling replaceHomeHealthPractitionerAssignments().'
            );
        }

        if (requestParameters['practitionerId'] == null) {
            throw new runtime.RequiredError(
                'practitionerId',
                'Required parameter "practitionerId" was null or undefined when calling replaceHomeHealthPractitionerAssignments().'
            );
        }

        if (requestParameters['replaceHomeHealthPractitionerAssignmentsRequest'] == null) {
            throw new runtime.RequiredError(
                'replaceHomeHealthPractitionerAssignmentsRequest',
                'Required parameter "replaceHomeHealthPractitionerAssignmentsRequest" was null or undefined when calling replaceHomeHealthPractitionerAssignments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/home-health-practitioners/{practitioner_id}/assignments`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{practitioner_id}', encodeURIComponent(String(requestParameters['practitionerId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReplaceHomeHealthPractitionerAssignmentsRequestToJSON(requestParameters['replaceHomeHealthPractitionerAssignmentsRequest']),
        };
    }

    /**
     * Atomically replace a practitioner\'s home-health roles on a lead
     */
    async replaceHomeHealthPractitionerAssignmentsRaw(requestParameters: ReplaceHomeHealthPractitionerAssignmentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindHomeHealthPractitionerAssignments200Response>> {
        const requestOptions = await this.replaceHomeHealthPractitionerAssignmentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindHomeHealthPractitionerAssignments200ResponseFromJSON(jsonValue));
    }

    /**
     * Atomically replace a practitioner\'s home-health roles on a lead
     */
    async replaceHomeHealthPractitionerAssignments(requestParameters: ReplaceHomeHealthPractitionerAssignmentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindHomeHealthPractitionerAssignments200Response> {
        const response = await this.replaceHomeHealthPractitionerAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resetPccE2eFixture without sending the request
     */
    async resetPccE2eFixtureRequestOpts(requestParameters: ResetPccE2eFixtureRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling resetPccE2eFixture().'
            );
        }

        if (requestParameters['pccE2eFixtureResetRequest'] == null) {
            throw new runtime.RequiredError(
                'pccE2eFixtureResetRequest',
                'Required parameter "pccE2eFixtureResetRequest" was null or undefined when calling resetPccE2eFixture().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/pcc/e2e-fixtures/reset`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PccE2eFixtureResetRequestToJSON(requestParameters['pccE2eFixtureResetRequest']),
        };
    }

    /**
     * Reset PCC E2E fixture state for a lead
     */
    async resetPccE2eFixtureRaw(requestParameters: ResetPccE2eFixtureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResetPccE2eFixture200Response>> {
        const requestOptions = await this.resetPccE2eFixtureRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResetPccE2eFixture200ResponseFromJSON(jsonValue));
    }

    /**
     * Reset PCC E2E fixture state for a lead
     */
    async resetPccE2eFixture(requestParameters: ResetPccE2eFixtureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResetPccE2eFixture200Response> {
        const response = await this.resetPccE2eFixtureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resetPccPushStatus without sending the request
     */
    async resetPccPushStatusRequestOpts(requestParameters: ResetPccPushStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling resetPccPushStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/pcc/push-status/reset`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Reset PCC push status for a lead
     */
    async resetPccPushStatusRaw(requestParameters: ResetPccPushStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResetPccPushStatus200Response>> {
        const requestOptions = await this.resetPccPushStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResetPccPushStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Reset PCC push status for a lead
     */
    async resetPccPushStatus(requestParameters: ResetPccPushStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResetPccPushStatus200Response> {
        const response = await this.resetPccPushStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resolveIntegrationEvent without sending the request
     */
    async resolveIntegrationEventRequestOpts(requestParameters: ResolveIntegrationEventOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['integrationEventId'] == null) {
            throw new runtime.RequiredError(
                'integrationEventId',
                'Required parameter "integrationEventId" was null or undefined when calling resolveIntegrationEvent().'
            );
        }

        if (requestParameters['resolveIntegrationEventRequest'] == null) {
            throw new runtime.RequiredError(
                'resolveIntegrationEventRequest',
                'Required parameter "resolveIntegrationEventRequest" was null or undefined when calling resolveIntegrationEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/integration-events/resolve/{integration_event_id}`;
        urlPath = urlPath.replace('{integration_event_id}', encodeURIComponent(String(requestParameters['integrationEventId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResolveIntegrationEventRequestToJSON(requestParameters['resolveIntegrationEventRequest']),
        };
    }

    /**
     * Resolve a flagged integration-event conflict (e.g. end-of-care transition) and apply the event in one transaction
     */
    async resolveIntegrationEventRaw(requestParameters: ResolveIntegrationEventOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResolveIntegrationEventResponse>> {
        const requestOptions = await this.resolveIntegrationEventRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResolveIntegrationEventResponseFromJSON(jsonValue));
    }

    /**
     * Resolve a flagged integration-event conflict (e.g. end-of-care transition) and apply the event in one transaction
     */
    async resolveIntegrationEvent(requestParameters: ResolveIntegrationEventOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResolveIntegrationEventResponse> {
        const response = await this.resolveIntegrationEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for revertAnalysisResult without sending the request
     */
    async revertAnalysisResultRequestOpts(requestParameters: RevertAnalysisResultRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling revertAnalysisResult().'
            );
        }

        if (requestParameters['resultId'] == null) {
            throw new runtime.RequiredError(
                'resultId',
                'Required parameter "resultId" was null or undefined when calling revertAnalysisResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/analysis-results/{result_id}/revert`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));
        urlPath = urlPath.replace('{result_id}', encodeURIComponent(String(requestParameters['resultId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Revert a previous override of an analysis result
     * Revert an analysis result override
     */
    async revertAnalysisResultRaw(requestParameters: RevertAnalysisResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OverrideAnalysisResult200Response>> {
        const requestOptions = await this.revertAnalysisResultRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OverrideAnalysisResult200ResponseFromJSON(jsonValue));
    }

    /**
     * Revert a previous override of an analysis result
     * Revert an analysis result override
     */
    async revertAnalysisResult(requestParameters: RevertAnalysisResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OverrideAnalysisResult200Response> {
        const response = await this.revertAnalysisResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchProviderDirectory without sending the request
     */
    async searchProviderDirectoryRequestOpts(requestParameters: SearchProviderDirectoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling searchProviderDirectory().'
            );
        }

        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling searchProviderDirectory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['providerType'] != null) {
            queryParameters['provider_type'] = requestParameters['providerType'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['zip'] != null) {
            queryParameters['zip'] = requestParameters['zip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/provider-directory/search`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fuzzy name search over provider_directory, filtered by provider type and location.
     * Search the global provider directory by name
     */
    async searchProviderDirectoryRaw(requestParameters: SearchProviderDirectoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchProviderDirectory200Response>> {
        const requestOptions = await this.searchProviderDirectoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchProviderDirectory200ResponseFromJSON(jsonValue));
    }

    /**
     * Fuzzy name search over provider_directory, filtered by provider type and location.
     * Search the global provider directory by name
     */
    async searchProviderDirectory(requestParameters: SearchProviderDirectoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchProviderDirectory200Response> {
        const response = await this.searchProviderDirectoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sendLeadReferral without sending the request
     */
    async sendLeadReferralRequestOpts(requestParameters: SendLeadReferralOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling sendLeadReferral().'
            );
        }

        if (requestParameters['sendLeadReferralRequest'] == null) {
            throw new runtime.RequiredError(
                'sendLeadReferralRequest',
                'Required parameter "sendLeadReferralRequest" was null or undefined when calling sendLeadReferral().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/leads/{lead_id}/referrals/send`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendLeadReferralRequestToJSON(requestParameters['sendLeadReferralRequest']),
        };
    }

    /**
     * Send an outbound referral for a lead
     */
    async sendLeadReferralRaw(requestParameters: SendLeadReferralOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendLeadReferral201Response>> {
        const requestOptions = await this.sendLeadReferralRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendLeadReferral201ResponseFromJSON(jsonValue));
    }

    /**
     * Send an outbound referral for a lead
     */
    async sendLeadReferral(requestParameters: SendLeadReferralOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendLeadReferral201Response> {
        const response = await this.sendLeadReferralRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for swapScreenerLeadResidents without sending the request
     */
    async swapScreenerLeadResidentsRequestOpts(requestParameters: SwapScreenerLeadResidentsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['swapScreenerLeadResidentsRequest'] == null) {
            throw new runtime.RequiredError(
                'swapScreenerLeadResidentsRequest',
                'Required parameter "swapScreenerLeadResidentsRequest" was null or undefined when calling swapScreenerLeadResidents().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/screener-leads/swap-residents`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SwapScreenerLeadResidentsRequestToJSON(requestParameters['swapScreenerLeadResidentsRequest']),
        };
    }

    /**
     * Swap the residents between two beds
     * Swap residents between two beds
     */
    async swapScreenerLeadResidentsRaw(requestParameters: SwapScreenerLeadResidentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SwapScreenerLeadResidents200Response>> {
        const requestOptions = await this.swapScreenerLeadResidentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SwapScreenerLeadResidents200ResponseFromJSON(jsonValue));
    }

    /**
     * Swap the residents between two beds
     * Swap residents between two beds
     */
    async swapScreenerLeadResidents(requestParameters: SwapScreenerLeadResidentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SwapScreenerLeadResidents200Response> {
        const response = await this.swapScreenerLeadResidentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for switchOrganizationStateTownType without sending the request
     */
    async switchOrganizationStateTownTypeRequestOpts(requestParameters: SwitchOrganizationStateTownTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling switchOrganizationStateTownType().'
            );
        }

        if (requestParameters['organizationStateTownSwitchTypeRequest'] == null) {
            throw new runtime.RequiredError(
                'organizationStateTownSwitchTypeRequest',
                'Required parameter "organizationStateTownSwitchTypeRequest" was null or undefined when calling switchOrganizationStateTownType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/organization-state-towns/{id}/switch-type`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationStateTownSwitchTypeRequestToJSON(requestParameters['organizationStateTownSwitchTypeRequest']),
        };
    }

    /**
     * Switch the town between served/unserved organization state where it belongs
     */
    async switchOrganizationStateTownTypeRaw(requestParameters: SwitchOrganizationStateTownTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.switchOrganizationStateTownTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Switch the town between served/unserved organization state where it belongs
     */
    async switchOrganizationStateTownType(requestParameters: SwitchOrganizationStateTownTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.switchOrganizationStateTownTypeRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for triggerPdpmEstimator without sending the request
     */
    async triggerPdpmEstimatorRequestOpts(requestParameters: TriggerPdpmEstimatorRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling triggerPdpmEstimator().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/leads/{lead_id}/trigger-pdpm-estimator`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Trigger the Pdpm Estimator for a lead
     * Trigger Pdpm Estimator
     */
    async triggerPdpmEstimatorRaw(requestParameters: TriggerPdpmEstimatorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.triggerPdpmEstimatorRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Trigger the Pdpm Estimator for a lead
     * Trigger Pdpm Estimator
     */
    async triggerPdpmEstimator(requestParameters: TriggerPdpmEstimatorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.triggerPdpmEstimatorRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateBedNote without sending the request
     */
    async updateBedNoteRequestOpts(requestParameters: UpdateBedNoteOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['bedId'] == null) {
            throw new runtime.RequiredError(
                'bedId',
                'Required parameter "bedId" was null or undefined when calling updateBedNote().'
            );
        }

        if (requestParameters['updateBedNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'updateBedNoteRequest',
                'Required parameter "updateBedNoteRequest" was null or undefined when calling updateBedNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/beds/{bed_id}/note`;
        urlPath = urlPath.replace('{bed_id}', encodeURIComponent(String(requestParameters['bedId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBedNoteRequestToJSON(requestParameters['updateBedNoteRequest']),
        };
    }

    /**
     * Update the note for a specific bed
     * Update a bed\'s note
     */
    async updateBedNoteRaw(requestParameters: UpdateBedNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneBed200Response>> {
        const requestOptions = await this.updateBedNoteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneBed200ResponseFromJSON(jsonValue));
    }

    /**
     * Update the note for a specific bed
     * Update a bed\'s note
     */
    async updateBedNote(requestParameters: UpdateBedNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneBed200Response> {
        const response = await this.updateBedNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateCriteria without sending the request
     */
    async updateCriteriaRequestOpts(requestParameters: UpdateCriteriaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['criteriaId'] == null) {
            throw new runtime.RequiredError(
                'criteriaId',
                'Required parameter "criteriaId" was null or undefined when calling updateCriteria().'
            );
        }

        if (requestParameters['criteria'] == null) {
            throw new runtime.RequiredError(
                'criteria',
                'Required parameter "criteria" was null or undefined when calling updateCriteria().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/criteria/{criteria_id}`;
        urlPath = urlPath.replace('{criteria_id}', encodeURIComponent(String(requestParameters['criteriaId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CriteriaToJSON(requestParameters['criteria']),
        };
    }

    /**
     * Update a screener criteria
     */
    async updateCriteriaRaw(requestParameters: UpdateCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCriteria201Response>> {
        const requestOptions = await this.updateCriteriaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCriteria201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener criteria
     */
    async updateCriteria(requestParameters: UpdateCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCriteria201Response> {
        const response = await this.updateCriteriaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateCriteriaCategories without sending the request
     */
    async updateCriteriaCategoriesRequestOpts(requestParameters: UpdateCriteriaCategoriesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['bulkUpdateCriteriaCategoriesRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkUpdateCriteriaCategoriesRequest',
                'Required parameter "bulkUpdateCriteriaCategoriesRequest" was null or undefined when calling updateCriteriaCategories().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/criteria/categories`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateCriteriaCategoriesRequestToJSON(requestParameters['bulkUpdateCriteriaCategoriesRequest']),
        };
    }

    /**
     * Update criteria categories
     * Update criteria categories
     */
    async updateCriteriaCategoriesRaw(requestParameters: UpdateCriteriaCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllCriteriaCategories200Response>> {
        const requestOptions = await this.updateCriteriaCategoriesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllCriteriaCategories200ResponseFromJSON(jsonValue));
    }

    /**
     * Update criteria categories
     * Update criteria categories
     */
    async updateCriteriaCategories(requestParameters: UpdateCriteriaCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllCriteriaCategories200Response> {
        const response = await this.updateCriteriaCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateCriteriaTargets without sending the request
     */
    async updateCriteriaTargetsRequestOpts(requestParameters: UpdateCriteriaTargetsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['criteriaId'] == null) {
            throw new runtime.RequiredError(
                'criteriaId',
                'Required parameter "criteriaId" was null or undefined when calling updateCriteriaTargets().'
            );
        }

        if (requestParameters['createCriteriaTargetsRequest'] == null) {
            throw new runtime.RequiredError(
                'createCriteriaTargetsRequest',
                'Required parameter "createCriteriaTargetsRequest" was null or undefined when calling updateCriteriaTargets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/criteria/targets/{criteria_id}`;
        urlPath = urlPath.replace('{criteria_id}', encodeURIComponent(String(requestParameters['criteriaId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCriteriaTargetsRequestToJSON(requestParameters['createCriteriaTargetsRequest']),
        };
    }

    /**
     * Update a screener criteria in place and replace all of its targets in a single transaction
     * Update a criteria and replace its targets
     */
    async updateCriteriaTargetsRaw(requestParameters: UpdateCriteriaTargetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCriteriaTargets201Response>> {
        const requestOptions = await this.updateCriteriaTargetsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCriteriaTargets201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener criteria in place and replace all of its targets in a single transaction
     * Update a criteria and replace its targets
     */
    async updateCriteriaTargets(requestParameters: UpdateCriteriaTargetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCriteriaTargets201Response> {
        const response = await this.updateCriteriaTargetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateDocumentExclusionTerm without sending the request
     */
    async updateDocumentExclusionTermRequestOpts(requestParameters: UpdateDocumentExclusionTermOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['termId'] == null) {
            throw new runtime.RequiredError(
                'termId',
                'Required parameter "termId" was null or undefined when calling updateDocumentExclusionTerm().'
            );
        }

        if (requestParameters['updateDocumentExclusionTermRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDocumentExclusionTermRequest',
                'Required parameter "updateDocumentExclusionTermRequest" was null or undefined when calling updateDocumentExclusionTerm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/document-exclusion-terms/{term_id}`;
        urlPath = urlPath.replace('{term_id}', encodeURIComponent(String(requestParameters['termId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDocumentExclusionTermRequestToJSON(requestParameters['updateDocumentExclusionTermRequest']),
        };
    }

    /**
     * Update an existing document exclusion term
     * Update document exclusion term
     */
    async updateDocumentExclusionTermRaw(requestParameters: UpdateDocumentExclusionTermOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDocumentExclusionTerm201Response>> {
        const requestOptions = await this.updateDocumentExclusionTermRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDocumentExclusionTerm201ResponseFromJSON(jsonValue));
    }

    /**
     * Update an existing document exclusion term
     * Update document exclusion term
     */
    async updateDocumentExclusionTerm(requestParameters: UpdateDocumentExclusionTermOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDocumentExclusionTerm201Response> {
        const response = await this.updateDocumentExclusionTermRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateFacilityCustomTag without sending the request
     */
    async updateFacilityCustomTagRequestOpts(requestParameters: UpdateFacilityCustomTagOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFacilityCustomTag().'
            );
        }

        if (requestParameters['updateFacilityCustomTagRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFacilityCustomTagRequest',
                'Required parameter "updateFacilityCustomTagRequest" was null or undefined when calling updateFacilityCustomTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facility-custom-tags/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFacilityCustomTagRequestToJSON(requestParameters['updateFacilityCustomTagRequest']),
        };
    }

    /**
     * Rename a facility custom tag and reconcile its tagged facilities
     */
    async updateFacilityCustomTagRaw(requestParameters: UpdateFacilityCustomTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityCustomTag201Response>> {
        const requestOptions = await this.updateFacilityCustomTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityCustomTag201ResponseFromJSON(jsonValue));
    }

    /**
     * Rename a facility custom tag and reconcile its tagged facilities
     */
    async updateFacilityCustomTag(requestParameters: UpdateFacilityCustomTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityCustomTag201Response> {
        const response = await this.updateFacilityCustomTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateFacilityRegion without sending the request
     */
    async updateFacilityRegionRequestOpts(requestParameters: UpdateFacilityRegionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFacilityRegion().'
            );
        }

        if (requestParameters['updateFacilityRegionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFacilityRegionRequest',
                'Required parameter "updateFacilityRegionRequest" was null or undefined when calling updateFacilityRegion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facility-regions/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFacilityRegionRequestToJSON(requestParameters['updateFacilityRegionRequest']),
        };
    }

    /**
     * Rename a facility region and reconcile its assigned facilities
     */
    async updateFacilityRegionRaw(requestParameters: UpdateFacilityRegionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityRegion201Response>> {
        const requestOptions = await this.updateFacilityRegionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityRegion201ResponseFromJSON(jsonValue));
    }

    /**
     * Rename a facility region and reconcile its assigned facilities
     */
    async updateFacilityRegion(requestParameters: UpdateFacilityRegionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityRegion201Response> {
        const response = await this.updateFacilityRegionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateFacilityServiceArea without sending the request
     */
    async updateFacilityServiceAreaRequestOpts(requestParameters: UpdateFacilityServiceAreaOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling updateFacilityServiceArea().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFacilityServiceArea().'
            );
        }

        if (requestParameters['updateFacilityServiceAreaRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFacilityServiceAreaRequest',
                'Required parameter "updateFacilityServiceAreaRequest" was null or undefined when calling updateFacilityServiceArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facilities/{facility_id}/service-areas/{id}`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFacilityServiceAreaRequestToJSON(requestParameters['updateFacilityServiceAreaRequest']),
        };
    }

    /**
     * Update a service area entry for a facility
     */
    async updateFacilityServiceAreaRaw(requestParameters: UpdateFacilityServiceAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityServiceArea201Response>> {
        const requestOptions = await this.updateFacilityServiceAreaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityServiceArea201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a service area entry for a facility
     */
    async updateFacilityServiceArea(requestParameters: UpdateFacilityServiceAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityServiceArea201Response> {
        const response = await this.updateFacilityServiceAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateFacilitySetting without sending the request
     */
    async updateFacilitySettingRequestOpts(requestParameters: UpdateFacilitySettingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling updateFacilitySetting().'
            );
        }

        if (requestParameters['settingName'] == null) {
            throw new runtime.RequiredError(
                'settingName',
                'Required parameter "settingName" was null or undefined when calling updateFacilitySetting().'
            );
        }

        if (requestParameters['updateScreenerSettingRequest'] == null) {
            throw new runtime.RequiredError(
                'updateScreenerSettingRequest',
                'Required parameter "updateScreenerSettingRequest" was null or undefined when calling updateFacilitySetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facilities/{facility_id}/settings/{setting_name}`;
        urlPath = urlPath.replace('{facility_id}', encodeURIComponent(String(requestParameters['facilityId'])));
        urlPath = urlPath.replace('{setting_name}', encodeURIComponent(String(requestParameters['settingName'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateScreenerSettingRequestToJSON(requestParameters['updateScreenerSettingRequest']),
        };
    }

    /**
     * Update a screener setting for a specific facility
     * Update a facility setting
     */
    async updateFacilitySettingRaw(requestParameters: UpdateFacilitySettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateFacilitySettingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a screener setting for a specific facility
     * Update a facility setting
     */
    async updateFacilitySetting(requestParameters: UpdateFacilitySettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFacilitySettingRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateFaxReadStatus without sending the request
     */
    async updateFaxReadStatusRequestOpts(requestParameters: UpdateFaxReadStatusOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFaxReadStatus().'
            );
        }

        if (requestParameters['updateFaxReadStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFaxReadStatusRequest',
                'Required parameter "updateFaxReadStatusRequest" was null or undefined when calling updateFaxReadStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/efax/faxes/{id}/read-status`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFaxReadStatusRequestToJSON(requestParameters['updateFaxReadStatusRequest']),
        };
    }

    /**
     * Update fax read status
     */
    async updateFaxReadStatusRaw(requestParameters: UpdateFaxReadStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateFaxReadStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update fax read status
     */
    async updateFaxReadStatus(requestParameters: UpdateFaxReadStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFaxReadStatusRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateFilterViewById without sending the request
     */
    async updateFilterViewByIdRequestOpts(requestParameters: UpdateFilterViewByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFilterViewById().'
            );
        }

        if (requestParameters['updateFilterViewRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFilterViewRequest',
                'Required parameter "updateFilterViewRequest" was null or undefined when calling updateFilterViewById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/filter-views/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFilterViewRequestToJSON(requestParameters['updateFilterViewRequest']),
        };
    }

    /**
     * Update a filter view
     */
    async updateFilterViewByIdRaw(requestParameters: UpdateFilterViewByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFilterView201Response>> {
        const requestOptions = await this.updateFilterViewByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFilterView201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a filter view
     */
    async updateFilterViewById(requestParameters: UpdateFilterViewByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFilterView201Response> {
        const response = await this.updateFilterViewByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateLeadCareAttributes without sending the request
     */
    async updateLeadCareAttributesRequestOpts(requestParameters: UpdateLeadCareAttributesOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['updateLeadCareAttributesRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLeadCareAttributesRequest',
                'Required parameter "updateLeadCareAttributesRequest" was null or undefined when calling updateLeadCareAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/referral-care-attributes`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLeadCareAttributesRequestToJSON(requestParameters['updateLeadCareAttributesRequest']),
        };
    }

    /**
     * Replaces the applied values for the given lead and category with the full set in care_attribute_ids. Values in other categories are untouched.
     * Update a lead\'s referral care attributes for one category
     */
    async updateLeadCareAttributesRaw(requestParameters: UpdateLeadCareAttributesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeadCareAttributes200Response>> {
        const requestOptions = await this.updateLeadCareAttributesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLeadCareAttributes200ResponseFromJSON(jsonValue));
    }

    /**
     * Replaces the applied values for the given lead and category with the full set in care_attribute_ids. Values in other categories are untouched.
     * Update a lead\'s referral care attributes for one category
     */
    async updateLeadCareAttributes(requestParameters: UpdateLeadCareAttributesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeadCareAttributes200Response> {
        const response = await this.updateLeadCareAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateLeadInfo without sending the request
     */
    async updateLeadInfoRequestOpts(requestParameters: UpdateLeadInfoRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling updateLeadInfo().'
            );
        }

        if (requestParameters['createLeadInfoRequest'] == null) {
            throw new runtime.RequiredError(
                'createLeadInfoRequest',
                'Required parameter "createLeadInfoRequest" was null or undefined when calling updateLeadInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/lead-info/{lead_id}`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLeadInfoRequestToJSON(requestParameters['createLeadInfoRequest']),
        };
    }

    /**
     * Update a screener lead info
     * Update a screener lead info
     */
    async updateLeadInfoRaw(requestParameters: UpdateLeadInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeadInfo201Response>> {
        const requestOptions = await this.updateLeadInfoRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadInfo201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener lead info
     * Update a screener lead info
     */
    async updateLeadInfo(requestParameters: UpdateLeadInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeadInfo201Response> {
        const response = await this.updateLeadInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateLeadWaitlist without sending the request
     */
    async updateLeadWaitlistRequestOpts(requestParameters: UpdateLeadWaitlistRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['waitlistId'] == null) {
            throw new runtime.RequiredError(
                'waitlistId',
                'Required parameter "waitlistId" was null or undefined when calling updateLeadWaitlist().'
            );
        }

        if (requestParameters['findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist'] == null) {
            throw new runtime.RequiredError(
                'findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist',
                'Required parameter "findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist" was null or undefined when calling updateLeadWaitlist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/lead-waitlist/{waitlist_id}`;
        urlPath = urlPath.replace('{waitlist_id}', encodeURIComponent(String(requestParameters['waitlistId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistToJSON(requestParameters['findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist']),
        };
    }

    /**
     * Update a lead waitlist record
     */
    async updateLeadWaitlistRaw(requestParameters: UpdateLeadWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeadWaitlistStatus200Response>> {
        const requestOptions = await this.updateLeadWaitlistRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLeadWaitlistStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Update a lead waitlist record
     */
    async updateLeadWaitlist(requestParameters: UpdateLeadWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeadWaitlistStatus200Response> {
        const response = await this.updateLeadWaitlistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateLeadWaitlistRank without sending the request
     */
    async updateLeadWaitlistRankRequestOpts(requestParameters: UpdateLeadWaitlistRankOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['waitlistId'] == null) {
            throw new runtime.RequiredError(
                'waitlistId',
                'Required parameter "waitlistId" was null or undefined when calling updateLeadWaitlistRank().'
            );
        }

        if (requestParameters['updateLeadWaitlistRankRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLeadWaitlistRankRequest',
                'Required parameter "updateLeadWaitlistRankRequest" was null or undefined when calling updateLeadWaitlistRank().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/lead-waitlist/{waitlist_id}/rank`;
        urlPath = urlPath.replace('{waitlist_id}', encodeURIComponent(String(requestParameters['waitlistId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLeadWaitlistRankRequestToJSON(requestParameters['updateLeadWaitlistRankRequest']),
        };
    }

    /**
     * Updates the rank of a lead waitlist record
     */
    async updateLeadWaitlistRankRaw(requestParameters: UpdateLeadWaitlistRankOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeadWaitlistStatus200Response>> {
        const requestOptions = await this.updateLeadWaitlistRankRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLeadWaitlistStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Updates the rank of a lead waitlist record
     */
    async updateLeadWaitlistRank(requestParameters: UpdateLeadWaitlistRankOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeadWaitlistStatus200Response> {
        const response = await this.updateLeadWaitlistRankRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateLeadWaitlistStatus without sending the request
     */
    async updateLeadWaitlistStatusRequestOpts(requestParameters: UpdateLeadWaitlistStatusOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['waitlistId'] == null) {
            throw new runtime.RequiredError(
                'waitlistId',
                'Required parameter "waitlistId" was null or undefined when calling updateLeadWaitlistStatus().'
            );
        }

        if (requestParameters['updateLeadWaitlistStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLeadWaitlistStatusRequest',
                'Required parameter "updateLeadWaitlistStatusRequest" was null or undefined when calling updateLeadWaitlistStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/lead-waitlist/{waitlist_id}/status`;
        urlPath = urlPath.replace('{waitlist_id}', encodeURIComponent(String(requestParameters['waitlistId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLeadWaitlistStatusRequestToJSON(requestParameters['updateLeadWaitlistStatusRequest']),
        };
    }

    /**
     * Update a lead waitlist status
     */
    async updateLeadWaitlistStatusRaw(requestParameters: UpdateLeadWaitlistStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeadWaitlistStatus200Response>> {
        const requestOptions = await this.updateLeadWaitlistStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLeadWaitlistStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Update a lead waitlist status
     */
    async updateLeadWaitlistStatus(requestParameters: UpdateLeadWaitlistStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeadWaitlistStatus200Response> {
        const response = await this.updateLeadWaitlistStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateReferralRecipientConfig without sending the request
     */
    async updateReferralRecipientConfigRequestOpts(requestParameters: UpdateReferralRecipientConfigOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateReferralRecipientConfig().'
            );
        }

        if (requestParameters['updateReferralRecipientConfigRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReferralRecipientConfigRequest',
                'Required parameter "updateReferralRecipientConfigRequest" was null or undefined when calling updateReferralRecipientConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/referral-recipient-configs/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferralRecipientConfigRequestToJSON(requestParameters['updateReferralRecipientConfigRequest']),
        };
    }

    /**
     * Update a referral recipient config
     */
    async updateReferralRecipientConfigRaw(requestParameters: UpdateReferralRecipientConfigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateReferralRecipientConfig201Response>> {
        const requestOptions = await this.updateReferralRecipientConfigRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateReferralRecipientConfig201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a referral recipient config
     */
    async updateReferralRecipientConfig(requestParameters: UpdateReferralRecipientConfigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateReferralRecipientConfig201Response> {
        const response = await this.updateReferralRecipientConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateReferralStatus without sending the request
     */
    async updateReferralStatusRequestOpts(requestParameters: UpdateReferralStatusOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling updateReferralStatus().'
            );
        }

        if (requestParameters['updateReferralStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReferralStatusRequest',
                'Required parameter "updateReferralStatusRequest" was null or undefined when calling updateReferralStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/referrals/{referral_id}/status`;
        urlPath = urlPath.replace('{referral_id}', encodeURIComponent(String(requestParameters['referralId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferralStatusRequestToJSON(requestParameters['updateReferralStatusRequest']),
        };
    }

    /**
     * Update referral status
     */
    async updateReferralStatusRaw(requestParameters: UpdateReferralStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateReferralStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update referral status
     */
    async updateReferralStatus(requestParameters: UpdateReferralStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReferralStatusRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateScreenerAdmissionFlag without sending the request
     */
    async updateScreenerAdmissionFlagRequestOpts(requestParameters: UpdateScreenerAdmissionFlagRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateScreenerAdmissionFlag().'
            );
        }

        if (requestParameters['findAllScreenerAdmissionFlags200ResponseDataInner'] == null) {
            throw new runtime.RequiredError(
                'findAllScreenerAdmissionFlags200ResponseDataInner',
                'Required parameter "findAllScreenerAdmissionFlags200ResponseDataInner" was null or undefined when calling updateScreenerAdmissionFlag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/screener-admission-flags/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON(requestParameters['findAllScreenerAdmissionFlags200ResponseDataInner']),
        };
    }

    /**
     * Update a screener admission flag
     */
    async updateScreenerAdmissionFlagRaw(requestParameters: UpdateScreenerAdmissionFlagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateScreenerAdmissionFlag201Response>> {
        const requestOptions = await this.updateScreenerAdmissionFlagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateScreenerAdmissionFlag201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener admission flag
     */
    async updateScreenerAdmissionFlag(requestParameters: UpdateScreenerAdmissionFlagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateScreenerAdmissionFlag201Response> {
        const response = await this.updateScreenerAdmissionFlagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateScreenerBedUnitRank without sending the request
     */
    async updateScreenerBedUnitRankRequestOpts(requestParameters: UpdateScreenerBedUnitRankOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['bedUnitId'] == null) {
            throw new runtime.RequiredError(
                'bedUnitId',
                'Required parameter "bedUnitId" was null or undefined when calling updateScreenerBedUnitRank().'
            );
        }

        if (requestParameters['updateScreenerBedUnitRankRequest'] == null) {
            throw new runtime.RequiredError(
                'updateScreenerBedUnitRankRequest',
                'Required parameter "updateScreenerBedUnitRankRequest" was null or undefined when calling updateScreenerBedUnitRank().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/screener-bed-units/{bed_unit_id}/rank`;
        urlPath = urlPath.replace('{bed_unit_id}', encodeURIComponent(String(requestParameters['bedUnitId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateScreenerBedUnitRankRequestToJSON(requestParameters['updateScreenerBedUnitRankRequest']),
        };
    }

    /**
     * Update the rank of a screener bed unit
     * Update screener bed unit rank
     */
    async updateScreenerBedUnitRankRaw(requestParameters: UpdateScreenerBedUnitRankOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerBedUnits200Response>> {
        const requestOptions = await this.updateScreenerBedUnitRankRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerBedUnits200ResponseFromJSON(jsonValue));
    }

    /**
     * Update the rank of a screener bed unit
     * Update screener bed unit rank
     */
    async updateScreenerBedUnitRank(requestParameters: UpdateScreenerBedUnitRankOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerBedUnits200Response> {
        const response = await this.updateScreenerBedUnitRankRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateScreenerLeadAdmissionFlag without sending the request
     */
    async updateScreenerLeadAdmissionFlagRequestOpts(requestParameters: UpdateScreenerLeadAdmissionFlagOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateScreenerLeadAdmissionFlag().'
            );
        }

        if (requestParameters['updateScreenerLeadAdmissionFlagRequest'] == null) {
            throw new runtime.RequiredError(
                'updateScreenerLeadAdmissionFlagRequest',
                'Required parameter "updateScreenerLeadAdmissionFlagRequest" was null or undefined when calling updateScreenerLeadAdmissionFlag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/screener-lead-admission-flags/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateScreenerLeadAdmissionFlagRequestToJSON(requestParameters['updateScreenerLeadAdmissionFlagRequest']),
        };
    }

    /**
     * Update a screener lead admission flag
     */
    async updateScreenerLeadAdmissionFlagRaw(requestParameters: UpdateScreenerLeadAdmissionFlagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateScreenerLeadAdmissionFlag200Response>> {
        const requestOptions = await this.updateScreenerLeadAdmissionFlagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateScreenerLeadAdmissionFlag200ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener lead admission flag
     */
    async updateScreenerLeadAdmissionFlag(requestParameters: UpdateScreenerLeadAdmissionFlagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateScreenerLeadAdmissionFlag200Response> {
        const response = await this.updateScreenerLeadAdmissionFlagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateScreenerSetting without sending the request
     */
    async updateScreenerSettingRequestOpts(requestParameters: UpdateScreenerSettingOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['settingName'] == null) {
            throw new runtime.RequiredError(
                'settingName',
                'Required parameter "settingName" was null or undefined when calling updateScreenerSetting().'
            );
        }

        if (requestParameters['updateScreenerSettingRequest'] == null) {
            throw new runtime.RequiredError(
                'updateScreenerSettingRequest',
                'Required parameter "updateScreenerSettingRequest" was null or undefined when calling updateScreenerSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/screener-settings/{setting_name}`;
        urlPath = urlPath.replace('{setting_name}', encodeURIComponent(String(requestParameters['settingName'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateScreenerSettingRequestToJSON(requestParameters['updateScreenerSettingRequest']),
        };
    }

    /**
     * Update a screener setting for an organization
     * Update a screener setting
     */
    async updateScreenerSettingRaw(requestParameters: UpdateScreenerSettingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateScreenerSettingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a screener setting for an organization
     * Update a screener setting
     */
    async updateScreenerSetting(requestParameters: UpdateScreenerSettingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateScreenerSettingRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const CheckEligibilityActionEnum = {
    UpdateMoveInDate: 'update-move-in-date',
    UpdateHospitalizedDate: 'update-hospitalized-date',
    UpdateLoaDate: 'update-loa-date',
    RevertMovedOut: 'revert-moved-out',
    RevertBedSwap: 'revert-bed-swap',
    RevertBedChange: 'revert-bed-change',
    RevertLoa: 'revert-loa',
} as const;
export type CheckEligibilityActionEnum = typeof CheckEligibilityActionEnum[keyof typeof CheckEligibilityActionEnum];
/**
 * @export
 */
export const FindAllCriteriaTargetsCriteriaTypeEnum = {
    Rule: 'rule',
    MedRule: 'med_rule',
    DataPull: 'data_pull',
} as const;
export type FindAllCriteriaTargetsCriteriaTypeEnum = typeof FindAllCriteriaTargetsCriteriaTypeEnum[keyof typeof FindAllCriteriaTargetsCriteriaTypeEnum];
/**
 * @export
 */
export const FindAllFaxesFacilityTypeEnum = {
    SkilledNursing: 'SKILLED_NURSING',
    CriticalCare: 'CRITICAL_CARE',
    HomeHealth: 'HOME_HEALTH',
    AssistedLiving: 'ASSISTED_LIVING',
    LongTermCareHospital: 'LONG_TERM_CARE_HOSPITAL',
    Hospice: 'HOSPICE',
    DialysisCenter: 'DIALYSIS_CENTER',
    Hospital: 'HOSPITAL',
} as const;
export type FindAllFaxesFacilityTypeEnum = typeof FindAllFaxesFacilityTypeEnum[keyof typeof FindAllFaxesFacilityTypeEnum];
/**
 * @export
 */
export const FindAllIntegrationEventsByFacilityIdFilterEnum = {
    All: 'all',
    Active: 'active',
    Applied: 'applied',
    Notifications: 'notifications',
    Review: 'review',
    Dismissed: 'dismissed',
} as const;
export type FindAllIntegrationEventsByFacilityIdFilterEnum = typeof FindAllIntegrationEventsByFacilityIdFilterEnum[keyof typeof FindAllIntegrationEventsByFacilityIdFilterEnum];
/**
 * @export
 */
export const FindAllReferralCareAttributesCategoryEnum = {
    ClinicalCareNeed: 'clinical_care_need',
    Program: 'program',
    TypeOfCare: 'type_of_care',
    Discipline: 'discipline',
} as const;
export type FindAllReferralCareAttributesCategoryEnum = typeof FindAllReferralCareAttributesCategoryEnum[keyof typeof FindAllReferralCareAttributesCategoryEnum];
/**
 * @export
 */
export const GetAllowedRecipientsReferralTypeEnum = {
    Dialysis: 'dialysis',
    HomeHealth: 'home_health',
    Hospice: 'hospice',
    Snf: 'snf',
    Ltac: 'ltac',
    Dme: 'dme',
    Other: 'other',
} as const;
export type GetAllowedRecipientsReferralTypeEnum = typeof GetAllowedRecipientsReferralTypeEnum[keyof typeof GetAllowedRecipientsReferralTypeEnum];
/**
 * @export
 */
export const GetUnreadFaxCountFacilityTypeEnum = {
    SkilledNursing: 'SKILLED_NURSING',
    CriticalCare: 'CRITICAL_CARE',
    HomeHealth: 'HOME_HEALTH',
    AssistedLiving: 'ASSISTED_LIVING',
    LongTermCareHospital: 'LONG_TERM_CARE_HOSPITAL',
    Hospice: 'HOSPICE',
    DialysisCenter: 'DIALYSIS_CENTER',
    Hospital: 'HOSPITAL',
} as const;
export type GetUnreadFaxCountFacilityTypeEnum = typeof GetUnreadFaxCountFacilityTypeEnum[keyof typeof GetUnreadFaxCountFacilityTypeEnum];
/**
 * @export
 */
export const ProcessIntegrationEventActionEnum = {
    Dismiss: 'dismiss',
    Apply: 'apply',
    MarkAsApplied: 'mark_as_applied',
} as const;
export type ProcessIntegrationEventActionEnum = typeof ProcessIntegrationEventActionEnum[keyof typeof ProcessIntegrationEventActionEnum];
/**
 * @export
 */
export const ProcessIntegrationEventConfirmationEnum = {
    HospitalizedReadmit: 'hospitalized_readmit',
} as const;
export type ProcessIntegrationEventConfirmationEnum = typeof ProcessIntegrationEventConfirmationEnum[keyof typeof ProcessIntegrationEventConfirmationEnum];
